var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9e83"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9e83"] = parcelRequire;
}
parcelRequire.register("lnboJ", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});


var $ilwiq = parcelRequire("ilwiq");
var $b9918e92641a49b0$exports = {};
// gif.js 0.2.0 - https://github.com/jnordberg/gif.js
(function(f) {
    var g;
    $b9918e92641a49b0$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(require1, module1, exports) {
                function EventEmitter() {
                    this._events = this._events || {};
                    this._maxListeners = this._maxListeners || undefined;
                }
                module1.exports = EventEmitter;
                EventEmitter.EventEmitter = EventEmitter;
                EventEmitter.prototype._events = undefined;
                EventEmitter.prototype._maxListeners = undefined;
                EventEmitter.defaultMaxListeners = 10;
                EventEmitter.prototype.setMaxListeners = function(n) {
                    if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
                    this._maxListeners = n;
                    return this;
                };
                EventEmitter.prototype.emit = function(type) {
                    var er, handler, len, args, i, listeners;
                    if (!this._events) this._events = {};
                    if (type === "error") {
                        if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
                            er = arguments[1];
                            if (er instanceof Error) throw er;
                            else {
                                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                                err.context = er;
                                throw err;
                            }
                        }
                    }
                    handler = this._events[type];
                    if (isUndefined(handler)) return false;
                    if (isFunction(handler)) switch(arguments.length){
                        case 1:
                            handler.call(this);
                            break;
                        case 2:
                            handler.call(this, arguments[1]);
                            break;
                        case 3:
                            handler.call(this, arguments[1], arguments[2]);
                            break;
                        default:
                            args = Array.prototype.slice.call(arguments, 1);
                            handler.apply(this, args);
                    }
                    else if (isObject(handler)) {
                        args = Array.prototype.slice.call(arguments, 1);
                        listeners = handler.slice();
                        len = listeners.length;
                        for(i = 0; i < len; i++)listeners[i].apply(this, args);
                    }
                    return true;
                };
                EventEmitter.prototype.addListener = function(type, listener) {
                    var m;
                    if (!isFunction(listener)) throw TypeError("listener must be a function");
                    if (!this._events) this._events = {};
                    if (this._events.newListener) this.emit("newListener", type, isFunction(listener.listener) ? listener.listener : listener);
                    if (!this._events[type]) this._events[type] = listener;
                    else if (isObject(this._events[type])) this._events[type].push(listener);
                    else this._events[type] = [
                        this._events[type],
                        listener
                    ];
                    if (isObject(this._events[type]) && !this._events[type].warned) {
                        if (!isUndefined(this._maxListeners)) m = this._maxListeners;
                        else m = EventEmitter.defaultMaxListeners;
                        if (m && m > 0 && this._events[type].length > m) {
                            this._events[type].warned = true;
                            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
                            if (typeof console.trace === "function") console.trace();
                        }
                    }
                    return this;
                };
                EventEmitter.prototype.on = EventEmitter.prototype.addListener;
                EventEmitter.prototype.once = function(type, listener) {
                    if (!isFunction(listener)) throw TypeError("listener must be a function");
                    var fired = false;
                    function g() {
                        this.removeListener(type, g);
                        if (!fired) {
                            fired = true;
                            listener.apply(this, arguments);
                        }
                    }
                    g.listener = listener;
                    this.on(type, g);
                    return this;
                };
                EventEmitter.prototype.removeListener = function(type, listener) {
                    var list, position, length, i;
                    if (!isFunction(listener)) throw TypeError("listener must be a function");
                    if (!this._events || !this._events[type]) return this;
                    list = this._events[type];
                    length = list.length;
                    position = -1;
                    if (list === listener || isFunction(list.listener) && list.listener === listener) {
                        delete this._events[type];
                        if (this._events.removeListener) this.emit("removeListener", type, listener);
                    } else if (isObject(list)) {
                        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
                            position = i;
                            break;
                        }
                        if (position < 0) return this;
                        if (list.length === 1) {
                            list.length = 0;
                            delete this._events[type];
                        } else list.splice(position, 1);
                        if (this._events.removeListener) this.emit("removeListener", type, listener);
                    }
                    return this;
                };
                EventEmitter.prototype.removeAllListeners = function(type) {
                    var key, listeners;
                    if (!this._events) return this;
                    if (!this._events.removeListener) {
                        if (arguments.length === 0) this._events = {};
                        else if (this._events[type]) delete this._events[type];
                        return this;
                    }
                    if (arguments.length === 0) {
                        for(key in this._events){
                            if (key === "removeListener") continue;
                            this.removeAllListeners(key);
                        }
                        this.removeAllListeners("removeListener");
                        this._events = {};
                        return this;
                    }
                    listeners = this._events[type];
                    if (isFunction(listeners)) this.removeListener(type, listeners);
                    else if (listeners) while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
                    delete this._events[type];
                    return this;
                };
                EventEmitter.prototype.listeners = function(type) {
                    var ret;
                    if (!this._events || !this._events[type]) ret = [];
                    else if (isFunction(this._events[type])) ret = [
                        this._events[type]
                    ];
                    else ret = this._events[type].slice();
                    return ret;
                };
                EventEmitter.prototype.listenerCount = function(type) {
                    if (this._events) {
                        var evlistener = this._events[type];
                        if (isFunction(evlistener)) return 1;
                        else if (evlistener) return evlistener.length;
                    }
                    return 0;
                };
                EventEmitter.listenerCount = function(emitter, type) {
                    return emitter.listenerCount(type);
                };
                function isFunction(arg) {
                    return typeof arg === "function";
                }
                function isNumber(arg) {
                    return typeof arg === "number";
                }
                function isObject(arg) {
                    return typeof arg === "object" && arg !== null;
                }
                function isUndefined(arg) {
                    return arg === void 0;
                }
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                var UA, browser, mode, platform, ua;
                ua = navigator.userAgent.toLowerCase();
                platform = navigator.platform.toLowerCase();
                UA = ua.match(/(opera|ie|firefox|chrome|version)[\s\/:]([\w\d\.]+)?.*?(safari|version[\s\/:]([\w\d\.]+)|$)/) || [
                    null,
                    "unknown",
                    0
                ];
                mode = UA[1] === "ie" && document.documentMode;
                browser = {
                    name: UA[1] === "version" ? UA[3] : UA[1],
                    version: mode || parseFloat(UA[1] === "opera" && UA[4] ? UA[4] : UA[2]),
                    platform: {
                        name: ua.match(/ip(?:ad|od|hone)/) ? "ios" : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || [
                            "other"
                        ])[0]
                    }
                };
                browser[browser.name] = true;
                browser[browser.name + parseInt(browser.version, 10)] = true;
                browser.platform[browser.platform.name] = true;
                module1.exports = browser;
            },
            {}
        ],
        3: [
            function(require1, module1, exports) {
                var EventEmitter, GIF, browser, extend = function(child, parent) {
                    for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
                    function ctor() {
                        this.constructor = child;
                    }
                    ctor.prototype = parent.prototype;
                    child.prototype = new ctor;
                    child.__super__ = parent.prototype;
                    return child;
                }, hasProp = {}.hasOwnProperty, indexOf = [].indexOf || function(item) {
                    for(var i = 0, l = this.length; i < l; i++){
                        if (i in this && this[i] === item) return i;
                    }
                    return -1;
                }, slice = [].slice;
                EventEmitter = require1("events").EventEmitter;
                browser = require1("./browser.coffee");
                GIF = function(superClass) {
                    var defaults, frameDefaults;
                    extend(GIF, superClass);
                    defaults = {
                        workerScript: "gif.worker.js",
                        workers: 2,
                        repeat: 0,
                        background: "#fff",
                        quality: 10,
                        width: null,
                        height: null,
                        transparent: null,
                        debug: false,
                        dither: false
                    };
                    frameDefaults = {
                        delay: 500,
                        copy: false
                    };
                    function GIF(options) {
                        var base, key, value;
                        this.running = false;
                        this.options = {};
                        this.frames = [];
                        this.freeWorkers = [];
                        this.activeWorkers = [];
                        this.setOptions(options);
                        for(key in defaults){
                            value = defaults[key];
                            if ((base = this.options)[key] == null) base[key] = value;
                        }
                    }
                    GIF.prototype.setOption = function(key, value) {
                        this.options[key] = value;
                        if (this._canvas != null && (key === "width" || key === "height")) return this._canvas[key] = value;
                    };
                    GIF.prototype.setOptions = function(options) {
                        var key, results, value;
                        results = [];
                        for(key in options){
                            if (!hasProp.call(options, key)) continue;
                            value = options[key];
                            results.push(this.setOption(key, value));
                        }
                        return results;
                    };
                    GIF.prototype.addFrame = function(image, options) {
                        var frame, key;
                        if (options == null) options = {};
                        frame = {};
                        frame.transparent = this.options.transparent;
                        for(key in frameDefaults)frame[key] = options[key] || frameDefaults[key];
                        if (this.options.width == null) this.setOption("width", image.width);
                        if (this.options.height == null) this.setOption("height", image.height);
                        if (typeof ImageData !== "undefined" && ImageData !== null && image instanceof ImageData) frame.data = image.data;
                        else if (typeof CanvasRenderingContext2D !== "undefined" && CanvasRenderingContext2D !== null && image instanceof CanvasRenderingContext2D || typeof WebGLRenderingContext !== "undefined" && WebGLRenderingContext !== null && image instanceof WebGLRenderingContext) {
                            if (options.copy) frame.data = this.getContextData(image);
                            else frame.context = image;
                        } else if (image.childNodes != null) {
                            if (options.copy) frame.data = this.getImageData(image);
                            else frame.image = image;
                        } else throw new Error("Invalid image");
                        return this.frames.push(frame);
                    };
                    GIF.prototype.render = function() {
                        var i, j, numWorkers, ref;
                        if (this.running) throw new Error("Already running");
                        if (this.options.width == null || this.options.height == null) throw new Error("Width and height must be set prior to rendering");
                        this.running = true;
                        this.nextFrame = 0;
                        this.finishedFrames = 0;
                        this.imageParts = (function() {
                            var j, ref, results;
                            results = [];
                            for(i = j = 0, ref = this.frames.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j)results.push(null);
                            return results;
                        }).call(this);
                        numWorkers = this.spawnWorkers();
                        if (this.options.globalPalette === true) this.renderNextFrame();
                        else for(i = j = 0, ref = numWorkers; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j)this.renderNextFrame();
                        this.emit("start");
                        return this.emit("progress", 0);
                    };
                    GIF.prototype.abort = function() {
                        var worker;
                        while(true){
                            worker = this.activeWorkers.shift();
                            if (worker == null) break;
                            this.log("killing active worker");
                            worker.terminate();
                        }
                        this.running = false;
                        return this.emit("abort");
                    };
                    GIF.prototype.spawnWorkers = function() {
                        var j, numWorkers, ref, results;
                        numWorkers = Math.min(this.options.workers, this.frames.length);
                        (function() {
                            results = [];
                            for(var j = ref = this.freeWorkers.length; ref <= numWorkers ? j < numWorkers : j > numWorkers; ref <= numWorkers ? j++ : j--)results.push(j);
                            return results;
                        }).apply(this).forEach(function(_this) {
                            return function(i) {
                                var worker;
                                _this.log("spawning worker " + i);
                                worker = new Worker(_this.options.workerScript);
                                worker.onmessage = function(event) {
                                    _this.activeWorkers.splice(_this.activeWorkers.indexOf(worker), 1);
                                    _this.freeWorkers.push(worker);
                                    return _this.frameFinished(event.data);
                                };
                                return _this.freeWorkers.push(worker);
                            };
                        }(this));
                        return numWorkers;
                    };
                    GIF.prototype.frameFinished = function(frame) {
                        var i, j, ref;
                        this.log("frame " + frame.index + " finished - " + this.activeWorkers.length + " active");
                        this.finishedFrames++;
                        this.emit("progress", this.finishedFrames / this.frames.length);
                        this.imageParts[frame.index] = frame;
                        if (this.options.globalPalette === true) {
                            this.options.globalPalette = frame.globalPalette;
                            this.log("global palette analyzed");
                            if (this.frames.length > 2) for(i = j = 1, ref = this.freeWorkers.length; 1 <= ref ? j < ref : j > ref; i = 1 <= ref ? ++j : --j)this.renderNextFrame();
                        }
                        if (indexOf.call(this.imageParts, null) >= 0) return this.renderNextFrame();
                        else return this.finishRendering();
                    };
                    GIF.prototype.finishRendering = function() {
                        var data, frame, i, image, j, k, l, len, len1, len2, len3, offset, page, ref, ref1, ref2;
                        len = 0;
                        ref = this.imageParts;
                        for(j = 0, len1 = ref.length; j < len1; j++){
                            frame = ref[j];
                            len += (frame.data.length - 1) * frame.pageSize + frame.cursor;
                        }
                        len += frame.pageSize - frame.cursor;
                        this.log("rendering finished - filesize " + Math.round(len / 1e3) + "kb");
                        data = new Uint8Array(len);
                        offset = 0;
                        ref1 = this.imageParts;
                        for(k = 0, len2 = ref1.length; k < len2; k++){
                            frame = ref1[k];
                            ref2 = frame.data;
                            for(i = l = 0, len3 = ref2.length; l < len3; i = ++l){
                                page = ref2[i];
                                data.set(page, offset);
                                if (i === frame.data.length - 1) offset += frame.cursor;
                                else offset += frame.pageSize;
                            }
                        }
                        image = new Blob([
                            data
                        ], {
                            type: "image/gif"
                        });
                        return this.emit("finished", image, data);
                    };
                    GIF.prototype.renderNextFrame = function() {
                        var frame, task, worker;
                        if (this.freeWorkers.length === 0) throw new Error("No free workers");
                        if (this.nextFrame >= this.frames.length) return;
                        frame = this.frames[this.nextFrame++];
                        worker = this.freeWorkers.shift();
                        task = this.getTask(frame);
                        this.log("starting frame " + (task.index + 1) + " of " + this.frames.length);
                        this.activeWorkers.push(worker);
                        return worker.postMessage(task);
                    };
                    GIF.prototype.getContextData = function(ctx) {
                        return ctx.getImageData(0, 0, this.options.width, this.options.height).data;
                    };
                    GIF.prototype.getImageData = function(image) {
                        var ctx;
                        if (this._canvas == null) {
                            this._canvas = document.createElement("canvas");
                            this._canvas.width = this.options.width;
                            this._canvas.height = this.options.height;
                        }
                        ctx = this._canvas.getContext("2d");
                        ctx.setFill = this.options.background;
                        ctx.fillRect(0, 0, this.options.width, this.options.height);
                        ctx.drawImage(image, 0, 0);
                        return this.getContextData(ctx);
                    };
                    GIF.prototype.getTask = function(frame) {
                        var index, task;
                        index = this.frames.indexOf(frame);
                        task = {
                            index: index,
                            last: index === this.frames.length - 1,
                            delay: frame.delay,
                            transparent: frame.transparent,
                            width: this.options.width,
                            height: this.options.height,
                            quality: this.options.quality,
                            dither: this.options.dither,
                            globalPalette: this.options.globalPalette,
                            repeat: this.options.repeat,
                            canTransfer: browser.name === "chrome"
                        };
                        if (frame.data != null) task.data = frame.data;
                        else if (frame.context != null) task.data = this.getContextData(frame.context);
                        else if (frame.image != null) task.data = this.getImageData(frame.image);
                        else throw new Error("Invalid frame");
                        return task;
                    };
                    GIF.prototype.log = function() {
                        var args;
                        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                        if (!this.options.debug) return;
                        return console.log.apply(console, args);
                    };
                    return GIF;
                }(EventEmitter);
                module1.exports = GIF;
            },
            {
                "./browser.coffee": 2,
                events: 1
            }
        ]
    }, {}, [
        3
    ])(3);
});


var $5d4e089399650db3$exports = {};

$5d4e089399650db3$exports = new URL("../" + (parcelRequire("27Lyk")).resolve("aSeFL"), import.meta.url).toString();


/* 
Tool Cool Range Slider v4.0.28
https://github.com/mzusin/toolcool-range-slider
MIT License        
Copyright (c) 2022-present, Miriam Zusin          
*/ (()=>{
    var jn = Object.defineProperty;
    var Et = Math.pow, qn = (r, i, t)=>i in r ? jn(r, i, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }) : r[i] = t;
    var ae = (r, i, t)=>(qn(r, typeof i != "symbol" ? i + "" : i, t), t);
    var St = (r, i)=>` ${i && i.length > 0 ? i.map((t)=>`<link rel="stylesheet" href="${t}" />`).join("") : ""} <style> ${r} </style> <div class="range-slider-box"> <div class="row"> <div id="range-slider" class="range-slider"> <div class="container"> <div class="panel"></div> <div class="panel-fill"></div> <div class="container"> <div class="pointer" tabindex="0" role="slider"> <div class="pointer-shape"></div> </div> </div> </div> </div> </div> </div>`;
    var Tt = ":host{--width:300px;--height:.25rem;--opacity:.4;--panel-bg:#cbd5e1;--panel-bg-hover:#94a3b8;--panel-bg-fill:#475569;--panel-bg-border-radius:1rem;--pointer-width:1rem;--pointer-height:1rem;--pointer-bg:#fff;--pointer-bg-hover:#dcdcdc;--pointer-bg-focus:#dcdcdc;--pointer-shadow:0 0 2px rgba(0,0,0,0.8);--pointer-shadow-hover:0 0 2px #000;--pointer-shadow-focus:var(--pointer-shadow-hover);--pointer-border:1px solid hsla(0,0%,88%,0.5);--pointer-border-hover:1px solid #94a3b8;--pointer-border-focus:var(--pointer-border-hover);--pointer-border-radius:100%;--animate-onclick:.3s}:host{max-width:100%}.range-slider-box{display:flex;position:relative;flex-direction:column}.range-slider{position:relative;width:var(--width,100%);height:var(--height,0.25rem);touch-action:none;max-width:100%;box-sizing:border-box;cursor:pointer}.row{width:100%;display:flex;align-items:center}.range-slider.disabled{opacity:var(--opacity,0.4);cursor:default}.pointer.disabled{-webkit-filter:brightness(0.8);filter:brightness(0.8);cursor:default}.range-slider *{box-sizing:border-box}.container{position:absolute;width:100%;height:100%}.panel{position:absolute;z-index:10;width:100%;height:100%;background:var(--panel-bg,#2d4373);border-radius:var(--panel-bg-border-radius,1rem);overflow:hidden;transition:.3s all ease}.panel-fill{background:var(--panel-bg-fill,#000);border-radius:var(--panel-bg-border-radius,1rem);overflow:hidden;height:100%;position:absolute;z-index:10}.panel:hover{background:var(--panel-bg-hover,#5f79b7)}.disabled .panel:hover{background:var(--panel-bg,#5f79b7)}.pointer{position:absolute;z-index:20;outline:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.pointer-shape{background:var(--pointer-bg,#fff);background-size:contain;box-shadow:var(--pointer-shadow);border:var(--pointer-border);border-radius:var(--pointer-border-radius,100%);-webkit-transform:translateX(-50%);transform:translateX(-50%);width:var(--pointer-width,15px);height:var(--pointer-height,15px);transition:.3s all ease}.pointer-shape:hover{background:var(--pointer-bg-hover,#fff);background-size:contain;border:var(--pointer-border-hover);box-shadow:var(--pointer-shadow-hover)}.disabled .pointer-shape:hover{background:var(--pointer-bg,#fff);background-size:contain;border:var(--pointer-border);box-shadow:var(--pointer-shadow)}.pointer:focus .pointer-shape{background:var(--pointer-bg-focus,#fff);background-size:contain;border:var(--pointer-border-focus);box-shadow:var(--pointer-shadow-focus)}.disabled .pointer:focus .pointer-shape{background:var(--pointer-bg,#fff);background-size:contain;border:var(--pointer-border);box-shadow:var(--pointer-shadow)}.type-vertical .range-slider{--width:.25rem;--height:300px;max-height:100%}.type-vertical .range-slider .pointer{left:50%}.type-vertical .range-slider .panel-fill{width:100%}.type-vertical.range-slider-box{flex-direction:row}.type-vertical .row{flex-direction:column}.animate-on-click .pointer,.animate-on-click .panel-fill{transition:all var(--animate-onclick)}.range-dragging .panel-fill{cursor:move}";
    var le = "pointers-overlap", ue = "pointers-min-distance", de = "pointers-max-distance", ce = "range-dragging", pe = "data", be = "min", ge = "max", fe = "step", me = "round", he = "type", ve = "theme", ye = "rtl", xe = "btt", Pe = "disabled", Ee = "keyboard-disabled", Se = "mousewheel-disabled", At = "slider-width", Mt = "slider-height", wt = "slider-radius", Dt = "slider-bg", Lt = "slider-bg-hover", Ct = "slider-bg-fill", kt = "pointer-width", Ht = "pointer-height", It = "pointer-radius", Rt = "pointer-bg", Ot = "pointer-bg-hover", Bt = "pointer-bg-focus", Ft = "pointer-shadow", Nt = "pointer-shadow-hover", Vt = "pointer-shadow-focus", Ut = "pointer-border", zt = "pointer-border-hover", Wt = "pointer-border-focus", Te = "animate-onclick", Kt = "css-links";
    var I = "vertical", V = "horizontal";
    var we = (r, i, t, n, s)=>{
        let d = i - r;
        return d === 0 ? t : (n - t) * (s - r) / d + t;
    }, B = (r)=>!isNaN(parseFloat(r)) && isFinite(r), E = (r, i)=>B(r) ? Number(r) : i, Qe = (r, i)=>i === 0 ? 0 : Math.round(r / i) * i, jt = (r, i = 1 / 0)=>{
        if (i === 1 / 0) return r;
        let t = Et(10, i);
        return Math.round(r * t) / t;
    }, D = (r)=>r == null ? !1 : typeof r == "boolean" ? r : r.trim().toLowerCase() === "true";
    var qt = (r, i)=>{
        r.dispatchEvent(new CustomEvent("onPointerClicked", {
            detail: {
                $pointer: i
            }
        }));
    }, Xt = (r, i)=>{
        r.dispatchEvent(new CustomEvent("onMouseDown", {
            detail: {
                nativeEvent: i
            }
        }));
    }, Gt = (r, i)=>{
        r.dispatchEvent(new CustomEvent("onMouseUp", {
            detail: {
                nativeEvent: i
            }
        }));
    }, Yt = (r, i)=>{
        r.dispatchEvent(new CustomEvent("onKeyDown", {
            detail: {
                nativeEvent: i
            }
        }));
    }, Zt = (r, i)=>{
        if (!i || i.length <= 0) return;
        let t = i.map((s)=>B(s) ? E(s, s) : s), n = {
            values: t || []
        };
        n.value = t[0], n.value0 = t[0], n.value1 = t[0];
        for(let s = 1; s < t.length; s++)n[`value${s + 1}`] = t[s];
        r.dispatchEvent(new CustomEvent("change", {
            detail: n
        }));
    };
    var Y = (r, i, t)=>{
        let n = 0, s, d, m, l, a = !1, f = (g1, S, L, P, A, k)=>{
            let F = n;
            L !== void 0 && g1 > L && (g1 = L), S !== void 0 && g1 < S && (g1 = S), n = g1;
            let R = n;
            return (P === I && k || P === V && A) && (R = 100 - R), P === I ? i.style.top = `${R}%` : i.style.left = `${R}%`, F !== n;
        }, x = (g1)=>g1 === i || i.contains(g1), p = (g1, S, L, P)=>{
            s = g1, d = S, m = L, l = P;
        }, b = (g1)=>{
            a = g1, i.classList.toggle("disabled", a), a ? i.setAttribute("aria-disabled", "true") : i.hasAttribute("aria-disabled") && i.removeAttribute("aria-disabled");
        }, T = (g1, S)=>{
            S == null ? i.removeAttribute(g1) : i.setAttribute(g1, S);
        }, C = (g1)=>i.getAttribute(g1), c1 = (g1)=>{
            if (!a) {
                switch(g1.key){
                    case "ArrowLeft":
                        g1.preventDefault(), typeof s == "function" && s(t);
                        break;
                    case "ArrowRight":
                        g1.preventDefault(), typeof d == "function" && d(t);
                        break;
                    case "ArrowUp":
                        g1.preventDefault(), typeof m == "function" && m(t);
                        break;
                    case "ArrowDown":
                        g1.preventDefault(), typeof l == "function" && l(t);
                        break;
                }
                Yt(r, g1);
            }
        }, h = ()=>{
            a || qt(r, i);
        };
        return i.className = `pointer pointer-${t}`, i.addEventListener("keydown", c1), i.addEventListener("click", h), {
            $pointer: i,
            get percent () {
                return n;
            },
            get disabled () {
                return a;
            },
            set disabled (g){
                b(g);
            },
            updatePosition: f,
            isClicked: x,
            setCallbacks: p,
            setAttr: T,
            getAttr: C,
            destroy: ()=>{
                i.removeEventListener("keydown", c1), i.removeEventListener("click", h), i.remove();
            }
        };
    };
    var Jt = (r)=>{
        if (r == null) return;
        if (Array.isArray(r)) return r;
        if (r.trim() === "") return;
        let t = r.split(","), n = [], s = !0;
        for(let d = 0; d < t.length; d++){
            let m = t[d].trim();
            m !== "" && (n.push(m), B(m) || (s = !1));
        }
        return s ? n.map((d)=>Number(d)) : n;
    }, Qt = (r, i)=>i ? i.findIndex((t)=>t === r || t.toString().trim() === r.toString().trim()) : -1;
    var _t = (r)=>({
            updatePosition: (t, n, s, d)=>{
                if (n.length <= 0) return;
                let m = n.length === 1, l = n[0], a = n[n.length - 1];
                t === I ? (r.style.removeProperty("width"), r.style.removeProperty("right"), r.style.removeProperty("left"), m ? r.style.height = `${l}%` : r.style.height = `${Math.abs(l - a)}%`, d ? (r.style.bottom = "0%", m ? r.style.top = "auto" : r.style.top = `${Math.min(100 - a, 100 - l)}%`) : (r.style.bottom = "auto", m ? r.style.top = "0%" : r.style.top = `${Math.min(l, a)}%`)) : (r.style.removeProperty("height"), r.style.removeProperty("top"), r.style.removeProperty("bottom"), m ? r.style.width = `${l}%` : r.style.width = `${Math.abs(l - a)}%`, s ? (r.style.right = "0%", m ? r.style.left = "auto" : r.style.left = `${Math.min(100 - a, 100 - l)}%`) : (r.style.right = "auto", m ? r.style.left = "0%" : r.style.left = `${Math.min(l, a)}%`));
            }
        });
    var _e = "--animate-onclick", $t = "--width", en = "--height", tn = "--panel-bg-border-radius", nn = "--panel-bg", rn = "--panel-bg-hover", on = "--panel-bg-fill", sn = "--pointer-width", an = "--pointer-height", ln = "--pointer-border-radius", un = "--pointer-bg", dn = "--pointer-bg-hover", cn = "--pointer-bg-focus", pn = "--pointer-shadow", bn = "--pointer-shadow-hover", gn = "--pointer-shadow-focus", fn = "--pointer-border", mn = "--pointer-border-hover", hn = "--pointer-border-focus";
    var q = (r, i, t)=>{
        let n = new Map;
        for (let s of r.attributes){
            let d = s.nodeName.trim().toLowerCase();
            if (!i.test(d)) continue;
            let l = d.replace(/\D/g, "").trim(), a = l === "" || l === "0" || l === "1" ? 0 : E(l, 0) - 1, f = t && typeof t == "function" ? t(s.value) : s.value;
            n.set(a, f);
        }
        return n;
    }, yn = (r)=>{
        if (!r) return null;
        let i = r.getAttribute(Kt);
        if (!i) return null;
        let t = i.split(";"), n = [];
        for (let s of t)s.trim() !== "" && n.push(s.trim());
        return n;
    };
    var $e = [
        [
            $t,
            At,
            "sliderWidth",
            null
        ],
        [
            en,
            Mt,
            "sliderHeight",
            null
        ],
        [
            tn,
            wt,
            "sliderRadius",
            null
        ],
        [
            nn,
            Dt,
            "sliderBg",
            null
        ],
        [
            rn,
            Lt,
            "sliderBgHover",
            null
        ],
        [
            on,
            Ct,
            "sliderBgFill",
            null
        ],
        [
            sn,
            kt,
            "pointer#Width",
            /^pointer([0-9]*)-width$/
        ],
        [
            an,
            Ht,
            "pointer#Height",
            /^pointer([0-9]*)-height$/
        ],
        [
            ln,
            It,
            "pointer#Radius",
            /^pointer([0-9]*)-radius$/
        ],
        [
            un,
            Rt,
            "pointer#Bg",
            /^pointer([0-9]*)-bg$/
        ],
        [
            dn,
            Ot,
            "pointer#BgHover",
            /^pointer([0-9]*)-bg-hover$/
        ],
        [
            cn,
            Bt,
            "pointer#BgFocus",
            /^pointer([0-9]*)-bg-focus$/
        ],
        [
            pn,
            Ft,
            "pointer#Shadow",
            /^pointer([0-9]*)-shadow$/
        ],
        [
            bn,
            Nt,
            "pointer#ShadowHover",
            /^pointer([0-9]*)-shadow-hover$/
        ],
        [
            gn,
            Vt,
            "pointer#ShadowFocus",
            /^pointer([0-9]*)-shadow-focus$/
        ],
        [
            fn,
            Ut,
            "pointer#Border",
            /^pointer([0-9]*)-border$/
        ],
        [
            mn,
            zt,
            "pointer#BorderHover",
            /^pointer([0-9]*)-border-hover$/
        ],
        [
            hn,
            Wt,
            "pointer#BorderFocus",
            /^pointer([0-9]*)-border-focus$/
        ]
    ], xn = (r, i, t)=>{
        let n = null, s = [], d = new Map, m = (c1, h = i)=>{
            let w = [
                ...h.classList
            ];
            for (let g1 of w)g1.startsWith(c1) && i.classList.remove(g1);
        }, l = ()=>{
            m("shape");
            let c1 = i.querySelectorAll(".pointer");
            for (let h of c1)m("shape", h);
        }, a = (c1)=>{
            n = c1, m("theme-"), typeof c1 == "string" && i.classList.add(`theme-${c1}`);
        }, f = ()=>{
            if (l(), !(s.length <= 0)) {
                i.classList.add("shape", `shape-${s[0]}`);
                for(let c1 = 1; c1 < s.length; c1++){
                    let h = s[c1];
                    if (!h) continue;
                    let w = i.querySelector(`.pointer-${c1}`);
                    !w || w.classList.add("shape", `shape-${h}`);
                }
            }
        }, x = (c1, h)=>{
            s[c1] = h, f();
        }, p = ()=>{
            l();
            let c1 = q(r, /^pointer([0-9]*)-shape$/);
            if (!(c1.size <= 0)) {
                for (let h of c1){
                    let w = h[0];
                    s[w] = h[1];
                }
                f();
            }
        }, b = (c1, h)=>`${c1}-${h}`, T = (c1, h, w)=>{
            let g1 = t[w];
            if (!g1) return;
            let S = w === 0 ? i : g1.$pointer;
            if (h == null) {
                d.has(b(c1, w)) && d.delete(b(c1, w)), S.style.removeProperty(c1);
                return;
            }
            d.set(b(c1, w), h), S.style.setProperty(c1, h);
        }, C = (c1, h)=>d.get(b(c1, h));
        return (()=>{
            for (let c1 of $e){
                let [h, w, g1, S] = c1;
                if (S) {
                    let P = q(r, S);
                    for (let A of P){
                        let k = A[0], F = A[1];
                        T(h, F, k);
                    }
                } else {
                    let P = r.getAttribute(w);
                    T(h, P, 0);
                }
                let L = [];
                if (g1.indexOf("#") === -1) L.push([
                    g1,
                    0
                ]);
                else {
                    L.push([
                        g1.replace("#", ""),
                        0
                    ]), L.push([
                        g1.replace("#", "0"),
                        0
                    ]), L.push([
                        g1.replace("#", "1"),
                        0
                    ]);
                    for(let P = 1; P < t.length; P++)L.push([
                        g1.replace("#", (P + 1).toString()),
                        P
                    ]);
                }
                for (let P of L)try {
                    let A = P[0], k = P[1];
                    Object.prototype.hasOwnProperty.call(r, A) || Object.defineProperty(r, A, {
                        get () {
                            return C(h, k);
                        },
                        set: (F)=>{
                            T(h, F, k);
                        }
                    });
                } catch (A) {
                    console.error(A);
                }
            }
            a(r.getAttribute(ve)), p();
        })(), {
            setStyle: T,
            getStyle: C,
            get theme () {
                return n;
            },
            set theme (c){
                a(c);
            },
            get pointerShapes () {
                return s;
            },
            setPointerShape: x
        };
    };
    var K = "animate-on-click", et = "range-dragging";
    var Pn = (r, i, t, n)=>{
        let s = [], d = (p)=>{
            for (let b of s)b.update && typeof b.update == "function" && b.update(p);
        }, m = ()=>{
            for (let p of s)p.destroy && typeof p.destroy == "function" && p.destroy();
        }, l = (p, b)=>{
            for (let T of s)T.onAttrChange && typeof T.onAttrChange == "function" && T.onAttrChange(p, b);
        }, a = (p)=>{
            if (!!p.gettersAndSetters) {
                for (let b of p.gettersAndSetters)if (!(!b.name || !b.attributes)) try {
                    Object.prototype.hasOwnProperty.call(r, b.name) || Object.defineProperty(r, b.name, b.attributes);
                } catch (T) {
                    console.error("defineSettersGetters error:", T);
                }
            }
        }, f = (p)=>{
            var T;
            if (!p.css) return;
            let b = (T = r.shadowRoot) == null ? void 0 : T.querySelector("style");
            !b || (b.innerHTML += p.css);
        };
        return {
            init: ()=>{
                if (!!window.tcRangeSliderPlugins) for (let p of window.tcRangeSliderPlugins){
                    let b = p();
                    s.push(b), b.init && typeof b.init == "function" && (b.init(r, i, t, n), a(b), f(b));
                }
            },
            update: d,
            onAttrChange: l,
            destroy: m
        };
    };
    var Yn = 10, En = 20, Sn = (r, i)=>{
        let t = new Map, n = /^value([0-9]*)$/;
        for (let l of r.attributes){
            let a = l.nodeName.trim().toLowerCase();
            if (!n.test(a)) continue;
            let x = a.replace("value", "").trim(), p = x === "" || x === "0" || x === "1" ? 0 : E(x, 0) - 1, b = B(l.value) ? E(l.value, 0) : l.value;
            t.set(p, b);
        }
        let s = Math.max(...Array.from(t.keys())), d = [];
        d.push([
            Y(r, i, 0),
            t.get(0)
        ]);
        let m = i;
        for(let l = 1; l <= s; l++){
            let a = i.cloneNode(!0);
            m.after(a), m = a, d.push([
                Y(r, a, l),
                t.get(l)
            ]);
        }
        return d;
    }, tt = (r, i, t, n, s, d, m)=>{
        try {
            Object.defineProperty(r, n, {
                configurable: !0,
                get () {
                    if (!i) return;
                    let l = i.pointers[t];
                    if (!l) return;
                    let a = i.getTextValue(l.percent);
                    return B(a) ? E(a, a) : a;
                },
                set: (l)=>{
                    i.pointers[t] ? i == null || i.setValue(l, t) : i == null || i.addPointer(l);
                }
            }), Object.defineProperty(r, s, {
                configurable: !0,
                get () {
                    var l, a;
                    return (a = (l = i == null ? void 0 : i.pointers[t]) == null ? void 0 : l.getAttr("aria-label")) != null ? a : void 0;
                },
                set: (l)=>{
                    !i || i.setAriaLabel(t, l);
                }
            }), Object.defineProperty(r, d, {
                configurable: !0,
                get () {
                    var l, a;
                    return (a = (l = i == null ? void 0 : i.styles) == null ? void 0 : l.pointerShapes[t]) != null ? a : null;
                },
                set: (l)=>{
                    !i || !i.styles || i.styles.setPointerShape(t, l);
                }
            }), Object.defineProperty(r, m, {
                configurable: !0,
                get () {
                    var l;
                    return (l = i == null ? void 0 : i.pointers[t].disabled) != null ? l : !1;
                },
                set: (l)=>{
                    if (!i) return;
                    let a = i == null ? void 0 : i.pointers[t];
                    !a || (a.disabled = l);
                }
            });
        } catch (l) {
            console.error(l);
        }
    }, Tn = (r, i)=>{
        let t = [
            [
                "value",
                "ariaLabel",
                "pointerShape",
                "pointerDisabled",
                0
            ],
            [
                "value0",
                "ariaLabel0",
                "pointerShape0",
                "pointer0Disabled",
                0
            ],
            [
                "value1",
                "ariaLabel1",
                "pointerShape1",
                "pointer1Disabled",
                0
            ]
        ];
        for(let n = 2; n < Yn; n++)t.push([
            `value${n}`,
            `ariaLabel${n}`,
            `pointer${n}Shape`,
            `pointer${n}Disabled`,
            n - 1
        ]);
        for (let n of t)tt(r, i, n[4], n[0], n[1], n[2], n[3]);
    }, nt = (r, i, t)=>{
        var s;
        let n = (s = t.shadowRoot) == null ? void 0 : s.querySelector(".container");
        if (!!n) for (let d of r)i ? n.prepend(d.$pointer) : n.append(d.$pointer);
    }, An = (r, i)=>{
        if (!(!i || r.length <= 1)) {
            for (let t of r)t.$pointer.style.zIndex = En.toString();
            i.$pointer.style.zIndex = (En * 2).toString();
        }
    };
    var rt = 0, Z = 100, U = 2, Mn = "0.3s", wn = (r, i, t)=>{
        let n = t.map((e1)=>e1[0]), s = null, d = null, m = null, l = null, a = rt, f = Z, x, p, b = V, T = U, C = !1, c1 = !1, h = !1, w = 0, g1 = 1 / 0, S = !1, L, P, A = !1, k = !1, F = !1, R = Mn, ot = [], st = (e1)=>{
            A || (e1.preventDefault && e1.preventDefault(), z(e1), window.addEventListener("mousemove", z), window.addEventListener("mouseup", J), Xt(r, e1));
        }, J = (e1)=>{
            A || (L = void 0, P = void 0, window.removeEventListener("mousemove", z), window.removeEventListener("mouseup", J), R && i.classList.add(K), Gt(r, e1));
        }, Ln = (e1, o)=>{
            if (n.length <= 0) return;
            if (n.length === 1) return n[0].isClicked(e1) && R && i.classList.remove(K), n[0];
            let u = kn(e1);
            if (S) {
                let v = o, O = _(v);
                O !== void 0 && (v = Qe(v, O)), u ? (L = v, P = 0, R && i.classList.remove(K)) : L !== void 0 && (P = v - L, L = v);
            }
            if (!Cn(e1) && !u) {
                for (let v of n)if (!(!v.isClicked(e1) || v.disabled)) return R && i.classList.remove(K), v;
                for (let v of n)if (s === v) return v;
            }
            let y = 1 / 0, M = null;
            for (let v of n){
                if (v.disabled) continue;
                let O = Math.abs(o - v.percent);
                O < y && (y = O, M = v);
            }
            return M;
        }, at = ()=>n.findIndex((e1)=>s === e1 && !e1.disabled), z = (e1)=>{
            let o;
            if (b === I) {
                let { height: y , top: M  } = i.getBoundingClientRect(), v = e1.type.indexOf("mouse") !== -1 ? e1.clientY : e1.touches[0].clientY;
                o = Math.min(Math.max(0, v - M), y) * 100 / y;
            } else {
                let { width: y , left: M  } = i.getBoundingClientRect(), v = e1.type.indexOf("mouse") !== -1 ? e1.clientX : e1.touches[0].clientX;
                o = Math.min(Math.max(0, v - M), y) * 100 / y;
            }
            if ((C || c1) && (o = 100 - o), s = Ln(e1.target, o), s && An(n, s), S && n.length > 1 && P !== void 0) {
                let y = n[0], M = n[n.length - 1], v = y.percent + P < 0, O = M.percent + P > 100;
                if (v || O) return;
                for(let se = 0; se < n.length; se++)H(se, n[se].percent + P);
                return;
            }
            let u = at();
            u !== -1 && (H(u, o), s == null || s.$pointer.focus());
        }, Q = (e1)=>{
            if (A || document.activeElement !== r || (s == null ? void 0 : s.disabled)) return;
            e1.stopPropagation(), e1.preventDefault();
            let o = e1.deltaY < 0, u = C || c1, y = o ? !u : u, M = at();
            M !== -1 && (y ? X(M, n[M].percent) : G(M, n[M].percent));
        }, lt = (e1)=>{
            A || k || (b === I ? c1 ? H(e1, 100) : H(e1, 0) : C ? G(e1, n[e1].percent) : X(e1, n[e1].percent));
        }, ut = (e1)=>{
            A || k || (b === I ? c1 ? H(e1, 0) : H(e1, 100) : C ? X(e1, n[e1].percent) : G(e1, n[e1].percent));
        }, dt = (e1)=>{
            A || k || (b === I ? c1 ? G(e1, n[e1].percent) : X(e1, n[e1].percent) : C ? H(e1, 100) : H(e1, 0));
        }, ct = (e1)=>{
            A || k || (b === I ? c1 ? X(e1, n[e1].percent) : G(e1, n[e1].percent) : C ? H(e1, 0) : H(e1, 100));
        }, Cn = (e1)=>e1.classList.contains("panel"), kn = (e1)=>e1.classList.contains("panel-fill"), X = (e1, o)=>{
            if (o === void 0) return;
            let u = _(o);
            u == null && (u = 1), o -= u, o < 0 && (o = 0), H(e1, o);
        }, G = (e1, o)=>{
            if (o === void 0) return;
            let u = _(o);
            u == null && (u = 1), o += u, o > 100 && (o = 100), H(e1, o);
        }, W = ()=>{
            !l || l.update({
                percents: pt(),
                values: bt(),
                $pointers: gt(),
                min: ft(),
                max: mt(),
                data: Ce(),
                step: Le(),
                round: He(),
                type: ke(),
                textMin: $(),
                textMax: ee(),
                rightToLeft: Oe(),
                bottomToTop: Be(),
                pointersOverlap: Ue(),
                pointersMinDistance: Ie(),
                pointersMaxDistance: Re(),
                rangeDragging: ze(),
                disabled: Fe(),
                keyboardDisabled: Ne(),
                mousewheelDisabled: Ve()
            });
        }, Hn = ()=>{
            W();
        }, In = (e1)=>{
            if (!(h || n.length <= 1 || f === a)) {
                if (e1 === 0) {
                    let o = g1 * 100 / (f - a);
                    return Math.max(0, n[e1 + 1].percent - o);
                } else {
                    let o = w * 100 / (f - a);
                    return Math.min(n[e1 - 1].percent + o, 100);
                }
            }
        }, Rn = (e1)=>{
            if (!(h || n.length <= 1 || f === a)) {
                if (e1 === n.length - 1) {
                    let o = g1 * 100 / (f - a);
                    return Math.min(n[e1 - 1].percent + o, 100);
                } else {
                    let o = w * 100 / (f - a);
                    return Math.max(0, n[e1 + 1].percent - o);
                }
            }
        }, _ = (e1)=>{
            let o;
            if (typeof x == "function") {
                let u = we(0, 100, a, f, e1);
                o = x(u, e1);
            } else o = x;
            if (B(o)) {
                let u = f - a;
                return o = u === 0 ? 0 : o * 100 / u, o;
            }
        }, j = (e1)=>{
            if (e1 === void 0) return;
            let o = we(0, 100, a, f, e1);
            return p !== void 0 ? p[Math.round(o)] : jt(o, T);
        }, $ = ()=>p !== void 0 ? p[a] : a, ee = ()=>p !== void 0 ? p[f] : f, Le = ()=>x, On = (e1)=>{
            var o;
            return e1 <= 0 || h ? $() : (o = j(n[e1 - 1].percent)) != null ? o : "";
        }, Bn = (e1)=>{
            var o;
            return n.length <= 1 || e1 >= n.length - 1 || h ? ee() : (o = j(n[e1 + 1].percent)) != null ? o : "";
        }, pt = ()=>n.map((e1)=>e1.percent), bt = ()=>n.map((e1)=>j(e1.percent)), gt = ()=>n.map((e1)=>e1.$pointer), ft = ()=>a, mt = ()=>f, Ce = ()=>p, ke = ()=>b, He = ()=>T, Ie = ()=>w, Re = ()=>g1, Fn = (e1)=>ot[e1], Oe = ()=>C, Be = ()=>c1, Fe = ()=>A, Ne = ()=>k, Ve = ()=>F, Ue = ()=>h, ze = ()=>S, H = (e1, o)=>{
            if (o === void 0) return;
            let u = _(o);
            u !== void 0 && (o = Qe(o, u));
            let y = n[e1];
            if (!y) return;
            let M = y.updatePosition(o, In(e1), Rn(e1), b, C, c1);
            d == null || d.updatePosition(b, n.map((v)=>v.percent), C, c1), W();
            for (let v of n){
                let O = j(v.percent);
                O !== void 0 && (v.setAttr("aria-valuenow", O.toString()), v.setAttr("aria-valuetext", O.toString()));
            }
            Vn(), M && Zt(r, n.map((v)=>j(v.percent)));
        }, N = ()=>{
            for(let e1 = 0; e1 < n.length; e1++)H(e1, n[e1].percent);
        }, Nn = (e1, o)=>{
            a = p !== void 0 ? 0 : E(e1, rt), f = p !== void 0 ? p.length - 1 : E(o, Z), te(a), ne(f);
        }, Vn = ()=>{
            var e1, o;
            for(let u = 0; u < n.length; u++){
                let y = n[u];
                y.setAttr("aria-valuemin", ((e1 = On(u)) != null ? e1 : "").toString()), y.setAttr("aria-valuemax", ((o = Bn(u)) != null ? o : "").toString());
            }
        }, te = (e1)=>{
            a = E(e1, rt), a > f && (f = a + Z), N();
        }, ne = (e1)=>{
            f = E(e1, Z), f < a && (f = a + Z), N();
        }, ht = (e1)=>{
            h = !0;
            for(let o = 0; o < e1.length; o++)re(e1[o], o);
            h = !1;
            for(let o = 0; o < e1.length; o++)re(e1[o], o);
        }, re = (e1, o)=>{
            let u;
            p !== void 0 ? (u = e1 == null ? 0 : Qt(e1, p), u === -1 && (u = 0)) : (u = E(e1, a), u < a && (u = a), u > f && (u = f));
            let y = we(a, f, 0, 100, u);
            H(o, y);
        }, ie = (e1)=>{
            if (e1 == null) {
                x = void 0;
                return;
            }
            if (typeof e1 == "function") {
                x = e1, N();
                return;
            }
            if (B(e1)) {
                x = E(e1, 1);
                let o = Math.abs(f - a);
                x > o && (x = void 0), N();
                return;
            }
            x = void 0;
        }, We = (e1)=>{
            h = e1, N();
        }, Ke = (e1)=>{
            (!B(e1) || e1 < 0) && (e1 = 0), w = e1;
        }, je = (e1)=>{
            (!B(e1) || e1 < 0) && (e1 = 1 / 0), g1 = e1;
        }, qe = (e1)=>{
            A = e1, i.classList.toggle("disabled", A), A ? i.setAttribute("aria-disabled", "true") : i.hasAttribute("aria-disabled") && i.removeAttribute("aria-disabled");
        }, vt = (e1)=>{
            k = e1;
        }, yt = (e1)=>{
            F = e1, F ? document.removeEventListener("wheel", Q) : document.addEventListener("wheel", Q, {
                passive: !1
            });
        }, Xe = (e1)=>{
            if (e1 == null) {
                p = void 0;
                return;
            }
            if (p = Jt(e1), p === void 0 || p.length <= 0) {
                p = void 0;
                return;
            }
            te(0), ne(p.length - 1), x === void 0 && ie(1);
        }, Ge = (e1)=>{
            var y;
            typeof e1 == "string" ? b = e1.trim().toLowerCase() === I ? I : V : b = V;
            let o = (y = r.shadowRoot) == null ? void 0 : y.querySelector(".range-slider-box");
            if (!o) return;
            o.className = `range-slider-box type-${b}`, N();
            let u = b === I ? "vertical" : "horizontal";
            for (let M of n)M.setAttr("aria-orientation", u);
        }, Ye = (e1)=>{
            C = e1, n.length > 1 && nt(n, C, r), N(), W();
        }, Ze = (e1)=>{
            c1 = e1, n.length > 1 && nt(n, c1, r), N(), W();
        }, Je = (e1)=>{
            T = E(e1, U), T < 0 && (T = U), W();
        }, xt = (e1)=>{
            e1 == null || e1.toString().trim().toLowerCase() === "false" ? (R = void 0, i.style.removeProperty(_e), i.classList.remove(K)) : (R = e1.toString(), i.style.setProperty(_e, R), i.classList.add(K));
        }, Pt = (e1, o)=>{
            let u = n[e1];
            !u || (u.setAttr("aria-label", o), ot[e1] = o);
        }, oe = (e1)=>{
            if (L = void 0, n.length <= 1) {
                S = !1, i.classList.remove(et);
                return;
            }
            S = e1, i.classList.toggle(et, S);
        }, Un = ()=>{
            qe(D(r.getAttribute(Pe))), k = D(r.getAttribute(Ee)), F = D(r.getAttribute(Se));
            let e1 = q(r, /^pointer([0-9]*)-disabled$/, (o)=>D(o));
            for (let o of e1){
                let u = o[0];
                !n[u] || (n[u].disabled = o[1]);
            }
        }, zn = ()=>{
            let e1 = q(r, /^aria-label([0-9]*)$/);
            for (let o of e1){
                let u = o[0];
                Pt(u, o[1]);
            }
        }, Wn = (e1)=>{
            let o = n.length, u = n[o - 1].$pointer, y = u.cloneNode(!0);
            u.after(y);
            let M = Y(r, y, o);
            return M.setCallbacks(lt, ut, dt, ct), n.push(M), re(e1, o), N(), W(), o;
        }, Kn = ()=>{
            let e1 = n.length, o = n[e1 - 1];
            return o ? (o.destroy(), n.pop(), n.length <= 1 && oe(!1), N(), W(), e1 - 1) : -1;
        };
        return (()=>{
            var o, u;
            for (let y of n)y.setCallbacks(lt, ut, dt, ct);
            let e1 = (o = r.shadowRoot) == null ? void 0 : o.querySelector(".panel-fill");
            e1 && (d = _t(e1)), Ge(r.getAttribute(he)), Ye(D(r.getAttribute(ye))), Ze(D(r.getAttribute(xe))), Nn(r.getAttribute(be), r.getAttribute(ge)), ie(r.getAttribute(fe)), Xe(r.getAttribute(pe)), ht(t.map((y)=>y[1])), We(D(r.getAttribute(le))), Ke(E(r.getAttribute(ue), 0)), je(E(r.getAttribute(de), 1 / 0)), oe(D(r.getAttribute(ce))), Je(E(r.getAttribute(me), U)), Un(), zn(), m = xn(r, i, n), xt((u = r.getAttribute(Te)) != null ? u : Mn), i.addEventListener("mousedown", st), i.addEventListener("mouseup", J), i.addEventListener("touchmove", z), i.addEventListener("touchstart", z), F || document.addEventListener("wheel", Q, {
                passive: !1
            }), l = Pn(r, Hn, {
                setValues: ht,
                setMin: te,
                setMax: ne,
                setStep: ie,
                setPointersOverlap: We,
                setPointersMinDistance: Ke,
                setPointersMaxDistance: je,
                setDisabled: qe,
                setType: Ge,
                setRightToLeft: Ye,
                setBottomToTop: Ze,
                setRound: Je,
                setKeyboardDisabled: vt,
                setMousewheelDisabled: yt,
                setRangeDragging: oe,
                setData: Xe
            }, {
                getPercents: pt,
                getValues: bt,
                getPointerElements: gt,
                getMin: ft,
                getMax: mt,
                getStep: Le,
                getData: Ce,
                getType: ke,
                getRound: He,
                getTextMin: $,
                getTextMax: ee,
                isRightToLeft: Oe,
                isBottomToTop: Be,
                isDisabled: Fe,
                isKeyboardDisabled: Ne,
                isMousewheelDisabled: Ve,
                isPointersOverlap: Ue,
                isRangeDraggingEnabled: ze,
                getPointersMinDistance: Ie,
                getPointersMaxDistance: Re
            }), l.init();
        })(), {
            get pointers () {
                return n;
            },
            get styles () {
                return m;
            },
            get pluginsManager () {
                return l;
            },
            get min () {
                return $();
            },
            get max () {
                return ee();
            },
            get step () {
                return Le();
            },
            get pointersOverlap () {
                return Ue();
            },
            set pointersOverlap (e){
                We(e);
            },
            get pointersMinDistance () {
                return Ie();
            },
            set pointersMinDistance (e){
                Ke(e);
            },
            get pointersMaxDistance () {
                return Re();
            },
            set pointersMaxDistance (e){
                je(e);
            },
            get disabled () {
                return Fe();
            },
            set disabled (e){
                qe(e);
            },
            get data () {
                return Ce();
            },
            get type () {
                return ke();
            },
            set type (e){
                Ge(e);
            },
            get rightToLeft () {
                return Oe();
            },
            set rightToLeft (e){
                Ye(e);
            },
            get bottomToTop () {
                return Be();
            },
            set bottomToTop (e){
                Ze(e);
            },
            get round () {
                return He();
            },
            set round (e){
                Je(e);
            },
            get animateOnClick () {
                return R;
            },
            set animateOnClick (e){
                xt(e);
            },
            get keyboardDisabled () {
                return Ne();
            },
            set keyboardDisabled (e){
                vt(e);
            },
            get mousewheelDisabled () {
                return Ve();
            },
            set mousewheelDisabled (e){
                yt(e);
            },
            get rangeDragging () {
                return ze();
            },
            set rangeDragging (e){
                oe(e);
            },
            setMin: te,
            setMax: ne,
            setValue: re,
            setStep: ie,
            setData: Xe,
            getTextValue: j,
            setAriaLabel: Pt,
            getAriaLabel: Fn,
            addPointer: Wn,
            removePointer: Kn,
            destroy: ()=>{
                i.removeEventListener("mousedown", st), i.removeEventListener("mouseup", J), i.removeEventListener("touchmove", z), i.removeEventListener("touchstart", z), document.removeEventListener("wheel", Q);
                for (let e1 of n)e1.destroy();
                l == null || l.destroy();
            }
        };
    };
    var Dn = (r, i, t)=>{
        let n = $e.find(([l, a, f, x])=>a.replace("#", "") === i.replace(/\d+/g, ""));
        if (n && r.styles) {
            let [l, a, f, x] = n, p = i.replace(/\D/g, "").trim(), b = p === "" || p === "0" || p === "1" ? 0 : E(p, 0) - 1;
            r.styles.setStyle(l, t, b);
            return;
        }
        switch(r && r.pluginsManager && r.pluginsManager.onAttrChange(i, t), i){
            case be:
                r.setMin(t);
                break;
            case ge:
                r.setMax(t);
                break;
            case fe:
                r.setStep(t);
                break;
            case le:
                r.pointersOverlap = D(t);
                break;
            case ue:
                r.pointersMinDistance = E(t, 0);
                break;
            case ce:
                r.rangeDragging = D(t);
                break;
            case de:
                r.pointersMaxDistance = E(t, 1 / 0);
                break;
            case Pe:
                r.disabled = D(t);
                break;
            case Ee:
                r.keyboardDisabled = D(t);
                break;
            case Se:
                r.mousewheelDisabled = D(t);
                break;
            case pe:
                r.setData(t);
                break;
            case he:
                r.type = t;
                break;
            case ye:
                r.rightToLeft = D(t);
                break;
            case xe:
                r.bottomToTop = D(t);
                break;
            case me:
                r.round = E(t, U);
                break;
            case ve:
                r.styles && (r.styles.theme = t);
                break;
            case Te:
                r.animateOnClick = t;
                break;
        }
        let s = null;
        if (/^value([0-9]*)$/.test(i) && (s = "value"), /^pointer([0-9]*)-disabled$/.test(i) && (s = "pointer-disabled"), /^aria-label([0-9]*)$/.test(i) && (s = "aria-label"), /^pointer([0-9]*)-shape$/.test(i) && (s = "pointer-shape"), !s) return;
        let d = i.replace(/\D/g, "").trim(), m = d === "" || d === "0" || d === "1" ? 0 : E(d, 0) - 1;
        switch(s){
            case "value":
                r.setValue(t, m);
                break;
            case "pointer-disabled":
                {
                    let l = r == null ? void 0 : r.pointers[m];
                    if (!l) return;
                    l.disabled = D(t);
                    break;
                }
            case "aria-label":
                r.setAriaLabel(m, t);
                break;
            case "pointer-shape":
                r.styles && r.styles.setPointerShape(m, t);
                break;
        }
    };
    var it = class extends HTMLElement {
        constructor(){
            super();
            ae(this, "slider");
            ae(this, "_externalCSSList", []);
            ae(this, "_observer", null);
            this.attachShadow({
                mode: "open"
            });
        }
        set step(t) {
            this.slider && this.slider.setStep(t);
        }
        get step() {
            var t;
            return (t = this.slider) == null ? void 0 : t.step;
        }
        set disabled(t) {
            this.slider && (this.slider.disabled = t);
        }
        get disabled() {
            var t, n;
            return (n = (t = this.slider) == null ? void 0 : t.disabled) != null ? n : !1;
        }
        set data(t) {
            var n;
            (n = this.slider) == null || n.setData(t);
        }
        get data() {
            var t;
            return (t = this.slider) == null ? void 0 : t.data;
        }
        set min(t) {
            var n;
            (n = this.slider) == null || n.setMin(t);
        }
        get min() {
            var t;
            return (t = this.slider) == null ? void 0 : t.min;
        }
        set max(t) {
            var n;
            (n = this.slider) == null || n.setMax(t);
        }
        get max() {
            var t;
            return (t = this.slider) == null ? void 0 : t.max;
        }
        set round(t) {
            !this.slider || (this.slider.round = t);
        }
        get round() {
            var t, n;
            return (n = (t = this.slider) == null ? void 0 : t.round) != null ? n : U;
        }
        set type(t) {
            !this.slider || (this.slider.type = t != null ? t : V);
        }
        get type() {
            var t;
            return ((t = this.slider) == null ? void 0 : t.type) || V;
        }
        set pointersOverlap(t) {
            !this.slider || (this.slider.pointersOverlap = t);
        }
        get pointersOverlap() {
            var t, n;
            return (n = (t = this.slider) == null ? void 0 : t.pointersOverlap) != null ? n : !1;
        }
        set pointersMinDistance(t) {
            !this.slider || (this.slider.pointersMinDistance = t);
        }
        get pointersMinDistance() {
            var t, n;
            return (n = (t = this.slider) == null ? void 0 : t.pointersMinDistance) != null ? n : 0;
        }
        set pointersMaxDistance(t) {
            !this.slider || (this.slider.pointersMaxDistance = t);
        }
        get pointersMaxDistance() {
            var t, n;
            return (n = (t = this.slider) == null ? void 0 : t.pointersMaxDistance) != null ? n : 1 / 0;
        }
        set theme(t) {
            !this.slider || !this.slider.styles || (this.slider.styles.theme = t);
        }
        get theme() {
            var t, n, s;
            return (s = (n = (t = this.slider) == null ? void 0 : t.styles) == null ? void 0 : n.theme) != null ? s : null;
        }
        set rtl(t) {
            !this.slider || (this.slider.rightToLeft = t);
        }
        get rtl() {
            var t, n;
            return (n = (t = this.slider) == null ? void 0 : t.rightToLeft) != null ? n : !1;
        }
        set btt(t) {
            !this.slider || (this.slider.bottomToTop = t);
        }
        get btt() {
            var t, n;
            return (n = (t = this.slider) == null ? void 0 : t.bottomToTop) != null ? n : !1;
        }
        set keyboardDisabled(t) {
            !this.slider || (this.slider.keyboardDisabled = t);
        }
        get keyboardDisabled() {
            var t, n;
            return (n = (t = this.slider) == null ? void 0 : t.keyboardDisabled) != null ? n : !1;
        }
        set mousewheelDisabled(t) {
            !this.slider || (this.slider.mousewheelDisabled = t);
        }
        get mousewheelDisabled() {
            var t, n;
            return (n = (t = this.slider) == null ? void 0 : t.mousewheelDisabled) != null ? n : !1;
        }
        set animateOnClick(t) {
            !this.slider || (this.slider.animateOnClick = t);
        }
        get animateOnClick() {
            var t;
            return (t = this.slider) == null ? void 0 : t.animateOnClick;
        }
        get rangeDragging() {
            var t, n;
            return (n = (t = this.slider) == null ? void 0 : t.rangeDragging) != null ? n : !1;
        }
        set rangeDragging(t) {
            this.slider && (this.slider.rangeDragging = D(t));
        }
        get externalCSSList() {
            return this._externalCSSList;
        }
        addPointer(t) {
            var s, d;
            if (!this.slider) return;
            let n = (d = (s = this.slider) == null ? void 0 : s.addPointer(t)) != null ? d : 0;
            tt(this, this.slider, n, `value${n + 1}`, `ariaLabel${n + 1}`, `pointerShape${n + 1}`, `pointer${n + 1}Disabled`);
        }
        removePointer() {
            var t;
            !this.slider || (t = this.slider) == null || t.removePointer();
        }
        addCSS(t) {
            if (!this.shadowRoot) return;
            let n = document.createElement("style");
            n.textContent = t, this.shadowRoot.appendChild(n);
        }
        connectedCallback() {
            var d, m;
            if (!this.shadowRoot) return;
            this._externalCSSList = yn(this), this.shadowRoot.innerHTML = St(Tt, this._externalCSSList);
            let t = (d = this.shadowRoot) == null ? void 0 : d.querySelector(".pointer");
            if (!t) return;
            let n = (m = this.shadowRoot) == null ? void 0 : m.getElementById("range-slider");
            if (!n) return;
            let s = Sn(this, t);
            this.slider = wn(this, n, s), Tn(this, this.slider), this._observer = new MutationObserver((l)=>{
                l.forEach((a)=>{
                    var x;
                    if (!this.slider || a.type !== "attributes") return;
                    let f = a.attributeName;
                    !f || Dn(this.slider, f, (x = this.getAttribute(f)) != null ? x : "");
                });
            }), this._observer.observe(this, {
                attributes: !0
            });
        }
        disconnectedCallback() {
            this._observer && this._observer.disconnect(), this.slider && this.slider.destroy();
        }
    }, De = it;
    window.tcRangeSlider = De;
    customElements.get("toolcool-range-slider") || customElements.define("toolcool-range-slider", De);
    customElements.get("tc-range-slider") || customElements.define("tc-range-slider", class extends De {
    });
})();


/* 
Tool Cool Range Slider - Moving Tooltip Plugin v1.0.6
https://github.com/mzusin/toolcool-range-slider 
MIT License        
Copyright (c) 2022-present, Miriam Zusin                         
*/ (()=>{
    var _ = (o)=>!isNaN(parseFloat(o)) && isFinite(o), a = (o, n)=>_(o) ? Number(o) : n;
    var A = (o)=>o == null ? !1 : typeof o == "boolean" ? o : o.trim().toLowerCase() === "true";
    window.tcRangeSliderPlugins = window.tcRangeSliderPlugins || [];
    var S = 40, U = 35, O = 30, q = "#475569", X = "#fff", j = 20, w = ()=>{
        let o = null, n = null, T = !1, c = S, v = U, h = O, I = q, P = X, b = "", E = "", L, f = [], r = null, y = null, Z = ()=>{
            r == null || r.classList.toggle("is-after", c <= 0);
        }, J = ()=>{
            var e;
            let t = (e = o == null ? void 0 : o.shadowRoot) == null ? void 0 : e.querySelector("#range-slider");
            r = document.createElement("div"), r.classList.add("tooltips"), t.prepend(r), Z();
        }, H = (t)=>{
            let e = document.createElement("div");
            return e.style.zIndex = j.toString(), e.className = t, e;
        }, D = (t, e, u, s, d)=>{
            !t || (e === "vertical" ? (t.style.left = `${-c}px`, t.style.top = s != null ? s : "0") : (t.style.left = u != null ? u : "0", t.style.top = `${-c}px`), t.style.width = `${v}px`, t.style.height = `${h}px`, t.style.background = I, t.style.color = P, t.style.zIndex = d.toString());
        }, z = (t)=>{
            let e = t;
            return typeof L == "function" && (e = L(t)), E === "prefix" ? `${b}${e}` : `${e}${b}`;
        }, p = ()=>{
            var s, d, i, g;
            let t = (s = n == null ? void 0 : n.getValues()) != null ? s : [], e = (d = n == null ? void 0 : n.getPointerElements()) != null ? d : [], u = (i = n == null ? void 0 : n.getType()) != null ? i : "horizontal";
            if (!!t) for(let l = 0; l < t.length; l++){
                let x = f[l];
                if (!x) continue;
                let m = ((g = t[l]) != null ? g : "").toString();
                x.textContent = z(m), D(x, u, e[l].style.left, e[l].style.top, e[l].style.zIndex);
            }
        }, K = ()=>{
            var e;
            let t = (e = n == null ? void 0 : n.getValues()) != null ? e : [];
            if (!!t) {
                for(let u = 0; u < t.length; u++){
                    let s = H(`tooltip tooltip-${u + 1}`);
                    s.style.position = "absolute", f.push(s), r == null || r.prepend(s);
                }
                p();
            }
        }, Q = ()=>{
            !o || (y = new ResizeObserver((t)=>{
                for (let e of t)p();
            }), y.observe(o));
        }, C = (t)=>{
            T = t, T ? (J(), K(), Q()) : N();
        }, M = (t)=>{
            c = t, p();
        }, F = (t)=>{
            v = t, p();
        }, B = (t)=>{
            h = t, p();
        }, R = (t)=>{
            I = t, p();
        }, k = (t)=>{
            P = t, p();
        }, G = (t)=>{
            b = t, p();
        }, W = (t)=>{
            E = t, p();
        }, Y = (t)=>{
            L = t, p();
        }, V = (t)=>{
            var s, d;
            if (!T || !t.values) return;
            let e = (s = n == null ? void 0 : n.getPointerElements()) != null ? s : [], u = (d = n == null ? void 0 : n.getType()) != null ? d : "horizontal";
            for(let i = 0; i < t.values.length; i++){
                let g = t.values[i], l = f[i];
                if (g === void 0 && !!l) {
                    l.remove(), f[i] = void 0;
                    continue;
                }
                if (g !== void 0 && !l) {
                    let m = H(`tooltip tooltip-${i + 1}`), $ = (g != null ? g : "").toString();
                    m.textContent = z($), m.style.position = "absolute", D(m, u, e[i].style.left, e[i].style.top, e[i].style.zIndex), f[i] = m, r == null || r.append(m);
                }
                if (!l) continue;
                let x = (g != null ? g : "").toString();
                l.textContent = z(x), D(l, u, e[i].style.left, e[i].style.top, e[i].style.zIndex);
            }
        }, N = ()=>{
            r == null || r.remove();
            for (let t of f)!t || t.remove();
            f = [], y == null || y.disconnect();
        };
        return {
            get name () {
                return "Moving Tooltip";
            },
            init: (t, e, u, s)=>{
                o = t, n = s, c = a(t.getAttribute("moving-tooltip-distance-to-pointer"), S), v = a(t.getAttribute("moving-tooltip-width"), U), h = a(t.getAttribute("moving-tooltip-height"), O), I = t.getAttribute("moving-tooltip-bg") || q, P = t.getAttribute("moving-tooltip-text-color") || X, b = t.getAttribute("moving-tooltip-units") || "", E = t.getAttribute("moving-tooltip-units-type") || "", C(A(t.getAttribute("moving-tooltip")));
            },
            update: V,
            onAttrChange: (t, e)=>{
                t === "moving-tooltip" && C(A(e)), t === "moving-tooltip-distance-to-pointer" && M(a(e, S)), t === "moving-tooltip-width" && F(a(e, U)), t === "moving-tooltip-height" && B(a(e, O)), t === "moving-tooltip-bg" && R(e), t === "moving-tooltip-text-color" && k(e), t === "moving-tooltip-units" && G(e), t === "moving-tooltip-units-type" && W(e);
            },
            gettersAndSetters: [
                {
                    name: "movingTooltip",
                    attributes: {
                        get () {
                            return T != null ? T : !1;
                        },
                        set: (t)=>{
                            C(A(t));
                        }
                    }
                },
                {
                    name: "distanceToPointer",
                    attributes: {
                        get () {
                            return c != null ? c : !1;
                        },
                        set: (t)=>{
                            M(a(t, S));
                        }
                    }
                },
                {
                    name: "tooltipWidth",
                    attributes: {
                        get () {
                            return v;
                        },
                        set: (t)=>{
                            F(a(t, U));
                        }
                    }
                },
                {
                    name: "tooltipHeight",
                    attributes: {
                        get () {
                            return h;
                        },
                        set: (t)=>{
                            B(a(t, O));
                        }
                    }
                },
                {
                    name: "tooltipBg",
                    attributes: {
                        get () {
                            return I;
                        },
                        set: (t)=>{
                            R(t);
                        }
                    }
                },
                {
                    name: "tooltipTextColor",
                    attributes: {
                        get () {
                            return P;
                        },
                        set: (t)=>{
                            k(t);
                        }
                    }
                },
                {
                    name: "tooltipUnits",
                    attributes: {
                        get () {
                            return b;
                        },
                        set: (t)=>{
                            G(t);
                        }
                    }
                },
                {
                    name: "tooltipUnitType",
                    attributes: {
                        get () {
                            return E;
                        },
                        set: (t)=>{
                            W(t);
                        }
                    }
                },
                {
                    name: "formatTooltipValue",
                    attributes: {
                        get () {
                            return L;
                        },
                        set: (t)=>{
                            Y(t);
                        }
                    }
                }
            ],
            css: `
.tooltip{
  background: #475569;
  color: #fff;
  font-size: 0.8rem;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: ${j};
}  

.tooltip::after {
    content: '';
    position: absolute;
    width: 7px;
    height: 6px;
    transform: translate(0%, -50%) rotate(45deg);
    background-color: inherit;
    z-index: -1;
    top: 100%;
}

.is-after .tooltip::after {
  top: 0;
}

.type-vertical .tooltip::after{
  transform: translate(-50%, 0%) rotate(45deg);
  left: 100%;
  top: auto;
}

.type-vertical .is-after .tooltip::after{
  left: 0%;
}

.animate-on-click .tooltip{
    transition: all var(--animate-onclick);
}
    `,
            destroy: N
        };
    };
    window.tcRangeSliderPlugins.push(w);
    var it = w;
})();



var $ilwiq = parcelRequire("ilwiq");

var $5Rd1x = parcelRequire("5Rd1x");

var $ilwiq = parcelRequire("ilwiq");

var $ilwiq = parcelRequire("ilwiq");
const $89f44d1a70691651$var$_box = new (0, $ilwiq.Box3)();
const $89f44d1a70691651$var$_vector = new (0, $ilwiq.Vector3)();
class $89f44d1a70691651$export$5b1256aa5274bf8 extends (0, $ilwiq.InstancedBufferGeometry) {
    constructor(){
        super();
        this.isLineSegmentsGeometry = true;
        this.type = "LineSegmentsGeometry";
        const positions = [
            -1,
            2,
            0,
            1,
            2,
            0,
            -1,
            1,
            0,
            1,
            1,
            0,
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const uvs = [
            -1,
            2,
            1,
            2,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -2,
            1,
            -2
        ];
        const index = [
            0,
            2,
            1,
            2,
            3,
            1,
            2,
            4,
            3,
            4,
            5,
            3,
            4,
            6,
            5,
            6,
            7,
            5
        ];
        this.setIndex(index);
        this.setAttribute("position", new (0, $ilwiq.Float32BufferAttribute)(positions, 3));
        this.setAttribute("uv", new (0, $ilwiq.Float32BufferAttribute)(uvs, 2));
    }
    applyMatrix4(matrix) {
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined) {
            start.applyMatrix4(matrix);
            end.applyMatrix4(matrix);
            start.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    setPositions(array) {
        let lineSegments;
        if (array instanceof Float32Array) lineSegments = array;
        else if (Array.isArray(array)) lineSegments = new Float32Array(array);
        const instanceBuffer = new (0, $ilwiq.InstancedInterleavedBuffer)(lineSegments, 6, 1); // xyz, xyz
        this.setAttribute("instanceStart", new (0, $ilwiq.InterleavedBufferAttribute)(instanceBuffer, 3, 0)); // xyz
        this.setAttribute("instanceEnd", new (0, $ilwiq.InterleavedBufferAttribute)(instanceBuffer, 3, 3)); // xyz
        //
        this.computeBoundingBox();
        this.computeBoundingSphere();
        return this;
    }
    setColors(array) {
        let colors;
        if (array instanceof Float32Array) colors = array;
        else if (Array.isArray(array)) colors = new Float32Array(array);
        const instanceColorBuffer = new (0, $ilwiq.InstancedInterleavedBuffer)(colors, 6, 1); // rgb, rgb
        this.setAttribute("instanceColorStart", new (0, $ilwiq.InterleavedBufferAttribute)(instanceColorBuffer, 3, 0)); // rgb
        this.setAttribute("instanceColorEnd", new (0, $ilwiq.InterleavedBufferAttribute)(instanceColorBuffer, 3, 3)); // rgb
        return this;
    }
    fromWireframeGeometry(geometry) {
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    fromEdgesGeometry(geometry) {
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    fromMesh(mesh) {
        this.fromWireframeGeometry(new (0, $ilwiq.WireframeGeometry)(mesh.geometry));
        // set colors, maybe
        return this;
    }
    fromLineSegments(lineSegments) {
        const geometry = lineSegments.geometry;
        this.setPositions(geometry.attributes.position.array); // assumes non-indexed
        // set colors, maybe
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new (0, $ilwiq.Box3)();
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined && end !== undefined) {
            this.boundingBox.setFromBufferAttribute(start);
            $89f44d1a70691651$var$_box.setFromBufferAttribute(end);
            this.boundingBox.union($89f44d1a70691651$var$_box);
        }
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new (0, $ilwiq.Sphere)();
        if (this.boundingBox === null) this.computeBoundingBox();
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined && end !== undefined) {
            const center = this.boundingSphere.center;
            this.boundingBox.getCenter(center);
            let maxRadiusSq = 0;
            for(let i = 0, il = start.count; i < il; i++){
                $89f44d1a70691651$var$_vector.fromBufferAttribute(start, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($89f44d1a70691651$var$_vector));
                $89f44d1a70691651$var$_vector.fromBufferAttribute(end, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($89f44d1a70691651$var$_vector));
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error("THREE.LineSegmentsGeometry.computeBoundingSphere(): Computed radius is NaN. The instanced position data is likely to have NaN values.", this);
        }
    }
    toJSON() {
    // todo
    }
    applyMatrix(matrix) {
        console.warn("THREE.LineSegmentsGeometry: applyMatrix() has been renamed to applyMatrix4().");
        return this.applyMatrix4(matrix);
    }
}


/**
 * parameters = {
 *  color: <hex>,
 *  linewidth: <float>,
 *  dashed: <boolean>,
 *  dashScale: <float>,
 *  dashSize: <float>,
 *  dashOffset: <float>,
 *  gapSize: <float>,
 *  resolution: <Vector2>, // to be set by renderer
 * }
 */ 
var $ilwiq = parcelRequire("ilwiq");
(0, $ilwiq.UniformsLib).line = {
    worldUnits: {
        value: 1
    },
    linewidth: {
        value: 1
    },
    resolution: {
        value: new (0, $ilwiq.Vector2)(1, 1)
    },
    dashOffset: {
        value: 0
    },
    dashScale: {
        value: 1
    },
    dashSize: {
        value: 1
    },
    gapSize: {
        value: 1
    } // todo FIX - maybe change to totalSize
};
(0, $ilwiq.ShaderLib)["line"] = {
    uniforms: (0, $ilwiq.UniformsUtils).merge([
        (0, $ilwiq.UniformsLib).common,
        (0, $ilwiq.UniformsLib).fog,
        (0, $ilwiq.UniformsLib).line
    ]),
    vertexShader: /* glsl */ `
		#include <common>
		#include <color_pars_vertex>
		#include <fog_pars_vertex>
		#include <logdepthbuf_pars_vertex>
		#include <clipping_planes_pars_vertex>

		uniform float linewidth;
		uniform vec2 resolution;

		attribute vec3 instanceStart;
		attribute vec3 instanceEnd;

		attribute vec3 instanceColorStart;
		attribute vec3 instanceColorEnd;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#ifdef USE_DASH

			uniform float dashScale;
			attribute float instanceDistanceStart;
			attribute float instanceDistanceEnd;
			varying float vLineDistance;

		#endif

		void trimSegment( const in vec4 start, inout vec4 end ) {

			// trim end segment so it terminates between the camera plane and the near plane

			// conservative estimate of the near plane
			float a = projectionMatrix[ 2 ][ 2 ]; // 3nd entry in 3th column
			float b = projectionMatrix[ 3 ][ 2 ]; // 3nd entry in 4th column
			float nearEstimate = - 0.5 * b / a;

			float alpha = ( nearEstimate - start.z ) / ( end.z - start.z );

			end.xyz = mix( start.xyz, end.xyz, alpha );

		}

		void main() {

			#ifdef USE_COLOR

				vColor.xyz = ( position.y < 0.5 ) ? instanceColorStart : instanceColorEnd;

			#endif

			#ifdef USE_DASH

				vLineDistance = ( position.y < 0.5 ) ? dashScale * instanceDistanceStart : dashScale * instanceDistanceEnd;
				vUv = uv;

			#endif

			float aspect = resolution.x / resolution.y;

			// camera space
			vec4 start = modelViewMatrix * vec4( instanceStart, 1.0 );
			vec4 end = modelViewMatrix * vec4( instanceEnd, 1.0 );

			#ifdef WORLD_UNITS

				worldStart = start.xyz;
				worldEnd = end.xyz;

			#else

				vUv = uv;

			#endif

			// special case for perspective projection, and segments that terminate either in, or behind, the camera plane
			// clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
			// but we need to perform ndc-space calculations in the shader, so we must address this issue directly
			// perhaps there is a more elegant solution -- WestLangley

			bool perspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 ); // 4th entry in the 3rd column

			if ( perspective ) {

				if ( start.z < 0.0 && end.z >= 0.0 ) {

					trimSegment( start, end );

				} else if ( end.z < 0.0 && start.z >= 0.0 ) {

					trimSegment( end, start );

				}

			}

			// clip space
			vec4 clipStart = projectionMatrix * start;
			vec4 clipEnd = projectionMatrix * end;

			// ndc space
			vec3 ndcStart = clipStart.xyz / clipStart.w;
			vec3 ndcEnd = clipEnd.xyz / clipEnd.w;

			// direction
			vec2 dir = ndcEnd.xy - ndcStart.xy;

			// account for clip-space aspect ratio
			dir.x *= aspect;
			dir = normalize( dir );

			#ifdef WORLD_UNITS

				// get the offset direction as perpendicular to the view vector
				vec3 worldDir = normalize( end.xyz - start.xyz );
				vec3 offset;
				if ( position.y < 0.5 ) {

					offset = normalize( cross( start.xyz, worldDir ) );

				} else {

					offset = normalize( cross( end.xyz, worldDir ) );

				}

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				float forwardOffset = dot( worldDir, vec3( 0.0, 0.0, 1.0 ) );

				// don't extend the line if we're rendering dashes because we
				// won't be rendering the endcaps
				#ifndef USE_DASH

					// extend the line bounds to encompass  endcaps
					start.xyz += - worldDir * linewidth * 0.5;
					end.xyz += worldDir * linewidth * 0.5;

					// shift the position of the quad so it hugs the forward edge of the line
					offset.xy -= dir * forwardOffset;
					offset.z += 0.5;

				#endif

				// endcaps
				if ( position.y > 1.0 || position.y < 0.0 ) {

					offset.xy += dir * 2.0 * forwardOffset;

				}

				// adjust for linewidth
				offset *= linewidth * 0.5;

				// set the world position
				worldPos = ( position.y < 0.5 ) ? start : end;
				worldPos.xyz += offset;

				// project the worldpos
				vec4 clip = projectionMatrix * worldPos;

				// shift the depth of the projected points so the line
				// segments overlap neatly
				vec3 clipPose = ( position.y < 0.5 ) ? ndcStart : ndcEnd;
				clip.z = clipPose.z * clip.w;

			#else

				vec2 offset = vec2( dir.y, - dir.x );
				// undo aspect ratio adjustment
				dir.x /= aspect;
				offset.x /= aspect;

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				// endcaps
				if ( position.y < 0.0 ) {

					offset += - dir;

				} else if ( position.y > 1.0 ) {

					offset += dir;

				}

				// adjust for linewidth
				offset *= linewidth;

				// adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
				offset /= resolution.y;

				// select end
				vec4 clip = ( position.y < 0.5 ) ? clipStart : clipEnd;

				// back to clip space
				offset *= clip.w;

				clip.xy += offset;

			#endif

			gl_Position = clip;

			vec4 mvPosition = ( position.y < 0.5 ) ? start : end; // this is an approximation

			#include <logdepthbuf_vertex>
			#include <clipping_planes_vertex>
			#include <fog_vertex>

		}
		`,
    fragmentShader: /* glsl */ `
		uniform vec3 diffuse;
		uniform float opacity;
		uniform float linewidth;

		#ifdef USE_DASH

			uniform float dashOffset;
			uniform float dashSize;
			uniform float gapSize;

		#endif

		varying float vLineDistance;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#include <common>
		#include <color_pars_fragment>
		#include <fog_pars_fragment>
		#include <logdepthbuf_pars_fragment>
		#include <clipping_planes_pars_fragment>

		vec2 closestLineToLine(vec3 p1, vec3 p2, vec3 p3, vec3 p4) {

			float mua;
			float mub;

			vec3 p13 = p1 - p3;
			vec3 p43 = p4 - p3;

			vec3 p21 = p2 - p1;

			float d1343 = dot( p13, p43 );
			float d4321 = dot( p43, p21 );
			float d1321 = dot( p13, p21 );
			float d4343 = dot( p43, p43 );
			float d2121 = dot( p21, p21 );

			float denom = d2121 * d4343 - d4321 * d4321;

			float numer = d1343 * d4321 - d1321 * d4343;

			mua = numer / denom;
			mua = clamp( mua, 0.0, 1.0 );
			mub = ( d1343 + d4321 * ( mua ) ) / d4343;
			mub = clamp( mub, 0.0, 1.0 );

			return vec2( mua, mub );

		}

		void main() {

			#include <clipping_planes_fragment>

			#ifdef USE_DASH

				if ( vUv.y < - 1.0 || vUv.y > 1.0 ) discard; // discard endcaps

				if ( mod( vLineDistance + dashOffset, dashSize + gapSize ) > dashSize ) discard; // todo - FIX

			#endif

			float alpha = opacity;

			#ifdef WORLD_UNITS

				// Find the closest points on the view ray and the line segment
				vec3 rayEnd = normalize( worldPos.xyz ) * 1e5;
				vec3 lineDir = worldEnd - worldStart;
				vec2 params = closestLineToLine( worldStart, worldEnd, vec3( 0.0, 0.0, 0.0 ), rayEnd );

				vec3 p1 = worldStart + lineDir * params.x;
				vec3 p2 = rayEnd * params.y;
				vec3 delta = p1 - p2;
				float len = length( delta );
				float norm = len / linewidth;

				#ifndef USE_DASH

					#ifdef USE_ALPHA_TO_COVERAGE

						float dnorm = fwidth( norm );
						alpha = 1.0 - smoothstep( 0.5 - dnorm, 0.5 + dnorm, norm );

					#else

						if ( norm > 0.5 ) {

							discard;

						}

					#endif

				#endif

			#else

				#ifdef USE_ALPHA_TO_COVERAGE

					// artifacts appear on some hardware if a derivative is taken within a conditional
					float a = vUv.x;
					float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
					float len2 = a * a + b * b;
					float dlen = fwidth( len2 );

					if ( abs( vUv.y ) > 1.0 ) {

						alpha = 1.0 - smoothstep( 1.0 - dlen, 1.0 + dlen, len2 );

					}

				#else

					if ( abs( vUv.y ) > 1.0 ) {

						float a = vUv.x;
						float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
						float len2 = a * a + b * b;

						if ( len2 > 1.0 ) discard;

					}

				#endif

			#endif

			vec4 diffuseColor = vec4( diffuse, alpha );

			#include <logdepthbuf_fragment>
			#include <color_fragment>

			gl_FragColor = vec4( diffuseColor.rgb, alpha );

			#include <tonemapping_fragment>
			#include <encodings_fragment>
			#include <fog_fragment>
			#include <premultiplied_alpha_fragment>

		}
		`
};
class $002da8e8d6c5dd8a$export$d19cd1378966f3d3 extends (0, $ilwiq.ShaderMaterial) {
    constructor(parameters){
        super({
            type: "LineMaterial",
            uniforms: (0, $ilwiq.UniformsUtils).clone((0, $ilwiq.ShaderLib)["line"].uniforms),
            vertexShader: (0, $ilwiq.ShaderLib)["line"].vertexShader,
            fragmentShader: (0, $ilwiq.ShaderLib)["line"].fragmentShader,
            clipping: true // required for clipping support
        });
        this.isLineMaterial = true;
        Object.defineProperties(this, {
            color: {
                enumerable: true,
                get: function() {
                    return this.uniforms.diffuse.value;
                },
                set: function(value) {
                    this.uniforms.diffuse.value = value;
                }
            },
            worldUnits: {
                enumerable: true,
                get: function() {
                    return "WORLD_UNITS" in this.defines;
                },
                set: function(value) {
                    if (value === true) this.defines.WORLD_UNITS = "";
                    else delete this.defines.WORLD_UNITS;
                }
            },
            linewidth: {
                enumerable: true,
                get: function() {
                    return this.uniforms.linewidth.value;
                },
                set: function(value) {
                    this.uniforms.linewidth.value = value;
                }
            },
            dashed: {
                enumerable: true,
                get: function() {
                    return Boolean("USE_DASH" in this.defines);
                },
                set (value) {
                    if (Boolean(value) !== Boolean("USE_DASH" in this.defines)) this.needsUpdate = true;
                    if (value === true) this.defines.USE_DASH = "";
                    else delete this.defines.USE_DASH;
                }
            },
            dashScale: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashScale.value;
                },
                set: function(value) {
                    this.uniforms.dashScale.value = value;
                }
            },
            dashSize: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashSize.value;
                },
                set: function(value) {
                    this.uniforms.dashSize.value = value;
                }
            },
            dashOffset: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashOffset.value;
                },
                set: function(value) {
                    this.uniforms.dashOffset.value = value;
                }
            },
            gapSize: {
                enumerable: true,
                get: function() {
                    return this.uniforms.gapSize.value;
                },
                set: function(value) {
                    this.uniforms.gapSize.value = value;
                }
            },
            opacity: {
                enumerable: true,
                get: function() {
                    return this.uniforms.opacity.value;
                },
                set: function(value) {
                    this.uniforms.opacity.value = value;
                }
            },
            resolution: {
                enumerable: true,
                get: function() {
                    return this.uniforms.resolution.value;
                },
                set: function(value) {
                    this.uniforms.resolution.value.copy(value);
                }
            },
            alphaToCoverage: {
                enumerable: true,
                get: function() {
                    return Boolean("USE_ALPHA_TO_COVERAGE" in this.defines);
                },
                set: function(value) {
                    if (Boolean(value) !== Boolean("USE_ALPHA_TO_COVERAGE" in this.defines)) this.needsUpdate = true;
                    if (value === true) {
                        this.defines.USE_ALPHA_TO_COVERAGE = "";
                        this.extensions.derivatives = true;
                    } else {
                        delete this.defines.USE_ALPHA_TO_COVERAGE;
                        this.extensions.derivatives = false;
                    }
                }
            }
        });
        this.setValues(parameters);
    }
}


const $0a33803082638faa$var$_start = new (0, $ilwiq.Vector3)();
const $0a33803082638faa$var$_end = new (0, $ilwiq.Vector3)();
const $0a33803082638faa$var$_start4 = new (0, $ilwiq.Vector4)();
const $0a33803082638faa$var$_end4 = new (0, $ilwiq.Vector4)();
const $0a33803082638faa$var$_ssOrigin = new (0, $ilwiq.Vector4)();
const $0a33803082638faa$var$_ssOrigin3 = new (0, $ilwiq.Vector3)();
const $0a33803082638faa$var$_mvMatrix = new (0, $ilwiq.Matrix4)();
const $0a33803082638faa$var$_line = new (0, $ilwiq.Line3)();
const $0a33803082638faa$var$_closestPoint = new (0, $ilwiq.Vector3)();
const $0a33803082638faa$var$_box = new (0, $ilwiq.Box3)();
const $0a33803082638faa$var$_sphere = new (0, $ilwiq.Sphere)();
const $0a33803082638faa$var$_clipToWorldVector = new (0, $ilwiq.Vector4)();
let $0a33803082638faa$var$_ray, $0a33803082638faa$var$_lineWidth;
// Returns the margin required to expand by in world space given the distance from the camera,
// line width, resolution, and camera projection
function $0a33803082638faa$var$getWorldSpaceHalfWidth(camera, distance, resolution) {
    // transform into clip space, adjust the x and y values by the pixel width offset, then
    // transform back into world space to get world offset. Note clip space is [-1, 1] so full
    // width does not need to be halved.
    $0a33803082638faa$var$_clipToWorldVector.set(0, 0, -distance, 1.0).applyMatrix4(camera.projectionMatrix);
    $0a33803082638faa$var$_clipToWorldVector.multiplyScalar(1.0 / $0a33803082638faa$var$_clipToWorldVector.w);
    $0a33803082638faa$var$_clipToWorldVector.x = $0a33803082638faa$var$_lineWidth / resolution.width;
    $0a33803082638faa$var$_clipToWorldVector.y = $0a33803082638faa$var$_lineWidth / resolution.height;
    $0a33803082638faa$var$_clipToWorldVector.applyMatrix4(camera.projectionMatrixInverse);
    $0a33803082638faa$var$_clipToWorldVector.multiplyScalar(1.0 / $0a33803082638faa$var$_clipToWorldVector.w);
    return Math.abs(Math.max($0a33803082638faa$var$_clipToWorldVector.x, $0a33803082638faa$var$_clipToWorldVector.y));
}
function $0a33803082638faa$var$raycastWorldUnits(lineSegments, intersects) {
    const matrixWorld = lineSegments.matrixWorld;
    const geometry = lineSegments.geometry;
    const instanceStart = geometry.attributes.instanceStart;
    const instanceEnd = geometry.attributes.instanceEnd;
    const segmentCount = Math.min(geometry.instanceCount, instanceStart.count);
    for(let i = 0, l = segmentCount; i < l; i++){
        $0a33803082638faa$var$_line.start.fromBufferAttribute(instanceStart, i);
        $0a33803082638faa$var$_line.end.fromBufferAttribute(instanceEnd, i);
        $0a33803082638faa$var$_line.applyMatrix4(matrixWorld);
        const pointOnLine = new (0, $ilwiq.Vector3)();
        const point = new (0, $ilwiq.Vector3)();
        $0a33803082638faa$var$_ray.distanceSqToSegment($0a33803082638faa$var$_line.start, $0a33803082638faa$var$_line.end, point, pointOnLine);
        const isInside = point.distanceTo(pointOnLine) < $0a33803082638faa$var$_lineWidth * 0.5;
        if (isInside) intersects.push({
            point: point,
            pointOnLine: pointOnLine,
            distance: $0a33803082638faa$var$_ray.origin.distanceTo(point),
            object: lineSegments,
            face: null,
            faceIndex: i,
            uv: null,
            uv1: null
        });
    }
}
function $0a33803082638faa$var$raycastScreenSpace(lineSegments, camera, intersects) {
    const projectionMatrix = camera.projectionMatrix;
    const material = lineSegments.material;
    const resolution = material.resolution;
    const matrixWorld = lineSegments.matrixWorld;
    const geometry = lineSegments.geometry;
    const instanceStart = geometry.attributes.instanceStart;
    const instanceEnd = geometry.attributes.instanceEnd;
    const segmentCount = Math.min(geometry.instanceCount, instanceStart.count);
    const near = -camera.near;
    //
    // pick a point 1 unit out along the ray to avoid the ray origin
    // sitting at the camera origin which will cause "w" to be 0 when
    // applying the projection matrix.
    $0a33803082638faa$var$_ray.at(1, $0a33803082638faa$var$_ssOrigin);
    // ndc space [ - 1.0, 1.0 ]
    $0a33803082638faa$var$_ssOrigin.w = 1;
    $0a33803082638faa$var$_ssOrigin.applyMatrix4(camera.matrixWorldInverse);
    $0a33803082638faa$var$_ssOrigin.applyMatrix4(projectionMatrix);
    $0a33803082638faa$var$_ssOrigin.multiplyScalar(1 / $0a33803082638faa$var$_ssOrigin.w);
    // screen space
    $0a33803082638faa$var$_ssOrigin.x *= resolution.x / 2;
    $0a33803082638faa$var$_ssOrigin.y *= resolution.y / 2;
    $0a33803082638faa$var$_ssOrigin.z = 0;
    $0a33803082638faa$var$_ssOrigin3.copy($0a33803082638faa$var$_ssOrigin);
    $0a33803082638faa$var$_mvMatrix.multiplyMatrices(camera.matrixWorldInverse, matrixWorld);
    for(let i = 0, l = segmentCount; i < l; i++){
        $0a33803082638faa$var$_start4.fromBufferAttribute(instanceStart, i);
        $0a33803082638faa$var$_end4.fromBufferAttribute(instanceEnd, i);
        $0a33803082638faa$var$_start4.w = 1;
        $0a33803082638faa$var$_end4.w = 1;
        // camera space
        $0a33803082638faa$var$_start4.applyMatrix4($0a33803082638faa$var$_mvMatrix);
        $0a33803082638faa$var$_end4.applyMatrix4($0a33803082638faa$var$_mvMatrix);
        // skip the segment if it's entirely behind the camera
        const isBehindCameraNear = $0a33803082638faa$var$_start4.z > near && $0a33803082638faa$var$_end4.z > near;
        if (isBehindCameraNear) continue;
        // trim the segment if it extends behind camera near
        if ($0a33803082638faa$var$_start4.z > near) {
            const deltaDist = $0a33803082638faa$var$_start4.z - $0a33803082638faa$var$_end4.z;
            const t = ($0a33803082638faa$var$_start4.z - near) / deltaDist;
            $0a33803082638faa$var$_start4.lerp($0a33803082638faa$var$_end4, t);
        } else if ($0a33803082638faa$var$_end4.z > near) {
            const deltaDist = $0a33803082638faa$var$_end4.z - $0a33803082638faa$var$_start4.z;
            const t = ($0a33803082638faa$var$_end4.z - near) / deltaDist;
            $0a33803082638faa$var$_end4.lerp($0a33803082638faa$var$_start4, t);
        }
        // clip space
        $0a33803082638faa$var$_start4.applyMatrix4(projectionMatrix);
        $0a33803082638faa$var$_end4.applyMatrix4(projectionMatrix);
        // ndc space [ - 1.0, 1.0 ]
        $0a33803082638faa$var$_start4.multiplyScalar(1 / $0a33803082638faa$var$_start4.w);
        $0a33803082638faa$var$_end4.multiplyScalar(1 / $0a33803082638faa$var$_end4.w);
        // screen space
        $0a33803082638faa$var$_start4.x *= resolution.x / 2;
        $0a33803082638faa$var$_start4.y *= resolution.y / 2;
        $0a33803082638faa$var$_end4.x *= resolution.x / 2;
        $0a33803082638faa$var$_end4.y *= resolution.y / 2;
        // create 2d segment
        $0a33803082638faa$var$_line.start.copy($0a33803082638faa$var$_start4);
        $0a33803082638faa$var$_line.start.z = 0;
        $0a33803082638faa$var$_line.end.copy($0a33803082638faa$var$_end4);
        $0a33803082638faa$var$_line.end.z = 0;
        // get closest point on ray to segment
        const param = $0a33803082638faa$var$_line.closestPointToPointParameter($0a33803082638faa$var$_ssOrigin3, true);
        $0a33803082638faa$var$_line.at(param, $0a33803082638faa$var$_closestPoint);
        // check if the intersection point is within clip space
        const zPos = (0, $ilwiq.MathUtils).lerp($0a33803082638faa$var$_start4.z, $0a33803082638faa$var$_end4.z, param);
        const isInClipSpace = zPos >= -1 && zPos <= 1;
        const isInside = $0a33803082638faa$var$_ssOrigin3.distanceTo($0a33803082638faa$var$_closestPoint) < $0a33803082638faa$var$_lineWidth * 0.5;
        if (isInClipSpace && isInside) {
            $0a33803082638faa$var$_line.start.fromBufferAttribute(instanceStart, i);
            $0a33803082638faa$var$_line.end.fromBufferAttribute(instanceEnd, i);
            $0a33803082638faa$var$_line.start.applyMatrix4(matrixWorld);
            $0a33803082638faa$var$_line.end.applyMatrix4(matrixWorld);
            const pointOnLine = new (0, $ilwiq.Vector3)();
            const point = new (0, $ilwiq.Vector3)();
            $0a33803082638faa$var$_ray.distanceSqToSegment($0a33803082638faa$var$_line.start, $0a33803082638faa$var$_line.end, point, pointOnLine);
            intersects.push({
                point: point,
                pointOnLine: pointOnLine,
                distance: $0a33803082638faa$var$_ray.origin.distanceTo(point),
                object: lineSegments,
                face: null,
                faceIndex: i,
                uv: null,
                uv1: null
            });
        }
    }
}
class $0a33803082638faa$export$6eda8f258bdba8c5 extends (0, $ilwiq.Mesh) {
    constructor(geometry = new (0, $89f44d1a70691651$export$5b1256aa5274bf8)(), material = new (0, $002da8e8d6c5dd8a$export$d19cd1378966f3d3)({
        color: Math.random() * 0xffffff
    })){
        super(geometry, material);
        this.isLineSegments2 = true;
        this.type = "LineSegments2";
    }
    // for backwards-compatibility, but could be a method of LineSegmentsGeometry...
    computeLineDistances() {
        const geometry = this.geometry;
        const instanceStart = geometry.attributes.instanceStart;
        const instanceEnd = geometry.attributes.instanceEnd;
        const lineDistances = new Float32Array(2 * instanceStart.count);
        for(let i = 0, j = 0, l = instanceStart.count; i < l; i++, j += 2){
            $0a33803082638faa$var$_start.fromBufferAttribute(instanceStart, i);
            $0a33803082638faa$var$_end.fromBufferAttribute(instanceEnd, i);
            lineDistances[j] = j === 0 ? 0 : lineDistances[j - 1];
            lineDistances[j + 1] = lineDistances[j] + $0a33803082638faa$var$_start.distanceTo($0a33803082638faa$var$_end);
        }
        const instanceDistanceBuffer = new (0, $ilwiq.InstancedInterleavedBuffer)(lineDistances, 2, 1); // d0, d1
        geometry.setAttribute("instanceDistanceStart", new (0, $ilwiq.InterleavedBufferAttribute)(instanceDistanceBuffer, 1, 0)); // d0
        geometry.setAttribute("instanceDistanceEnd", new (0, $ilwiq.InterleavedBufferAttribute)(instanceDistanceBuffer, 1, 1)); // d1
        return this;
    }
    raycast(raycaster, intersects) {
        const worldUnits = this.material.worldUnits;
        const camera = raycaster.camera;
        if (camera === null && !worldUnits) console.error('LineSegments2: "Raycaster.camera" needs to be set in order to raycast against LineSegments2 while worldUnits is set to false.');
        const threshold = raycaster.params.Line2 !== undefined ? raycaster.params.Line2.threshold || 0 : 0;
        $0a33803082638faa$var$_ray = raycaster.ray;
        const matrixWorld = this.matrixWorld;
        const geometry = this.geometry;
        const material = this.material;
        $0a33803082638faa$var$_lineWidth = material.linewidth + threshold;
        // check if we intersect the sphere bounds
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $0a33803082638faa$var$_sphere.copy(geometry.boundingSphere).applyMatrix4(matrixWorld);
        // increase the sphere bounds by the worst case line screen space width
        let sphereMargin;
        if (worldUnits) sphereMargin = $0a33803082638faa$var$_lineWidth * 0.5;
        else {
            const distanceToSphere = Math.max(camera.near, $0a33803082638faa$var$_sphere.distanceToPoint($0a33803082638faa$var$_ray.origin));
            sphereMargin = $0a33803082638faa$var$getWorldSpaceHalfWidth(camera, distanceToSphere, material.resolution);
        }
        $0a33803082638faa$var$_sphere.radius += sphereMargin;
        if ($0a33803082638faa$var$_ray.intersectsSphere($0a33803082638faa$var$_sphere) === false) return;
        // check if we intersect the box bounds
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        $0a33803082638faa$var$_box.copy(geometry.boundingBox).applyMatrix4(matrixWorld);
        // increase the box bounds by the worst case line width
        let boxMargin;
        if (worldUnits) boxMargin = $0a33803082638faa$var$_lineWidth * 0.5;
        else {
            const distanceToBox = Math.max(camera.near, $0a33803082638faa$var$_box.distanceToPoint($0a33803082638faa$var$_ray.origin));
            boxMargin = $0a33803082638faa$var$getWorldSpaceHalfWidth(camera, distanceToBox, material.resolution);
        }
        $0a33803082638faa$var$_box.expandByScalar(boxMargin);
        if ($0a33803082638faa$var$_ray.intersectsBox($0a33803082638faa$var$_box) === false) return;
        if (worldUnits) $0a33803082638faa$var$raycastWorldUnits(this, intersects);
        else $0a33803082638faa$var$raycastScreenSpace(this, camera, intersects);
    }
}




const $14c6e27f5c489006$export$cadc9083b0ea9c43 = {
    UPPER_LOWER: "upper_lower",
    UPPER: "upper",
    LOWER: "lower"
};
const $14c6e27f5c489006$export$50bf86b71c5fd0d9 = {
    DEFAULT: "DEFAULT",
    DIFF: "DIFF",
    HEMIAN: "HEMIAN"
};
const $14c6e27f5c489006$export$d5abd5dd7869e8af = {
    isCompressed: false,
    plyFiles: {
        gums: [],
        teeth: [],
        attachments: []
    },
    areFilesLoaded: false,
    modelsObjectCache: [],
    currentView: $14c6e27f5c489006$export$50bf86b71c5fd0d9.DEFAULT,
    isGridVisible: false
};


const $53de29777cdbd7c8$export$a550975ce732ef83 = window.matchMedia("(orientation: portrait)").matches && window.innerWidth <= 500;
const $53de29777cdbd7c8$export$e4d886da0d914a1b = ()=>{
    const scene = new $ilwiq.Scene();
    if ($53de29777cdbd7c8$export$a550975ce732ef83) scene.rotation.z = Math.PI / 2;
    return scene;
};
const $53de29777cdbd7c8$export$40e69c7cd6d54d9c = ({ width: width , height: height  }, canvas)=>{
    const renderer = new $ilwiq.WebGLRenderer({
        canvas: canvas,
        antialias: true,
        alpha: true,
        preserveDrawingBuffer: true
    });
    const DPR = window.devicePixelRatio ? window.devicePixelRatio : 1;
    renderer.setPixelRatio(DPR);
    renderer.setSize(width, height);
    renderer.shadowMap.enabled = true;
    // renderer.gammaInput = true;
    // renderer.gammaOutput = true;
    renderer.toneMapping = $ilwiq.LinearToneMapping;
    renderer.toneMappingExposure = 1;
    renderer.outputEncoding = $ilwiq.sRGBEncoding;
    return renderer;
};
const $53de29777cdbd7c8$export$e24de3f6e24de13a = (camera, renderer)=>{
    var orbitControls = new (0, $5Rd1x.OrbitControls)(camera, renderer.domElement);
    orbitControls.target.set(0, 0, 20);
    orbitControls.enableDamping = true;
    orbitControls.dampingFactor = 0.05;
    orbitControls.screenSpacePanning = true;
    orbitControls.minDistance = 10;
    orbitControls.maxDistance = 1000;
    orbitControls.enablePan = true;
    orbitControls.zoomSpeed = 0.5;
    if ($53de29777cdbd7c8$export$a550975ce732ef83) orbitControls.rotateSpeed = -0.5;
    else orbitControls.rotateSpeed = 0.5;
    return orbitControls;
};
const $53de29777cdbd7c8$export$254b82f749afde61 = ({ width: width , height: height  })=>{
    var frustumSize = 200;
    const aspectRatio = width / height;
    // const camera = new THREE.PerspectiveCamera();
    const camera = new $ilwiq.OrthographicCamera(frustumSize * aspectRatio, frustumSize * aspectRatio, frustumSize, frustumSize);
    // camera.fov = 45;
    // camera.aspect = aspectRatio;
    // camera.far = 1000;
    // camera.near = 0.5;
    // camera.position.set(0, 0, 112);
    camera.position.set(0, 0, 112);
    // Orthographic cameras zoom via camera.zoom (not by moving camera position).
    // Keep mobile at default zoom to avoid an over-zoomed initial view.
    if (!$53de29777cdbd7c8$export$a550975ce732ef83) camera.zoom = 1.21;
    camera.updateProjectionMatrix();
    // var target = new THREE.Vector3(0, 0, 0);
    // camera.lookAt(target);
    return camera;
};
const $53de29777cdbd7c8$export$d70675aa2822a2ba = (scene, renderer)=>{
    // const light = new THREE.DirectionalLight(0xffffff);
    // light.position.set(0, 1, 0);
    // light.castShadow = false;
    // scene.add(light);
    const mainLight = new $ilwiq.DirectionalLight(0xffffff, 1.8);
    // mainLight.position.set(5, 10, 5);
    mainLight.castShadow = true;
    mainLight.shadow.camera.near = 0.1;
    mainLight.shadow.camera.far = 50;
    if ($53de29777cdbd7c8$export$a550975ce732ef83) {
        mainLight.shadow.camera.left = 20;
        mainLight.shadow.camera.right = -20;
        mainLight.shadow.camera.top = -20;
        mainLight.shadow.camera.bottom = 20;
    } else {
        mainLight.shadow.camera.left = -20;
        mainLight.shadow.camera.right = 20;
        mainLight.shadow.camera.top = 20;
        mainLight.shadow.camera.bottom = -20;
    }
    mainLight.shadow.mapSize.width = 2048;
    mainLight.shadow.mapSize.height = 2048;
    // mainLight.shadow.bias = -0.0005;
    scene.add(mainLight);
    const fillLight = new $ilwiq.DirectionalLight(0xffffff, 0.8);
    scene.add(fillLight);
    const rimLight = new $ilwiq.DirectionalLight(0xffffff, 0.65);
    scene.add(rimLight);
    const ambientLight = new $ilwiq.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = $ilwiq.PCFSoftShadowMap;
    renderer.toneMapping = $ilwiq.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.0;
    renderer.outputEncoding = $ilwiq.sRGBEncoding;
    renderer.physicallyCorrectLights = true;
    if (!$53de29777cdbd7c8$export$a550975ce732ef83) {
        fillLight.position.set(-5, 5, 5);
        rimLight.position.set(0, 5, -10);
    } else {
        fillLight.position.set(5, -5, 5);
        rimLight.position.set(-5, 0, -10);
    }
    return mainLight;
};
const $53de29777cdbd7c8$export$1b2a38402d047d8e = ({ width: width , height: height  })=>{
    const aspect = width / height;
    const overlayCamera = new $ilwiq.OrthographicCamera(-1 * aspect, 1 * aspect, 1, -1, 0, 1);
    const overlayScene = new $ilwiq.Scene();
    overlayScene.visible = (0, $14c6e27f5c489006$export$d5abd5dd7869e8af).isGridVisible;
    // Regular grid
    const gridGeometry = new (0, $89f44d1a70691651$export$5b1256aa5274bf8)();
    const positions = [];
    const step = 0.05;
    const maxExtent = Math.max(aspect, 1) * 2;
    const range = Math.ceil(maxExtent / step);
    // Vertical lines (excluding center line)
    for(let i = -range; i <= range; i++){
        if (i === 0) continue; // Skip center line
        const x = i * step;
        positions.push(x, -range * step, 0, x, range * step, 0);
    }
    // Horizontal lines (excluding center line)
    for(let i = -range; i <= range; i++){
        if (i === 0) continue; // Skip center line
        const y = i * step;
        positions.push(-range * step, y, 0, range * step, y, 0);
    }
    gridGeometry.setPositions(positions);
    const gridMaterial = new (0, $002da8e8d6c5dd8a$export$d19cd1378966f3d3)({
        color: 0x888888,
        linewidth: 2,
        transparent: true,
        opacity: 0.3
    });
    gridMaterial.resolution.set(window.innerWidth, window.innerHeight);
    const grid = new (0, $0a33803082638faa$export$6eda8f258bdba8c5)(gridGeometry, gridMaterial);
    overlayScene.add(grid);
    // Center lines (thicker)
    const centerGeometry = new (0, $89f44d1a70691651$export$5b1256aa5274bf8)();
    const centerPositions = [
        // Vertical center line
        0,
        -range * step,
        0,
        0,
        range * step,
        0,
        // Horizontal center line
        -range * step,
        0,
        0,
        range * step,
        0,
        0
    ];
    centerGeometry.setPositions(centerPositions);
    const centerMaterial = new (0, $002da8e8d6c5dd8a$export$d19cd1378966f3d3)({
        color: 0x888888,
        linewidth: 3.5,
        transparent: true,
        opacity: 0.5
    });
    centerMaterial.resolution.set(window.innerWidth, window.innerHeight);
    const centerLines = new (0, $0a33803082638faa$export$6eda8f258bdba8c5)(centerGeometry, centerMaterial);
    overlayScene.add(centerLines);
    return {
        overlayCamera: overlayCamera,
        overlayScene: overlayScene,
        gridMaterial: gridMaterial,
        centerMaterial: centerMaterial
    };
};



var $ilwiq = parcelRequire("ilwiq");

var $hKOBv = parcelRequire("hKOBv");

var $ilwiq = parcelRequire("ilwiq");
class $835522ae6eafc86c$export$e6c0a4d92bb85d0b extends $ilwiq.Loader {
    constructor(options = {}, manager = $ilwiq.DefaultLoadingManager){
        super(manager);
        this.manager = manager;
        this.path = options.path || "";
        this.loadMaterial = options.loadMaterial || true;
    }
    load(url, onLoad, onProgress, onError) {
        const loader = new $ilwiq.FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.load(url, (blob)=>{
            const now = performance.now();
            const decoder = new CortoDecoder(blob);
            const model = decoder.decode();
            const ms = performance.now() - now;
            console.log((model.nvert / 1024.0).toFixed(1) + "KV", ms.toFixed(1) + "ms", (model.nvert / 1000 / ms).toFixed(2) + "MV/s");
            const geometry = this.geometry(model);
            onLoad(geometry);
        }, onProgress, onError);
    }
    loadAsync(url) {
        return new Promise((resolve)=>{
            this.load(url, (geometry)=>{
                resolve(geometry);
            });
        });
    }
    geometry(model) {
        const geometry = new $ilwiq.BufferGeometry();
        if (model.nface) geometry.setIndex(new $ilwiq.BufferAttribute(model.index, 1));
        if (model.groups.length > 0) {
            let start = 0;
            for(let i = 0; i < model.groups.length; i++){
                const g = model.groups[i];
                geometry.addGroup(start * 3, g.end * 3, i);
                start = g.end;
            }
        }
        geometry.setAttribute("position", new $ilwiq.BufferAttribute(model.position, 3));
        // if (model.color)
        //   geometry.setAttribute(
        //     "color",
        //     new THREE.BufferAttribute(model.color, 3, true)
        //   );
        if (model.normal) geometry.setAttribute("normal", new $ilwiq.BufferAttribute(model.normal, 3, true));
        // if (model.uv)
        //   geometry.setAttribute("uv", new THREE.BufferAttribute(model.uv, 2));
        return geometry;
    }
    materials(model, mesh) {
        const promise = {
            waiting: 0
        };
        const options = {};
        options.color = 0xffffffff;
        if (model.nface) {
            options.side = $ilwiq.DoubleSide;
            const materials = [];
            for(let i = 0; i < model.groups.length; i++){
                const opt = Object.assign({}, options);
                const group = model.groups[i];
                if (group.properties.texture) {
                    const textureLoader = new $ilwiq.TextureLoader();
                    promise.waiting++;
                    opt.map = textureLoader.load(this.path + group.properties.texture, ()=>{
                        mesh.dispatchEvent({
                            type: "change"
                        });
                    });
                }
                materials.push(group.properties.texture && !model.normal ? new $ilwiq.MeshBasicMaterial(opt) : new $ilwiq.MeshLambertMaterial(opt));
            }
            mesh.material = materials;
        } else {
            options.size = 2;
            options.sizeAttenuation = false;
            mesh.material = new $ilwiq.PointsMaterial(options);
        }
    }
}



parcelRequire("lnboJ");

var $fTNTF = parcelRequire("fTNTF");

var $fmRoT = parcelRequire("fmRoT");
var $ff323866fb43afa6$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ff323866fb43afa6$require$Buffer = $6ZWSX.Buffer;
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


!function(e) {
    $ff323866fb43afa6$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\x00\x00",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\x00", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\x00", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\x00\x00\x00\x00" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\x00\x00\x00\x00" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $ff323866fb43afa6$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($ff323866fb43afa6$require$Buffer.from && $ff323866fb43afa6$require$Buffer.from !== Uint8Array.from) return $ff323866fb43afa6$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $ff323866fb43afa6$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($ff323866fb43afa6$require$Buffer.alloc) return $ff323866fb43afa6$require$Buffer.alloc(e);
                        var t = new $ff323866fb43afa6$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $ff323866fb43afa6$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $ff323866fb43afa6$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $ff323866fb43afa6$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $cfae44f0dfdf62c0$exports.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});


parcelRequire("lnboJ");

class $c67591ac74c9ae8f$var$CanvasManager {
    constructor(){
        this.canvases = new Map();
    }
    add(id, canvas, scene, camera, renderer, controls, overlayScene, overlayCamera) {
        this.canvases.set(id, {
            canvas: canvas,
            scene: scene,
            camera: camera,
            renderer: renderer,
            controls: controls,
            id: id,
            overlayScene: overlayScene,
            overlayCamera: overlayCamera,
            hiddenModels: {
                gums: false,
                teeth: false,
                attachments: false,
                superImposition: true
            },
            visibilityMode: (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER,
            models: {},
            modelGeometries: {},
            superImpositions: {},
            activeMaxilOrMandView: ""
        });
        if (controls) controls.addEventListener("change", ()=>{
            const zoom = camera.zoom;
            this.canvases.forEach((data, canvasId)=>{
                if (canvasId !== id) {
                    data.camera.zoom = zoom;
                    data.camera.updateProjectionMatrix();
                }
            });
        });
        return this.canvases.get(id);
    }
    update(id, { models: models , hiddenModels: hiddenModels , visibilityMode: visibilityMode , modelGeometries: modelGeometries , superImpositions: superImpositions , activeMaxilOrMandView: activeMaxilOrMandView , realMaxUpperIndex: realMaxUpperIndex , realMaxLowerIndex: realMaxLowerIndex  }) {
        const values = {};
        // if (models) values.models = JSON.parse(JSON.stringify({ ...models }));
        if (models) values.models = models;
        if (hiddenModels) values.hiddenModels = {
            ...hiddenModels
        };
        if (visibilityMode) values.visibilityMode = visibilityMode;
        if (modelGeometries) values.modelGeometries = modelGeometries;
        if (superImpositions) values.superImpositions = superImpositions;
        if (activeMaxilOrMandView || activeMaxilOrMandView === "") values.activeMaxilOrMandView = activeMaxilOrMandView;
        if (realMaxUpperIndex != null) values.realMaxUpperIndex = realMaxUpperIndex;
        if (realMaxLowerIndex != null) values.realMaxLowerIndex = realMaxLowerIndex;
        this.canvases.set(id, {
            ...this.get(id),
            ...values
        });
    }
    get(id) {
        return this.canvases.get(id);
    }
    remove(id) {
        const data = this.canvases.get(id);
        if (data) {
            data.renderer.dispose();
            this.canvases.delete(id);
        }
    }
    getAll() {
        return Array.from(this.canvases.values());
    }
    forEach(callback) {
        this.canvases.forEach(callback);
    }
}
window.canvasManager = new $c67591ac74c9ae8f$var$CanvasManager();
var $c67591ac74c9ae8f$export$2e2bcd8739ae039 = window.canvasManager;




var $ilwiq = parcelRequire("ilwiq");






// ============================================================================
// CONSTANTS & CONFIGURATION
// ============================================================================
const $34b3600950cd5660$var$fallbackIprData = [];
let $34b3600950cd5660$var$iprLayers = null;
const $34b3600950cd5660$export$97f48d371494f63c = (layers)=>{
    $34b3600950cd5660$var$iprLayers = layers || null;
};
/**
 * Get all layers from iprLayers sorted by layer number (1, 2, 3, …).
 * Works with any key format that contains a number, e.g. "layer1", "layer2", "3", etc.
 * @returns {{ key: string, data: object, num: number }[]}
 */ const $34b3600950cd5660$var$getSortedLayers = ()=>{
    if (!$34b3600950cd5660$var$iprLayers || typeof $34b3600950cd5660$var$iprLayers !== "object") return [];
    return Object.entries($34b3600950cd5660$var$iprLayers).map(([key, data])=>{
        const match = key.match(/(\d+)/);
        return match ? {
            key: key,
            data: data,
            num: parseInt(match[1], 10)
        } : null;
    }).filter(Boolean).sort((a, b)=>a.num - b.num);
};
const $34b3600950cd5660$var$normalizeAlignerNumber = (alignerNum)=>{
    if (alignerNum === null || alignerNum === undefined) return null;
    const parsed = parseInt(alignerNum, 10);
    return Number.isNaN(parsed) ? null : parsed;
};
/** IPR starts from aligner 1; treat layer startAligner 0 as 1 for range and display. */ const $34b3600950cd5660$var$iprEffectiveStart = (start)=>start === 0 ? 1 : start;
const $34b3600950cd5660$var$getCurrentAlignerNumber = (upperAlignerNum, lowerAlignerNum)=>{
    const upper = $34b3600950cd5660$var$normalizeAlignerNumber(upperAlignerNum);
    const lower = $34b3600950cd5660$var$normalizeAlignerNumber(lowerAlignerNum);
    if (upper === null) return lower;
    if (lower === null) return upper;
    return Math.max(upper, lower);
};
const $34b3600950cd5660$var$getIprEntriesForAligner = (alignerNum)=>{
    if (!$34b3600950cd5660$var$iprLayers) return null;
    const current = $34b3600950cd5660$var$normalizeAlignerNumber(alignerNum);
    if (current === null) return null;
    const layers = $34b3600950cd5660$var$getSortedLayers();
    // IPR starts from aligner 1; no IPR at aligner 0
    if (current === 0) return [];
    // Find the layer whose aligner range contains the current aligner (start 0 treated as 1)
    for (const { data: data  } of layers){
        if (data == null) continue;
        const effectiveStart = $34b3600950cd5660$var$iprEffectiveStart(data.startAligner ?? 0);
        if (current >= effectiveStart && current <= data.endAligner) return data.ipr || [];
    }
    return [];
};
/**
 * Get ALL IPR entries across every layer, each annotated with its layer's startAligner.
 * Used to show all IPRs from aligner 1 onwards (regardless of which layer they belong to).
 * @returns {{ entry: string, startAligner: number, endAligner: number }[]}
 */ const $34b3600950cd5660$var$getAllIprEntriesWithMetadata = ()=>{
    if (!$34b3600950cd5660$var$iprLayers) return [];
    const result = [];
    for (const { data: data  } of $34b3600950cd5660$var$getSortedLayers()){
        if (data == null || !data.ipr || data.ipr.length === 0) continue;
        const effectiveStart = $34b3600950cd5660$var$iprEffectiveStart(data.startAligner ?? 0);
        data.ipr.forEach((entry)=>{
            result.push({
                entry: entry,
                startAligner: effectiveStart,
                endAligner: data.endAligner
            });
        });
    }
    return result;
};
/**
 * Get the start aligner number for the layer that applies to the given aligner.
 * Used for tooltip text: "IPR performed prior to stage {startAlignerNumber}".
 */ const $34b3600950cd5660$var$getStartAlignerForAligner = (alignerNum)=>{
    if (!$34b3600950cd5660$var$iprLayers) return null;
    const current = $34b3600950cd5660$var$normalizeAlignerNumber(alignerNum);
    if (current === null) return null;
    const layers = $34b3600950cd5660$var$getSortedLayers();
    // IPR starts from aligner 1; no stage at aligner 0
    if (current === 0) return null;
    for (const { data: data  } of layers){
        if (data == null) continue;
        const effectiveStart = $34b3600950cd5660$var$iprEffectiveStart(data.startAligner ?? 0);
        if (current >= effectiveStart && current <= data.endAligner) return data.startAligner != null ? $34b3600950cd5660$var$iprEffectiveStart(data.startAligner) : null;
    }
    return null;
};
/**
 * Returns true if the FDI tooth number belongs to the given arch.
 * Upper arch: quadrant 1 (11–18) and quadrant 2 (21–28).
 * Lower arch: quadrant 3 (31–38) and quadrant 4 (41–48).
 * @param {number} fdi
 * @param {"upper"|"lower"} arch
 */ const $34b3600950cd5660$var$isToothInArch = (fdi, arch)=>{
    const n = parseInt(fdi, 10);
    if (Number.isNaN(n)) return false;
    return arch === "upper" ? n >= 11 && n <= 28 : n >= 31 && n <= 48;
};
const $34b3600950cd5660$export$8639bd0cc6662416 = (arch)=>{
    if (!$34b3600950cd5660$var$iprLayers) return [];
    const starts = new Set();
    for (const { data: data  } of $34b3600950cd5660$var$getSortedLayers()){
        if (data == null || data.startAligner == null || !data.ipr || data.ipr.length === 0) continue;
        const hasArchIpr = arch ? data.ipr.some((entry)=>{
            const toothStr = entry.includes(":") ? entry.split(":")[0] : entry.split(".")[0];
            return $34b3600950cd5660$var$isToothInArch(toothStr, arch);
        }) : true;
        if (hasArchIpr) starts.add($34b3600950cd5660$var$iprEffectiveStart(data.startAligner));
    }
    return [
        ...starts
    ].sort((a, b)=>a - b);
};
const $34b3600950cd5660$export$7b0d3c7f83127bd = (maxAligner, arch)=>{
    if (!$34b3600950cd5660$var$iprLayers) return {
        starts: [],
        ends: []
    };
    const starts = new Set();
    const ends = new Set();
    const layers = $34b3600950cd5660$var$getSortedLayers();
    if (layers.length === 0) return {
        starts: [],
        ends: []
    };
    const filterByArch = (items)=>{
        if (!arch || !Array.isArray(items)) return items || [];
        return items.filter((item)=>$34b3600950cd5660$var$isToothInArch(item, arch));
    };
    // Effective attachments per layer (arch-filtered): if layer has defined non-empty attachment use it,
    // otherwise carry forward from the previous layer minus this layer's removedAttachments (so that
    // add-then-remove-then-add again shows an add marker at the re-add layer).
    const effectiveAttachments = [];
    for(let i = 0; i < layers.length; i++){
        const raw = filterByArch(layers[i].data.attachment);
        const hasOwn = Array.isArray(raw) && raw.length > 0;
        if (hasOwn) effectiveAttachments.push(raw);
        else {
            const prev = i > 0 ? effectiveAttachments[i - 1] : [];
            const removed = filterByArch(layers[i].data.removedAttachments);
            const removedSet = new Set(Array.isArray(removed) ? removed : []);
            effectiveAttachments.push(prev.filter((a)=>!removedSet.has(a)));
        }
    }
    for(let i = 0; i < layers.length; i++){
        const currentAttachments = new Set(effectiveAttachments[i]);
        const prevAttachments = i > 0 ? new Set(effectiveAttachments[i - 1]) : new Set();
        // Addition: current layer introduces at least one new attachment vs previous layer
        const hasNewAttachments = [
            ...currentAttachments
        ].some((a)=>!prevAttachments.has(a));
        if (hasNewAttachments && layers[i].data.startAligner != null) starts.add(layers[i].data.startAligner);
        // Removal: use layer's removedAttachments (arch-filtered). Show at this layer's first aligner (startAligner).
        // If this layer also has new attachments, prefer add marker only.
        const removed = filterByArch(layers[i].data.removedAttachments);
        const hasRemoved = Array.isArray(removed) && removed.length > 0;
        if (hasRemoved && !hasNewAttachments && layers[i].data.startAligner != null) {
            const alignerToMark = layers[i].data.startAligner;
            const end = maxAligner != null ? Math.min(alignerToMark, maxAligner) : alignerToMark;
            ends.add(end);
        }
    }
    // If any attachments persist at the end of the last layer, they are always removed
    // at the final treatment step (maxAligner). This applies even when one arch is shorter
    // than the other — the removal marker is placed at the greater arch's last step.
    // When filtering by arch (upper or lower): also show end-of-treatment removal at maxAligner
    // if that arch had attachments in some layer but has none remaining at the end (so the
    // removal marker is visible at the end of the treatment timeline for that arch).
    const lastEffective = effectiveAttachments[effectiveAttachments.length - 1];
    const hasRemainingAtEnd = Array.isArray(lastEffective) && lastEffective.length > 0;
    const hadAttachmentsEarlier = (arch === "upper" || arch === "lower") && !hasRemainingAtEnd && effectiveAttachments.some((arr)=>Array.isArray(arr) && arr.length > 0);
    if (hasRemainingAtEnd || hadAttachmentsEarlier) {
        const lastLayer = layers[layers.length - 1];
        const endOfTreatment = maxAligner != null ? maxAligner : lastLayer.data.endAligner != null ? lastLayer.data.endAligner : null;
        if (endOfTreatment != null) ends.add(endOfTreatment);
    }
    return {
        starts: [
            ...starts
        ].sort((a, b)=>a - b),
        ends: [
            ...ends
        ].sort((a, b)=>a - b)
    };
};
/**
 * Convert IPR format to tooth pair and value.
 * Supports "tooth:value" (e.g. "21:0.3") and "tooth.value" (e.g. "15.04").
 * The key is one FDI; the IPR is between that tooth and its arch-neighbor.
 * Arch order: upper right 17→11 (-1), upper left 21→27 (+1), lower right 47→41 (-1), lower left 31→37 (+1).
 * Midline: 11↔21 and 31↔41 only for the central incisors (11 → 21, 41 → 31).
 */ const $34b3600950cd5660$var$parseIPREntry = (entry)=>{
    let toothStr;
    let value;
    if (entry.includes(":")) [toothStr, value] = entry.split(":");
    else if (entry.includes(".")) {
        const parts = entry.split(".");
        toothStr = parts[0];
        value = parts.slice(1).join(".");
        if (value.length >= 2 && !value.includes(".")) value = value.replace(/^0/, "0.") || value;
    } else return {
        tooth1: null,
        tooth2: null,
        value: ""
    };
    const toothNum = parseInt(toothStr, 10);
    if (Number.isNaN(toothNum)) return {
        tooth1: null,
        tooth2: null,
        value: value || ""
    };
    let nextTooth;
    if (toothNum === 11) nextTooth = 21;
    else if (toothNum === 41) nextTooth = 31;
    else if (toothNum >= 21 && toothNum <= 27) nextTooth = toothNum + 1;
    else if (toothNum >= 31 && toothNum <= 37) nextTooth = toothNum + 1;
    else if (toothNum >= 11 && toothNum <= 17) nextTooth = toothNum - 1;
    else if (toothNum >= 41 && toothNum <= 47) nextTooth = toothNum - 1;
    else nextTooth = toothNum;
    return {
        tooth1: toothStr,
        tooth2: nextTooth.toString(),
        value: value == null ? "" : String(value)
    };
};
/**
 * FDI neighbor along the arch as in IPR data (same rule as parseIPREntry tooth2).
 * Used to walk past missing teeth to the next present contact tooth.
 */ const $34b3600950cd5660$var$getNominalArchNeighborFDI = (toothNum)=>{
    if (toothNum === 11) return 21;
    if (toothNum === 41) return 31;
    if (toothNum >= 21 && toothNum <= 27) return toothNum + 1;
    if (toothNum >= 31 && toothNum <= 37) return toothNum + 1;
    if (toothNum >= 11 && toothNum <= 17) return toothNum - 1;
    if (toothNum >= 41 && toothNum <= 47) return toothNum - 1;
    return null;
};
/**
 * Resolve IPR anchor + nominal neighbor to FDI numbers that have meshes.
 * When the nominal neighbor is missing (e.g. IPR "15" with 14 missing), walks the arch
 * in the same direction until a non-missing tooth is found (e.g. 15–13).
 * @returns {{ tooth1: string, tooth2: string } | null}
 */ const $34b3600950cd5660$var$resolveIPRPresentMeshPairFDI = (anchorStr, nominalNeighborStr)=>{
    const missingSet = new Set($34b3600950cd5660$var$missingTeethFDI);
    const anchor = parseInt(anchorStr, 10);
    let neighbor = parseInt(nominalNeighborStr, 10);
    if (Number.isNaN(anchor) || Number.isNaN(neighbor)) return null;
    if (missingSet.has(anchor)) return null;
    const visited = new Set();
    while(missingSet.has(neighbor)){
        if (visited.has(neighbor)) return null;
        visited.add(neighbor);
        const next = $34b3600950cd5660$var$getNominalArchNeighborFDI(neighbor);
        if (next == null || next === neighbor) return null;
        neighbor = next;
    }
    if (neighbor === anchor) return null;
    return {
        tooth1: String(anchor),
        tooth2: String(neighbor)
    };
};
// IPR line rendering configuration
const $34b3600950cd5660$var$IPR_CONFIG = {
    lineLength: 18,
    gapDistance: 3.4,
    lineWidth: 1,
    lineColor: 0x000000,
    downwardAdjustmentFactor: 1.3,
    blendFactor: 0.6,
    verticalBiasFactor: 1.2,
    verticalAngleRatio: 0.4,
    horizontalStraightenFactor: 0.6,
    anteriorStraightenFactor: 0.8
};
// IPR line color palettes (vertex colors, RGB normalized 0–1)
const $34b3600950cd5660$var$IPR_COLORS = {
    // Default: dark gradient (line not yet highlighted / already past its aligner)
    default: {
        startRGB: [
            0.149,
            0.149,
            0.149
        ],
        endRGB: [
            0.051,
            0.051,
            0.051
        ]
    },
    // Highlighted: blue gradient matching the stripe-segment color (#6FC3DF) — shown exactly at startAligner
    highlighted: {
        startRGB: [
            0.549,
            0.808,
            0.902
        ],
        endRGB: [
            0.435,
            0.765,
            0.875
        ]
    }
};
// Visibility thresholds
const $34b3600950cd5660$var$VISIBILITY_THRESHOLDS = {
    farThreshold: 60,
    nearThreshold: 30,
    sideThreshold: 50,
    verticalThreshold: 30,
    horizontalSectionBoundary: 30
};
// ============================================================================
// DATA STORAGE
// ============================================================================
// Map to store tooth identifiers (FDI numbers) to their meshes
const $34b3600950cd5660$var$toothMapping = new Map();
// Store all IPR lines with their metadata for visibility control
const $34b3600950cd5660$var$iprLines = new Map(); // key: canvasId, value: array of { line, quadrant, horizontalSection, midpoint, endPoint, label }
// Expose iprLines to window for render loop access
window.iprLines = $34b3600950cd5660$var$iprLines;
// Track the last known aligner number per canvas so updateIPRVisibility can respect aligner 0
const $34b3600950cd5660$var$lastAlignerByCanvas = new Map();
// ============================================================================
// TOOTH IDENTIFICATION & MAPPING
// ============================================================================
// Missing teeth FDI numbers (e.g. [28, 38]). Set via setMissingTeethFDI() when case data is loaded.
let $34b3600950cd5660$var$missingTeethFDI = [];
const $34b3600950cd5660$export$80c2ac620393e8b7 = (fdiList)=>{
    $34b3600950cd5660$var$missingTeethFDI = Array.isArray(fdiList) ? fdiList.map((n)=>parseInt(n, 10)).filter((n)=>!Number.isNaN(n)) : [];
};
/**
 * Ordered FDI numbers for upper jaw (14 teeth): right 17-11, then left 21-27.
 * Models typically have 7 per side (no 3rd molars 18, 28).
 */ const $34b3600950cd5660$var$UPPER_ORDERED_FDI = [
    17,
    16,
    15,
    14,
    13,
    12,
    11,
    21,
    22,
    23,
    24,
    25,
    26,
    27
];
/**
 * Ordered FDI numbers for lower jaw (14 teeth): right 47-41, then left 31-37.
 */ const $34b3600950cd5660$var$LOWER_ORDERED_FDI = [
    47,
    46,
    45,
    44,
    43,
    42,
    41,
    31,
    32,
    33,
    34,
    35,
    36,
    37
];
/**
 * Convert file tooth index to FDI number.
 * File indices are full-arch positions 01-14 (gaps exist for missing teeth — those files simply
 * aren't present in the zip). Upper: 01->17..07->11, 08->21..14->27.
 * Lower: 01->47..07->41, 08->31..14->37.
 * @param {number|string} index - File tooth index (1-based, 1–14)
 * @param {string} jaw - "UPPER" or "LOWER"
 * @returns {number|null} FDI number or null if index out of range
 */ const $34b3600950cd5660$var$convertIndexToFDI = (index, jaw)=>{
    const idx = parseInt(index, 10);
    if (Number.isNaN(idx) || idx < 1) return null;
    const orderedFDI = jaw === "UPPER" ? $34b3600950cd5660$var$UPPER_ORDERED_FDI : jaw === "LOWER" ? $34b3600950cd5660$var$LOWER_ORDERED_FDI : null;
    if (!orderedFDI || idx > orderedFDI.length) return null;
    return orderedFDI[idx - 1];
};
/**
 * Extract tooth index from filename
 * Files use indices 01-14, not FDI numbers
 */ const $34b3600950cd5660$var$extractToothIndex = (filename)=>{
    // Extract the last part of the path (filename only)
    const parts = filename.split("/");
    const filenameOnly = parts[parts.length - 1];
    // Remove file extension
    const nameWithoutExt = filenameOnly.replace(/\.(ply|corto|ctm)$/i, "");
    // Look for patterns with 01-14 indices
    const patterns = [
        /tooth[_-]?(\d{2})/i,
        /(\d{2})[_-]?tooth/i,
        /[_-](\d{2})[_-]/,
        /\/(\d{2})\//,
        /^(\d{2})$/,
        /[_-](\d{2})$/,
        /^(\d{2})[_-]/
    ];
    for (const pattern of patterns){
        const match = nameWithoutExt.match(pattern);
        if (match && match[1]) {
            const index = match[1];
            const num = parseInt(index);
            // Validate it's a valid index (01-14)
            if (num >= 1 && num <= 14) return index;
        }
    }
    return null;
};
const $34b3600950cd5660$export$5973fc5f62f16522 = (filename, mesh, geometry, jaw, alignerNum, index)=>{
    const toothIndex = $34b3600950cd5660$var$extractToothIndex(filename);
    if (toothIndex) {
        // Convert file index to FDI number
        const fdiNumber = $34b3600950cd5660$var$convertIndexToFDI(toothIndex, jaw);
        if (fdiNumber) {
            const key = `${jaw}_${alignerNum}_${fdiNumber}`;
            $34b3600950cd5660$var$toothMapping.set(key, {
                mesh: mesh,
                geometry: geometry,
                jaw: jaw,
                alignerNum: alignerNum,
                toothNumber: fdiNumber.toString(),
                fileIndex: toothIndex,
                index: index,
                filename: filename
            });
        }
    }
};
/**
 * Find tooth mesh by FDI number
 * @param {string} canvasId - Canvas ID
 * @param {string} toothNumber - FDI tooth number
 * @param {string} jaw - Jaw type (UPPER/LOWER)
 * @param {string} alignerNum - Active aligner number (e.g., "00", "01", "02")
 */ const $34b3600950cd5660$var$findToothMesh = (canvasId, toothNumber, jaw = null, alignerNum = null)=>{
    // Try to find in mapping first - this should be the primary method
    for (const [key, value] of $34b3600950cd5660$var$toothMapping.entries())if (value.toothNumber === toothNumber.toString()) {
        const { jaw: storedJaw , mesh: mesh , geometry: geometry , alignerNum: storedAlignerNum , toothNumber: fdiNumber  } = value;
        // Filter by jaw if provided
        if (jaw && storedJaw !== jaw.toUpperCase()) continue;
        // Filter by aligner number if provided (prioritize active aligner)
        if (alignerNum !== null && storedAlignerNum !== alignerNum) continue;
        return {
            mesh: mesh,
            geometry: geometry,
            fdiNumber: fdiNumber ? parseInt(fdiNumber) : null
        };
    }
    // If alignerNum was specified but not found, try without aligner filter as fallback
    if (alignerNum !== null) return $34b3600950cd5660$var$findToothMesh(canvasId, toothNumber, jaw, null);
    return null;
};
/**
 * Resolve IPR FDIs and locate meshes. If the clinical contact tooth has no entry in
 * toothMapping (file index / export mismatch), walk along the arch in the same direction
 * as nominal IPR until a non-missing tooth with a mesh is found.
 */ const $34b3600950cd5660$var$findIPRMeshPairForCanvas = (canvasId, tooth1Num, tooth2Num, jaw, alignerNum)=>{
    const base = $34b3600950cd5660$var$resolveIPRPresentMeshPairFDI(tooth1Num, tooth2Num);
    if (!base) return null;
    const tryMesh = (fdiStr)=>$34b3600950cd5660$var$findToothMesh(canvasId, fdiStr, jaw, alignerNum) || $34b3600950cd5660$var$findToothMesh(canvasId, fdiStr, jaw, null);
    const missingSet = new Set($34b3600950cd5660$var$missingTeethFDI);
    const anchor = parseInt(base.tooth1, 10);
    let t1 = tryMesh(base.tooth1);
    let t2 = tryMesh(base.tooth2);
    if (t1 && !t2) {
        let cur = parseInt(base.tooth2, 10);
        const visited = new Set();
        while(true){
            const next = $34b3600950cd5660$var$getNominalArchNeighborFDI(cur);
            if (next == null || next === cur || visited.has(next)) break;
            visited.add(cur);
            cur = next;
            if (cur === anchor) break;
            if (missingSet.has(cur)) continue;
            const t = tryMesh(String(cur));
            if (t) {
                t2 = t;
                break;
            }
        }
    }
    if (!t1 || !t2) return null;
    return {
        t1: t1,
        t2: t2,
        /** Clinical contact FDIs (after missing-tooth resolution) — labels and stable keys */ resolved: {
            tooth1: base.tooth1,
            tooth2: base.tooth2
        }
    };
};
const $34b3600950cd5660$export$72128fa364af8f33 = ()=>{
    return $34b3600950cd5660$var$toothMapping;
};
const $34b3600950cd5660$export$4860e836ee91184f = ()=>{};
// ============================================================================
// GEOMETRY CALCULATIONS
// ============================================================================
/**
 * Get the center point of a tooth mesh in world coordinates
 */ const $34b3600950cd5660$var$getToothCenter = (mesh, geometry)=>{
    if (!geometry || !mesh) return null;
    // Compute bounding box in local space
    geometry.computeBoundingBox();
    const box = geometry.boundingBox;
    if (!box) return null;
    // Get center of bounding box in local space
    const localCenter = new $ilwiq.Vector3();
    box.getCenter(localCenter);
    // Transform to world coordinates using the mesh's transform
    const worldCenter = localCenter.clone();
    mesh.localToWorld(worldCenter);
    return worldCenter;
};
/**
 * Get the center of the contact face (the face of bounding box closest to the other tooth)
 * This finds which face of the box is facing the other tooth and returns its center point
 */ const $34b3600950cd5660$var$getContactFaceCenter = (mesh, geometry, otherCenter)=>{
    if (!geometry || !mesh) return null;
    // Compute bounding box in local space
    geometry.computeBoundingBox();
    const box = geometry.boundingBox;
    if (!box) return null;
    // Get the center of this tooth in local space
    const localCenter = new $ilwiq.Vector3();
    box.getCenter(localCenter);
    // Transform to world coordinates
    const worldCenter = localCenter.clone();
    mesh.localToWorld(worldCenter);
    // Calculate direction from this tooth to the other tooth
    const directionToOther = new $ilwiq.Vector3();
    directionToOther.subVectors(otherCenter, worldCenter);
    // Transform direction to local space to work with local bounding box
    const localDirection = directionToOther.clone();
    const meshWorldQuaternionInverse = mesh.quaternion.clone().invert();
    localDirection.applyQuaternion(meshWorldQuaternionInverse);
    localDirection.normalize();
    // Find which face of the bounding box is most aligned with the direction
    // The 6 faces are: +X, -X, +Y, -Y, +Z, -Z
    const faces = [
        {
            normal: new $ilwiq.Vector3(1, 0, 0),
            point: new $ilwiq.Vector3(box.max.x, localCenter.y, localCenter.z)
        },
        {
            normal: new $ilwiq.Vector3(-1, 0, 0),
            point: new $ilwiq.Vector3(box.min.x, localCenter.y, localCenter.z)
        },
        {
            normal: new $ilwiq.Vector3(0, 1, 0),
            point: new $ilwiq.Vector3(localCenter.x, box.max.y, localCenter.z)
        },
        {
            normal: new $ilwiq.Vector3(0, -1, 0),
            point: new $ilwiq.Vector3(localCenter.x, box.min.y, localCenter.z)
        },
        {
            normal: new $ilwiq.Vector3(0, 0, 1),
            point: new $ilwiq.Vector3(localCenter.x, localCenter.y, box.max.z)
        },
        {
            normal: new $ilwiq.Vector3(0, 0, -1),
            point: new $ilwiq.Vector3(localCenter.x, localCenter.y, box.min.z)
        }
    ];
    // Find the face with normal most aligned with direction to other tooth
    let bestFace = faces[0];
    let maxDot = -Infinity;
    faces.forEach((face)=>{
        const dot = face.normal.dot(localDirection);
        if (dot > maxDot) {
            maxDot = dot;
            bestFace = face;
        }
    });
    // Transform the face center point to world coordinates
    const contactFaceWorld = bestFace.point.clone();
    mesh.localToWorld(contactFaceWorld);
    return contactFaceWorld;
};
/**
 * Calculate midpoint between two teeth at their contact surfaces
 */ const $34b3600950cd5660$var$getMidpointBetweenTeeth = (scene, tooth1, tooth2)=>{
    // Get the centers of both teeth first
    const center1 = $34b3600950cd5660$var$getToothCenter(tooth1.mesh, tooth1.geometry);
    const center2 = $34b3600950cd5660$var$getToothCenter(tooth2.mesh, tooth2.geometry);
    if (!center1 || !center2) return null;
    // Get the contact face centers (the center of the faces closest to each other)
    const contactFace1 = $34b3600950cd5660$var$getContactFaceCenter(tooth1.mesh, tooth1.geometry, center2);
    const contactFace2 = $34b3600950cd5660$var$getContactFaceCenter(tooth2.mesh, tooth2.geometry, center1);
    if (!contactFace1 || !contactFace2) return null;
    // Calculate midpoint between the contact face centers
    const midpoint = new $ilwiq.Vector3();
    midpoint.addVectors(contactFace1, contactFace2);
    midpoint.multiplyScalar(0.5);
    return {
        midpoint: midpoint,
        center1: center1,
        center2: center2
    };
};
// ============================================================================
// DIRECTION CALCULATION
// ============================================================================
/**
 * Check if a tooth is anterior (incisor/canine) or posterior (premolar/molar)
 * Based on FDI numbering: 11-13, 21-23, 31-33, 41-43 are anterior
 */ const $34b3600950cd5660$var$isAnteriorTooth = (fdiNumber)=>{
    const num = parseInt(fdiNumber);
    // Anterior teeth: 11-13 (upper right), 21-23 (upper left), 31-33 (lower left), 41-43 (lower right)
    return num >= 11 && num <= 13 || num >= 21 && num <= 23 || num >= 31 && num <= 33 || num >= 41 && num <= 43;
};
/**
 * Check if an IPR line is for posterior (back) teeth
 * Returns true if BOTH teeth in the IPR pair are posterior teeth
 * Posterior teeth: 14-18, 24-28, 34-38, 44-48 (premolars and molars)
 */ const $34b3600950cd5660$var$isPosteriorIPR = (tooth1FDI, tooth2FDI)=>{
    if (!tooth1FDI || !tooth2FDI) return false;
    const num1 = parseInt(tooth1FDI);
    const num2 = parseInt(tooth2FDI);
    // Check if both teeth are posterior (premolars and molars)
    const isPosterior1 = num1 >= 14 && num1 <= 18 || num1 >= 24 && num1 <= 28 || num1 >= 34 && num1 <= 38 || num1 >= 44 && num1 <= 48;
    const isPosterior2 = num2 >= 14 && num2 <= 18 || num2 >= 24 && num2 <= 28 || num2 >= 34 && num2 <= 38 || num2 >= 44 && num2 <= 48;
    return isPosterior1 && isPosterior2;
};
/**
 * Calculate direction for anterior teeth (front teeth need adjusted angle)
 */ const $34b3600950cd5660$var$calculateAnteriorDirection = (midpoint, center1, center2, jaw)=>{
    // Calculate vector from center1 to center2 (direction along the arch)
    const archDirection = new $ilwiq.Vector3();
    archDirection.subVectors(center2, center1);
    archDirection.normalize();
    // Project arch direction onto X/Y plane (remove Z component)
    const archDirectionXY = new $ilwiq.Vector3(archDirection.x, archDirection.y, 0);
    archDirectionXY.normalize();
    // Get the base outward direction (same as posterior)
    const baseDirection = new $ilwiq.Vector3();
    baseDirection.copy(midpoint);
    baseDirection.z = 5; // Keep Z component same as posterior
    baseDirection.normalize();
    // Calculate perpendicular direction in X/Y plane using cross product with Z-axis
    // Perpendicular = archDirectionXY × (0, 0, 1) gives us the perpendicular in horizontal plane
    const zAxis = new $ilwiq.Vector3(0, 0, 1);
    const perpendicularXY = new $ilwiq.Vector3();
    perpendicularXY.crossVectors(archDirectionXY, zAxis);
    perpendicularXY.normalize();
    // Determine which direction to use (toward or away from origin)
    // Use the one that points more outward (has positive dot product with midpoint direction)
    const midpointXY = new $ilwiq.Vector3(midpoint.x, midpoint.y, 0);
    midpointXY.normalize();
    const dot1 = perpendicularXY.dot(midpointXY);
    const dot2 = perpendicularXY.clone().multiplyScalar(-1).dot(midpointXY);
    // Use the direction that points more outward
    if (dot2 > dot1) perpendicularXY.multiplyScalar(-1);
    // For front teeth, blend the perpendicular direction with the base direction
    // This gives a more gradual adjustment rather than completely perpendicular
    const baseXY = new $ilwiq.Vector3(baseDirection.x, baseDirection.y, 0);
    baseXY.normalize();
    const blendedXY = new $ilwiq.Vector3();
    blendedXY.addVectors(perpendicularXY.clone().multiplyScalar($34b3600950cd5660$var$IPR_CONFIG.blendFactor), baseXY.clone().multiplyScalar(1 - $34b3600950cd5660$var$IPR_CONFIG.blendFactor));
    blendedXY.normalize();
    // Create final direction: blended X/Y, adjust vertical angle to point more downward
    // For front teeth, we want the lines to point more downward (toward gum line)
    const labialDirection = new $ilwiq.Vector3();
    labialDirection.x = blendedXY.x;
    // Decrease Y component to make lines point more downward (assuming positive Y is upward)
    labialDirection.y = baseDirection.y * (1 - ($34b3600950cd5660$var$IPR_CONFIG.downwardAdjustmentFactor - 1));
    labialDirection.z = baseDirection.z; // Keep Z component
    // Apply jaw-specific vertical bias (upper up, lower down)
    if (jaw === "UPPER" || jaw === "LOWER") {
        const bias = 1 + $34b3600950cd5660$var$IPR_CONFIG.verticalBiasFactor;
        const magnitude = Math.abs(labialDirection.y) * bias;
        labialDirection.y = jaw === "UPPER" ? magnitude : -magnitude;
    }
    labialDirection.normalize();
    return labialDirection;
};
/**
 * Calculate direction for posterior teeth (back teeth use standard approach)
 */ const $34b3600950cd5660$var$calculatePosteriorDirection = (midpoint, jaw)=>{
    const labialDirection = new $ilwiq.Vector3();
    labialDirection.copy(midpoint);
    labialDirection.z = 5; // Zero out Z to stay in horizontal plane
    // Apply a consistent vertical tilt and jaw-specific bias
    labialDirection.y = labialDirection.y * (1 - ($34b3600950cd5660$var$IPR_CONFIG.downwardAdjustmentFactor - 1));
    if (jaw === "UPPER" || jaw === "LOWER") {
        const bias = 1 + $34b3600950cd5660$var$IPR_CONFIG.verticalBiasFactor;
        const magnitude = Math.abs(labialDirection.y) * bias;
        labialDirection.y = jaw === "UPPER" ? magnitude : -magnitude;
    }
    labialDirection.normalize();
    return labialDirection;
};
/**
 * Determine direction to draw IPR line (towards outside/labial)
 * The line should point outward from between the teeth toward the lips/cheeks
 * Front teeth need a different angle than back teeth due to arch curvature
 */ const $34b3600950cd5660$var$getIPRDirection = (jaw, center1, center2, tooth1FDI = null, tooth2FDI = null)=>{
    // Calculate midpoint between teeth
    const midpoint = new $ilwiq.Vector3();
    midpoint.addVectors(center1, center2);
    midpoint.multiplyScalar(0.5);
    // Check if these are anterior teeth
    const isAnterior = tooth1FDI && $34b3600950cd5660$var$isAnteriorTooth(tooth1FDI) || tooth2FDI && $34b3600950cd5660$var$isAnteriorTooth(tooth2FDI);
    // Use different calculation for anterior vs posterior teeth
    if (isAnterior) return $34b3600950cd5660$var$calculateAnteriorDirection(midpoint, center1, center2, jaw);
    else return $34b3600950cd5660$var$calculatePosteriorDirection(midpoint, jaw);
};
// ============================================================================
// VISIBILITY MANAGEMENT
// ============================================================================
/**
 * Determine which horizontal section an IPR line is in (4 horizontal divisions)
 * Returns 'far-left', 'left', 'right', or 'far-right'.
 * In portrait, scene is rotated 90° so left/right on screen corresponds to world Y; use midpoint.y.
 */ const $34b3600950cd5660$var$getIPRHorizontalSection = (midpoint)=>{
    const horiz = (0, $53de29777cdbd7c8$export$a550975ce732ef83) ? midpoint.y : midpoint.x;
    const boundary = $34b3600950cd5660$var$VISIBILITY_THRESHOLDS.horizontalSectionBoundary;
    if (horiz < -boundary) return "far-left";
    if (horiz < 0) return "left";
    if (horiz < boundary) return "right";
    return "far-right";
};
/**
 * Determine which quadrant an IPR line is in
 * Returns 'upper-right', 'upper-left', 'lower-right', or 'lower-left'
 * Based on X (left/right) and Y or Z (upper/lower). In portrait, left/right follows world Y.
 */ const $34b3600950cd5660$var$getIPRQuadrant = (midpoint, jaw)=>{
    const isRight = ((0, $53de29777cdbd7c8$export$a550975ce732ef83) ? midpoint.y : midpoint.x) >= 0;
    const isUpper = jaw === "UPPER";
    if (isUpper && isRight) return "upper-right";
    if (isUpper && !isRight) return "upper-left";
    if (!isUpper && isRight) return "lower-right";
    if (!isUpper && !isRight) return "lower-left";
    // Fallback based on Y coordinate if jaw is not provided
    const isUpperByY = midpoint.y >= 0 || midpoint.z >= 0;
    if (isRight && isUpperByY) return "upper-right";
    if (!isRight && isUpperByY) return "upper-left";
    if (isRight && !isUpperByY) return "lower-right";
    return "lower-left";
};
/**
 * Determine which horizontal section(s) the camera is viewing (4 horizontal divisions)
 * Returns an array: ['far-left'], ['left'], ['right'], ['far-right'], or combinations.
 * In portrait, scene is rotated 90° so horizontal on screen = world Y; use camera Y.
 */ const $34b3600950cd5660$var$getCameraViewHorizontalSections = (camera)=>{
    const cameraPos = camera.position;
    const cameraHoriz = (0, $53de29777cdbd7c8$export$a550975ce732ef83) ? cameraPos.y : cameraPos.x;
    const { farThreshold: farThreshold , nearThreshold: nearThreshold  } = $34b3600950cd5660$var$VISIBILITY_THRESHOLDS;
    // Camera position logic:
    // If camera horiz is positive (camera on left), it's viewing the RIGHT side
    // If camera horiz is negative (camera on right), it's viewing the LEFT side
    if (Math.abs(cameraHoriz) > farThreshold) {
        // Camera is far to the side - viewing the opposite far section and adjacent
        if (cameraHoriz > farThreshold) // Camera far left, viewing far-right and right sections
        return [
            "right",
            "far-right"
        ];
        else // Camera far right, viewing far-left and left sections
        return [
            "far-left",
            "left"
        ];
    } else if (Math.abs(cameraHoriz) > nearThreshold) {
        // Camera is moderately to the side - viewing the opposite section and adjacent
        if (cameraHoriz > nearThreshold) // Camera left, viewing right and far-right sections
        return [
            "right",
            "far-right"
        ];
        else // Camera right, viewing left and far-left sections
        return [
            "far-left",
            "left"
        ];
    } else {
        // Camera is near center - viewing multiple sections
        if (cameraHoriz > 15) // Slightly left of center, viewing right and far-right
        return [
            "right",
            "far-right"
        ];
        else if (cameraHoriz < -15) // Slightly right of center, viewing left and far-left
        return [
            "far-left",
            "left"
        ];
        else // Near center - show all sections
        return [
            "far-left",
            "left",
            "right",
            "far-right"
        ];
    }
};
/**
 * Determine which quadrant(s) of the mouth the camera is viewing
 * Returns an array of quadrants: ['upper-right'], ['upper-left'], etc.
 * Can return multiple quadrants if viewing from front/rear.
 * In portrait, horizontal on screen = world Y; use camera Y for left/right.
 */ const $34b3600950cd5660$var$getCameraViewQuadrants = (camera)=>{
    const cameraPos = camera.position;
    const cameraHoriz = (0, $53de29777cdbd7c8$export$a550975ce732ef83) ? cameraPos.y : cameraPos.x;
    const { sideThreshold: sideThreshold  } = $34b3600950cd5660$var$VISIBILITY_THRESHOLDS;
    // Determine horizontal view (left/right)
    let horizontalView = null;
    if (Math.abs(cameraHoriz) > sideThreshold) // Camera is on the side - return which side is being VIEWED
    // Positive horiz (camera on left) = viewing right side
    // Negative horiz (camera on right) = viewing left side
    horizontalView = cameraHoriz > 0 ? "right" : "left";
    // If only horizontal, return both upper and lower of that side
    if (horizontalView) return [
        `upper-${horizontalView}`,
        `lower-${horizontalView}`
    ];
    // Front, rear, or other views - show all quadrants
    return [
        "upper-right",
        "upper-left",
        "lower-right",
        "lower-left"
    ];
};
/**
 * Determine if the camera is viewing from the front or back of the jaw
 * Front view: Camera Z is high (looking at labial/buccal surface from outside)
 * Rotated/side view: Camera Z drops as camera rotates around the model
 * Returns: 'front' or 'neutral'
 */ const $34b3600950cd5660$var$getCameraFrontBackView = (camera)=>{
    const cameraPos = camera.position;
    const cameraZ = cameraPos.z;
    // Threshold for determining front view
    // Default front view has Z ~112, rotated views have Z ~25-60
    // Use 100 as threshold so posterior IPR lines appear with minimal rotation
    const frontThreshold = 110;
    if (cameraZ > frontThreshold) return "front";
    return "neutral";
};
const $34b3600950cd5660$export$127367bf4516af82 = (canvasId)=>{
    const canvasData = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    if (!canvasData) return;
    // Aligner 0 is the passive tray — keep all lines hidden regardless of camera changes
    if ($34b3600950cd5660$var$lastAlignerByCanvas.get(canvasId) === 0) {
        const lines = $34b3600950cd5660$var$iprLines.get(canvasId) || [];
        lines.forEach(({ line: line , label: label  })=>{
            line.visible = false;
            if (label) {
                label.dataset.visible = "false";
                label.style.opacity = "0";
            }
        });
        return;
    }
    // Diff view canvas: never show IPR
    if (canvasId === "diff-canvas") {
        const lines = $34b3600950cd5660$var$iprLines.get(canvasId) || [];
        lines.forEach(({ line: line , label: label  })=>{
            line.visible = false;
            if (label) {
                label.dataset.visible = "false";
                label.style.opacity = "0";
            }
        });
        return;
    }
    const { camera: camera , renderer: renderer , visibilityMode: visibilityMode  } = canvasData;
    if (!camera || !renderer) return;
    // If IPR is globally disabled, hide all lines for this canvas and return
    if (!$34b3600950cd5660$var$iprEnabled) {
        const linesToHide = $34b3600950cd5660$var$iprLines.get(canvasId) || [];
        linesToHide.forEach(({ line: line , label: label  })=>{
            line.visible = false;
            if (label) {
                label.dataset.visible = "false";
                label.style.opacity = "0";
            }
        });
        return;
    }
    const viewQuadrants = $34b3600950cd5660$var$getCameraViewQuadrants(camera);
    const viewHorizontalSections = $34b3600950cd5660$var$getCameraViewHorizontalSections(camera);
    const frontBackView = $34b3600950cd5660$var$getCameraFrontBackView(camera);
    const lines = $34b3600950cd5660$var$iprLines.get(canvasId) || [];
    lines.forEach(({ line: line , quadrant: quadrant , horizontalSection: horizontalSection , endPoint: endPoint , label: label , isPosterior: isPosterior  })=>{
        // Show lines only if both their quadrant AND horizontal section are in the view
        const quadrantVisible = viewQuadrants.includes(quadrant);
        const horizontalVisible = viewHorizontalSections.includes(horizontalSection);
        const isUpperQuadrant = quadrant.startsWith("upper");
        const isLowerQuadrant = quadrant.startsWith("lower");
        let jawVisible = true;
        if (visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER) jawVisible = isUpperQuadrant;
        else if (visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER) jawVisible = isLowerQuadrant;
        // Front/back visibility logic:
        // When viewing from front, hide posterior (back) IPR lines
        // When viewing from back, show posterior IPR lines
        // When neutral, show all
        let frontBackVisible = true;
        if (frontBackView === "front" && isPosterior) // Camera is at front of jaw, hide back teeth IPR lines
        frontBackVisible = false;
        // When frontBackView is 'back' or 'neutral', show all IPR lines
        // IPR is visible regardless of gums visibility so both can be on at once
        const isVisible = jawVisible && quadrantVisible && horizontalVisible && frontBackVisible;
        line.visible = isVisible;
        // Update label visibility and position
        if (label) {
            label.dataset.visible = isVisible.toString();
            if (isVisible) {
                if ($34b3600950cd5660$export$10242fad97d15005()) $34b3600950cd5660$export$cd624845698d9c61(label, line, camera, renderer, endPoint);
                else if (endPoint) $34b3600950cd5660$export$e4ed0ff6cb6e65c2(label, endPoint, camera, renderer);
            } else label.style.opacity = "0";
        }
    });
};
// ============================================================================
// IPR GLOBAL TOGGLE
// ============================================================================
// Global flag to track if IPR visualization is enabled (visible by default)
let $34b3600950cd5660$var$iprEnabled = true;
const $34b3600950cd5660$export$94a482d3376e4ed9 = (canvasId)=>{
    $34b3600950cd5660$var$iprEnabled = !$34b3600950cd5660$var$iprEnabled;
    const allCanvasIds = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().map((c)=>c.id);
    if (!$34b3600950cd5660$var$iprEnabled) // Hide all IPR lines and labels on every canvas
    allCanvasIds.forEach((id)=>{
        const lines = $34b3600950cd5660$var$iprLines.get(id) || [];
        lines.forEach(({ line: line , label: label  })=>{
            line.visible = false;
            if (label) {
                label.dataset.visible = "false";
                label.style.opacity = "0";
            }
        });
    });
    else // Re-enable IPR and update visibility based on camera for every canvas
    allCanvasIds.forEach((id)=>$34b3600950cd5660$export$127367bf4516af82(id));
    return $34b3600950cd5660$var$iprEnabled;
};
const $34b3600950cd5660$export$ad4e5a378e5747e0 = ()=>$34b3600950cd5660$var$iprEnabled;
const $34b3600950cd5660$export$8d5444b70ae94d36 = (canvasId)=>{
    const lines = $34b3600950cd5660$var$iprLines.get(canvasId);
    if (!lines) return;
    const canvasData = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const scene = canvasData?.scene;
    lines.forEach(({ line: line , label: label  })=>{
        // Remove line from scene
        if (scene && line) {
            scene.remove(line);
            // Dispose of geometry and material
            if (line.geometry) line.geometry.dispose();
            if (line.material) line.material.dispose();
            // Call cleanup function if exists
            if (line.userData?.cleanup) line.userData.cleanup();
        }
        // Remove label from DOM
        if (label && label.parentNode) label.parentNode.removeChild(label);
    });
    // Clear the lines array for this canvas
    $34b3600950cd5660$var$iprLines.delete(canvasId);
};
// ============================================================================
// LABEL MANAGEMENT
// ============================================================================
const $34b3600950cd5660$var$IPR_LABELS_OVERLAY_ID = "ipr-labels-overlay";
const $34b3600950cd5660$export$10242fad97d15005 = ()=>(0, $53de29777cdbd7c8$export$a550975ce732ef83) && window.innerWidth <= 500;
/**
 * Get world position of the line's end vertex (where the IPR line actually ends after transform).
 * LineSegmentsGeometry uses instanceStart/instanceEnd, not position — we read instanceEnd.
 */ const $34b3600950cd5660$var$getIPRLineEndWorld = (line)=>{
    const endAttr = line?.geometry?.attributes?.instanceEnd;
    if (!endAttr || endAttr.count < 1) return null;
    const localEnd = new $ilwiq.Vector3();
    localEnd.fromBufferAttribute(endAttr, 0);
    line.updateMatrixWorld(true);
    return localEnd.applyMatrix4(line.matrixWorld);
};
const $34b3600950cd5660$var$syncOverlayToCanvas = (overlay, canvas)=>{
    if (!overlay || !canvas) return;
    const computed = window.getComputedStyle(canvas);
    overlay.style.position = "absolute";
    overlay.style.top = computed.top;
    overlay.style.left = computed.left;
    overlay.style.width = computed.width;
    overlay.style.height = computed.height;
    overlay.style.transform = computed.transform;
    overlay.style.transformOrigin = computed.transformOrigin;
    overlay.style.pointerEvents = "none";
    overlay.style.zIndex = "9999";
};
/**
 * Get or create a label overlay that matches the canvas transform.
 * We keep labels in the same coordinate system as the canvas so projection math stays simple.
 */ const $34b3600950cd5660$var$getIPRLabelsOverlayForCanvas = (canvas)=>{
    if (!canvas) return null;
    const overlayId = `${$34b3600950cd5660$var$IPR_LABELS_OVERLAY_ID}-${canvas.id || "default"}`;
    let el = document.getElementById(overlayId);
    if (!el) {
        el = document.createElement("div");
        el.id = overlayId;
        el.style.cssText = "position:absolute;pointer-events:none;z-index:9999;";
        (canvas.parentElement || document.body).appendChild(el);
    }
    $34b3600950cd5660$var$syncOverlayToCanvas(el, canvas);
    return el;
};
const $34b3600950cd5660$export$cd624845698d9c61 = (label, line, camera, renderer, worldEndOverride, enableTransition = false)=>{
    if (!label || !camera || !renderer) return;
    const worldEnd = worldEndOverride || (line ? $34b3600950cd5660$var$getIPRLineEndWorld(line) : null);
    if (!worldEnd) return;
    label.style.transition = enableTransition ? "left 0.25s ease-out, top 0.25s ease-out, opacity 0.2s" : "opacity 0.2s";
    const canvas = renderer.domElement;
    const overlay = $34b3600950cd5660$var$getIPRLabelsOverlayForCanvas(canvas);
    if (overlay && label.parentElement !== overlay) overlay.appendChild(label);
    const vector = worldEnd.clone().project(camera);
    const cw = canvas.clientWidth;
    const ch = canvas.clientHeight;
    const canvasLocalX = (vector.x * 0.5 + 0.5) * cw;
    const canvasLocalY = (vector.y * -0.5 + 0.5) * ch;
    label.style.position = "absolute";
    label.style.left = `${canvasLocalX}px`;
    label.style.top = `${canvasLocalY}px`;
    // Counter-rotate so label reads upright (overlay/canvas are rotated 90deg CW in portrait)
    label.style.transform = "translate(-50%, -50%) rotate(-90deg)";
    const shouldBeVisible = label.dataset.visible === "true";
    label.style.opacity = shouldBeVisible ? "1" : "0";
};
/**
 * Get or create a viewport-fixed overlay for IPR labels in portrait.
 * Appended to document.documentElement so position:fixed is viewport-relative
 * and labels are not affected by body's transform.
 */ const $34b3600950cd5660$var$getIPRLabelsOverlay = ()=>{
    let el = document.getElementById($34b3600950cd5660$var$IPR_LABELS_OVERLAY_ID);
    if (!el) {
        el = document.createElement("div");
        el.id = $34b3600950cd5660$var$IPR_LABELS_OVERLAY_ID;
        el.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:9999;";
        document.documentElement.appendChild(el);
    }
    return el;
};
/**
 * Create a diamond-shaped label element for IPR value.
 * @param {string} value - IPR value (e.g. "0.6")
 * @param {string} id - Unique label id (e.g. "canvasId-toothPair")
 * @param {string} canvasId - Canvas id for overlay
 * @param {{ tooth1: string, tooth2: string, value: string, startAlignerNumber: number|null }|undefined} tooltipData - Data for hover tooltip
 */ const $34b3600950cd5660$var$createIPRLabel = (value, id, canvasId, tooltipData)=>{
    const label = document.createElement("span");
    label.className = "ipr-label";
    label.id = `ipr-label-${id}`;
    const isMobile = (0, $53de29777cdbd7c8$export$a550975ce732ef83);
    const size = isMobile ? "18px" : "26px";
    const fontSize = isMobile ? "7px" : "9px";
    // Outer label: positioning only, no rotation — so tooltip "bottom" is screen bottom
    label.style.cssText = `
    position: absolute;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: ${size};
    height: ${size};
    pointer-events: auto;
    z-index: 10;
    transform: translate(-50%, -50%);
    transform-origin: center;
    opacity: 0;
    transition: opacity 0.2s;
  `;
    // Inner diamond: visual only (rotated) so tooltip stays in unrotated space
    const diamond = document.createElement("span");
    diamond.style.cssText = `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${size};
    height: ${size};
    background: #ffffff;
    color: #000000;
    font-size: ${fontSize};
    font-weight: normal;
    font-family: sans-serif;
    white-space: nowrap;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transform: rotate(45deg);
    transform-origin: center;
  `;
    const labelText = document.createElement("span");
    labelText.textContent = value;
    labelText.style.display = "inline-block";
    // -45deg cancels diamond's 45deg so text reads upright (label has counter-rotation in portrait)
    const textRotation = "-45deg";
    labelText.style.transform = `rotate(${textRotation})`;
    diamond.appendChild(labelText);
    label.appendChild(diamond);
    // Set initial visibility state - labels should be visible by default until visibility logic determines otherwise
    label.dataset.visible = "true";
    // Tooltip on hover: "Between []-[], {content} mm, IPR performed prior to stage {startAlignerNumber}"
    if (tooltipData) {
        const stageNum = tooltipData.startAlignerNumber != null ? tooltipData.startAlignerNumber : "?";
        const tooltipText = `Between ${tooltipData.tooth1}-${tooltipData.tooth2}, ${tooltipData.value} mm IPR performed prior to stage ${stageNum}.`;
        const tooltip = document.createElement("span");
        tooltip.className = "ipr-label-tooltip";
        tooltip.setAttribute("role", "tooltip");
        tooltip.style.cssText = `
      position: absolute;
      left: 50%;
      top: 100%;
      transform: translateX(-50%) translateY(18px);
      padding: 8px 12px;
      background: #b6e9fa;
      color: #424242;
      font-size: 12px;
      font-weight: normal;
      font-family: sans-serif;
      white-space: nowrap;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.15s, visibility 0.15s;
      z-index: 20;
      pointer-events: none;
    `;
        // Caret (upward triangle) at top center of tooltip
        const caret = document.createElement("span");
        caret.style.cssText = `
      position: absolute;
      left: 50%;
      bottom: 100%;
      transform: translateX(-50%);
      border: 6px solid transparent;
      border-top: none;
      border-bottom-color: #b6e9fa;
      width: 0;
      height: 0;
    `;
        tooltip.appendChild(caret);
        tooltip.appendChild(document.createTextNode(tooltipText));
        label.appendChild(tooltip);
        label.addEventListener("mouseenter", ()=>{
            // Elevate this label's stacking context so its tooltip renders above all sibling labels
            label.style.zIndex = "1000";
            diamond.style.outline = "1px solid #e93435";
            diamond.style.outlineOffset = "1px";
            if ($34b3600950cd5660$export$10242fad97d15005()) {
                // In portrait, label has rotate(-90deg). Place tooltip below the label in viewport coords.
                // Use rAF to ensure layout is settled before measuring.
                const portal = $34b3600950cd5660$var$getIPRLabelsOverlay();
                const portraitTooltip = document.createElement("span");
                portraitTooltip.className = "ipr-label-tooltip ipr-portrait-tooltip";
                portraitTooltip.setAttribute("role", "tooltip");
                portraitTooltip.textContent = tooltipText;
                portraitTooltip.style.cssText = `
          position: fixed;
          padding: 4px 6px;
          background: #b6e9fa;
          color: #424242;
          font-size: 9px;
          font-family: sans-serif;
          white-space: nowrap;
          border-radius: 4px;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
          z-index: 20;
          pointer-events: none;
          visibility: hidden;
        `;
                portal.appendChild(portraitTooltip);
                label._portraitTooltip = portraitTooltip;
                requestAnimationFrame(()=>{
                    const rect = label.getBoundingClientRect();
                    const centerX = rect.left + rect.width / 2;
                    const centerY = rect.top + rect.height / 2;
                    // Label has rotate(-90deg). Its local "bottom" (+Y) maps to viewport "left" (-X).
                    // So "below" the diamond (away from line) = offset (-28, 0) in viewport.
                    const tooltipLeft = centerX - 28;
                    const tooltipTop = centerY;
                    portraitTooltip.style.left = `${tooltipLeft}px`;
                    portraitTooltip.style.top = `${tooltipTop}px`;
                    portraitTooltip.style.transform = "translate(-50%, -50%) rotate(90deg)";
                    portraitTooltip.style.transformOrigin = "center center";
                    portraitTooltip.style.visibility = "visible";
                });
            } else {
                tooltip.style.visibility = "visible";
                tooltip.style.opacity = "1";
            }
        });
        label.addEventListener("mouseleave", ()=>{
            label.style.zIndex = "10";
            tooltip.style.visibility = "hidden";
            tooltip.style.opacity = "0";
            diamond.style.outline = "";
            diamond.style.outlineOffset = "";
            if ($34b3600950cd5660$export$10242fad97d15005() && label._portraitTooltip) {
                label._portraitTooltip.remove();
                label._portraitTooltip = null;
            }
        });
    }
    // Append to overlay aligned with the canvas on mobile; otherwise use body
    let appendTarget;
    if ((0, $53de29777cdbd7c8$export$a550975ce732ef83) && window.innerWidth <= 500 && canvasId) {
        const canvas = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId)?.renderer?.domElement;
        const overlay = $34b3600950cd5660$var$getIPRLabelsOverlayForCanvas(canvas);
        appendTarget = overlay || document.body;
        appendTarget.appendChild(label);
    } else {
        appendTarget = document.body;
        appendTarget.appendChild(label);
    }
    return label;
};
const $34b3600950cd5660$export$e4ed0ff6cb6e65c2 = (label, worldPosition, camera, renderer, enableTransition = false)=>{
    if (!label || !worldPosition || !camera || !renderer) return;
    // When camera/view changes we want the label to snap to the line end (no transition). Only aligner changes use transition.
    label.style.transition = enableTransition ? "transform 0.25s ease-out, left 0.25s ease-out, top 0.25s ease-out, opacity 0.2s" : "opacity 0.2s";
    // Convert 3D world position to 2D screen coordinates
    const vector = worldPosition.clone();
    vector.project(camera);
    // Get canvas bounding rect - this gives visual screen position after all transforms
    const canvasRect = renderer.domElement.getBoundingClientRect();
    const isPortraitMode = (0, $53de29777cdbd7c8$export$a550975ce732ef83) && window.innerWidth <= 500;
    let finalX, finalY;
    if (isPortraitMode) {
        // Portrait: labels live in a viewport overlay (document.documentElement), so use viewport
        // coords directly. Canvas is CSS-rotated 90deg CW: (dx,dy) -> (dy,-dx).
        const cw = renderer.domElement.clientWidth;
        const ch = renderer.domElement.clientHeight;
        const canvasLocalX = (vector.x * 0.5 + 0.5) * cw;
        const canvasLocalY = (vector.y * -0.5 + 0.5) * ch;
        const visualCenterX = canvasRect.left + canvasRect.width / 2;
        const visualCenterY = canvasRect.top + canvasRect.height / 2;
        const offsetX = canvasLocalX - cw / 2;
        const offsetY = canvasLocalY - ch / 2;
        const viewportX = visualCenterX + offsetY;
        const viewportY = visualCenterY - offsetX;
        finalX = viewportX;
        finalY = viewportY;
        label.style.position = "fixed";
    } else {
        finalX = (vector.x * 0.5 + 0.5) * renderer.domElement.clientWidth + canvasRect.left;
        finalY = (vector.y * -0.5 + 0.5) * renderer.domElement.clientHeight + canvasRect.top;
        label.style.position = "absolute";
    }
    // Position via translate; no transition when enableTransition is false so label sticks to line end
    label.style.left = isPortraitMode ? "0" : `${canvasRect.left}px`;
    label.style.top = isPortraitMode ? "0" : `${canvasRect.top}px`;
    const tx = isPortraitMode ? finalX : finalX - canvasRect.left;
    const ty = isPortraitMode ? finalY : finalY - canvasRect.top;
    // Outer label: translate only (diamond rotation is on inner element so tooltip stays below in screen space)
    label.style.transform = `translate(${tx}px, ${ty}px) translate(-50%, -50%)`;
    const shouldBeVisible = label.dataset.visible === "true";
    label.style.opacity = shouldBeVisible ? "1" : "0";
};
// ============================================================================
// LINE RENDERING
// ============================================================================
/**
 * Compute IPR line positions (scene-space for line, world for label) between two teeth.
 * Shared by drawIPRLine and updateIPRLineInPlace so positions can be updated without recreating.
 * @returns {{ lineStartPoint: THREE.Vector3, endPoint: THREE.Vector3, labelWorldEnd: THREE.Vector3, midpoint: THREE.Vector3, sceneMidpoint: THREE.Vector3 } | null}
 */ const $34b3600950cd5660$var$computeIPRLinePositions = (scene, tooth1, tooth2, jaw)=>{
    const result = $34b3600950cd5660$var$getMidpointBetweenTeeth(scene, tooth1, tooth2);
    if (!result) return null;
    const { midpoint: midpoint , center1: center1 , center2: center2  } = result;
    const worldToScene = (v)=>new $ilwiq.Vector3(v.y, -v.x, v.z);
    const sceneMidpoint = (0, $53de29777cdbd7c8$export$a550975ce732ef83) ? worldToScene(midpoint) : midpoint.clone();
    const sceneCenter1 = (0, $53de29777cdbd7c8$export$a550975ce732ef83) ? worldToScene(center1) : center1.clone();
    const sceneCenter2 = (0, $53de29777cdbd7c8$export$a550975ce732ef83) ? worldToScene(center2) : center2.clone();
    const tooth1FDI = tooth1.fdiNumber || null;
    const tooth2FDI = tooth2.fdiNumber || null;
    const isAnterior = tooth1FDI && $34b3600950cd5660$var$isAnteriorTooth(tooth1FDI) || tooth2FDI && $34b3600950cd5660$var$isAnteriorTooth(tooth2FDI);
    const direction = $34b3600950cd5660$var$getIPRDirection(jaw, sceneCenter1, sceneCenter2, tooth1FDI, tooth2FDI);
    const directionNormalized = direction.clone().normalize();
    const adjustedDirection = directionNormalized.clone();
    const horizontalMagnitude = Math.sqrt(adjustedDirection.x * adjustedDirection.x + adjustedDirection.z * adjustedDirection.z);
    if (horizontalMagnitude > 0) {
        const targetY = jaw === "LOWER" ? -$34b3600950cd5660$var$IPR_CONFIG.verticalAngleRatio : $34b3600950cd5660$var$IPR_CONFIG.verticalAngleRatio;
        const targetHorizontal = Math.sqrt(1 - targetY * targetY);
        adjustedDirection.x = adjustedDirection.x / horizontalMagnitude * targetHorizontal;
        adjustedDirection.z = adjustedDirection.z / horizontalMagnitude * targetHorizontal;
        adjustedDirection.y = targetY;
        adjustedDirection.normalize();
    }
    const midpointHorizontal = new $ilwiq.Vector3(sceneMidpoint.x, 0, sceneMidpoint.z);
    const midpointHorizontalMagnitude = midpointHorizontal.length();
    if (horizontalMagnitude > 0 && midpointHorizontalMagnitude > 0) {
        const currentHorizontal = new $ilwiq.Vector3(adjustedDirection.x, 0, adjustedDirection.z).normalize();
        const targetHorizontal = midpointHorizontal.normalize();
        const blend = isAnterior ? $34b3600950cd5660$var$IPR_CONFIG.anteriorStraightenFactor : $34b3600950cd5660$var$IPR_CONFIG.horizontalStraightenFactor;
        const blendedHorizontal = currentHorizontal.clone().multiplyScalar(1 - blend).add(targetHorizontal.clone().multiplyScalar(blend)).normalize();
        const targetY = jaw === "LOWER" ? -$34b3600950cd5660$var$IPR_CONFIG.verticalAngleRatio : $34b3600950cd5660$var$IPR_CONFIG.verticalAngleRatio;
        const targetHorizontalMagnitude = Math.sqrt(1 - targetY * targetY);
        adjustedDirection.x = blendedHorizontal.x * targetHorizontalMagnitude;
        adjustedDirection.z = blendedHorizontal.z * targetHorizontalMagnitude;
        adjustedDirection.y = targetY;
        adjustedDirection.normalize();
    }
    const lineStartPoint = new $ilwiq.Vector3();
    lineStartPoint.addVectors(sceneMidpoint, adjustedDirection.clone().multiplyScalar($34b3600950cd5660$var$IPR_CONFIG.gapDistance));
    const endPoint = new $ilwiq.Vector3();
    endPoint.addVectors(lineStartPoint, adjustedDirection.clone().multiplyScalar($34b3600950cd5660$var$IPR_CONFIG.lineLength));
    const sceneToWorld = (v)=>new $ilwiq.Vector3(-v.y, v.x, v.z);
    const labelWorldEnd = (0, $53de29777cdbd7c8$export$a550975ce732ef83) ? sceneToWorld(endPoint) : endPoint.clone();
    return {
        lineStartPoint: lineStartPoint,
        endPoint: endPoint,
        labelWorldEnd: labelWorldEnd,
        midpoint: midpoint,
        sceneMidpoint: sceneMidpoint
    };
};
/**
 * Draw IPR line between two teeth
 * @param {boolean} [isHighlighted] - If true, renders with blue gradient (IPR performed at current aligner)
 * @param {{ tooth1: string, tooth2: string }|null} [clinicalPair] - FDI pair for tooltip/keys when meshes
 *   use a different registered tooth (e.g. line anchored on 12’s mesh for 15–13 IPR)
 */ const $34b3600950cd5660$var$drawIPRLine = (scene, tooth1, tooth2, jaw, value, canvasId = null, startAlignerNum = null, isHighlighted = false, clinicalPair = null)=>{
    const positionsResult = $34b3600950cd5660$var$computeIPRLinePositions(scene, tooth1, tooth2, jaw);
    if (!positionsResult) return null;
    const { lineStartPoint: lineStartPoint , endPoint: endPoint , labelWorldEnd: labelWorldEnd , midpoint: midpoint  } = positionsResult;
    const mesh1FDI = tooth1.fdiNumber != null ? Number(tooth1.fdiNumber) : null;
    const mesh2FDI = tooth2.fdiNumber != null ? Number(tooth2.fdiNumber) : null;
    let toothPair;
    let tooltipTooth1;
    let tooltipTooth2;
    let posteriorsFDI1;
    let posteriorsFDI2;
    if (clinicalPair && clinicalPair.tooth1 != null && clinicalPair.tooth2 != null && clinicalPair.tooth1 !== "" && clinicalPair.tooth2 !== "") {
        const c1 = parseInt(String(clinicalPair.tooth1), 10);
        const c2 = parseInt(String(clinicalPair.tooth2), 10);
        toothPair = [
            c1,
            c2
        ].filter((n)=>!Number.isNaN(n)).sort((a, b)=>a - b).join("-") || "unknown";
        tooltipTooth1 = String(clinicalPair.tooth1);
        tooltipTooth2 = String(clinicalPair.tooth2);
        posteriorsFDI1 = c1;
        posteriorsFDI2 = c2;
    } else {
        toothPair = [
            mesh1FDI,
            mesh2FDI
        ].filter((n)=>n != null && !Number.isNaN(n)).sort((a, b)=>a - b).join("-") || "unknown";
        tooltipTooth1 = mesh1FDI != null ? String(mesh1FDI) : "";
        tooltipTooth2 = mesh2FDI != null ? String(mesh2FDI) : "";
        posteriorsFDI1 = mesh1FDI;
        posteriorsFDI2 = mesh2FDI;
    }
    // Stable id by tooth pair so the same label is reused across aligner changes
    const labelId = `${canvasId}-${toothPair}`;
    const tooltipData = {
        tooth1: tooltipTooth1,
        tooth2: tooltipTooth2,
        value: value,
        startAlignerNumber: startAlignerNum
    };
    const label = $34b3600950cd5660$var$createIPRLabel(value, labelId, canvasId, tooltipData);
    $34b3600950cd5660$var$updateIPRLabelHighlight(label, isHighlighted);
    // Create line geometry
    const positions = [
        lineStartPoint.x,
        lineStartPoint.y,
        lineStartPoint.z,
        endPoint.x,
        endPoint.y,
        endPoint.z
    ];
    const geometry = new (0, $89f44d1a70691651$export$5b1256aa5274bf8)();
    geometry.setPositions(positions);
    // Line always uses the default dark gradient — highlight is applied to the label span only
    const { startRGB: startRGB , endRGB: endRGB  } = $34b3600950cd5660$var$IPR_COLORS.default;
    const colors = new Float32Array([
        ...startRGB,
        ...endRGB
    ]);
    geometry.setColors(colors);
    // Create line material with vertex colors enabled
    const material = new (0, $002da8e8d6c5dd8a$export$d19cd1378966f3d3)({
        color: 0xffffff,
        linewidth: $34b3600950cd5660$var$IPR_CONFIG.lineWidth,
        transparent: false,
        opacity: 1.0,
        depthTest: true,
        depthWrite: true,
        vertexColors: true
    });
    material.resolution.set(window.innerWidth, window.innerHeight);
    // Create line
    const line = new (0, $0a33803082638faa$export$6eda8f258bdba8c5)(geometry, material);
    // Determine which quadrant and horizontal section this IPR line is in
    const quadrant = $34b3600950cd5660$var$getIPRQuadrant(midpoint, jaw);
    const horizontalSection = $34b3600950cd5660$var$getIPRHorizontalSection(midpoint);
    // Determine if this is a posterior (back) IPR line
    const isPosterior = $34b3600950cd5660$var$isPosteriorIPR(posteriorsFDI1, posteriorsFDI2);
    // Make sure line is visible initially
    line.visible = true;
    // Store IPR value as userData for potential future use
    line.userData = {
        iprValue: value,
        tooth1: tooth1,
        tooth2: tooth2,
        material: material,
        type: "ipr-line",
        quadrant: quadrant,
        horizontalSection: horizontalSection,
        isPosterior: isPosterior
    };
    // Store line in the map for visibility updates (toothPair used to update in place on aligner change)
    if (canvasId) {
        if (!$34b3600950cd5660$var$iprLines.has(canvasId)) $34b3600950cd5660$var$iprLines.set(canvasId, []);
        $34b3600950cd5660$var$iprLines.get(canvasId).push({
            line: line,
            quadrant: quadrant,
            horizontalSection: horizontalSection,
            midpoint: midpoint,
            endPoint: labelWorldEnd,
            label: label,
            isPosterior: isPosterior,
            toothPair: toothPair,
            startAligner: startAlignerNum
        });
    }
    // Update resolution on window resize
    const updateResolution = ()=>{
        material.resolution.set(window.innerWidth, window.innerHeight);
    };
    window.addEventListener("resize", updateResolution);
    // Store cleanup function
    line.userData.cleanup = ()=>{
        window.removeEventListener("resize", updateResolution);
    };
    scene.add(line);
    // Initial label position update (after line is in scene so geometry/matrix are valid)
    if (canvasId && label) {
        const { camera: camera , renderer: renderer  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
        if (camera && renderer) {
            if ($34b3600950cd5660$export$10242fad97d15005()) $34b3600950cd5660$export$cd624845698d9c61(label, line, camera, renderer, labelWorldEnd);
            else $34b3600950cd5660$export$e4ed0ff6cb6e65c2(label, labelWorldEnd, camera, renderer);
        }
    }
    return line;
};
/**
 * Update only the vertex colors of an existing IPR line.
 * (Reserved for future use; line color is currently always the default dark gradient.)
 */ const $34b3600950cd5660$var$updateIPRLineColors = (line, isHighlighted)=>{
    if (!line?.geometry) return;
    const { startRGB: startRGB , endRGB: endRGB  } = isHighlighted ? $34b3600950cd5660$var$IPR_COLORS.highlighted : $34b3600950cd5660$var$IPR_COLORS.default;
    const colors = new Float32Array([
        ...startRGB,
        ...endRGB
    ]);
    line.geometry.setColors(colors);
    if (line.geometry.attributes.instanceColorStart) line.geometry.attributes.instanceColorStart.needsUpdate = true;
    if (line.geometry.attributes.instanceColorEnd) line.geometry.attributes.instanceColorEnd.needsUpdate = true;
};
/**
 * Apply or remove the blue highlight on the diamond label span.
 * Highlighted = blue gradient background (IPR performed at exactly this aligner).
 * Default     = white background.
 */ const $34b3600950cd5660$var$updateIPRLabelHighlight = (label, isHighlighted)=>{
    if (!label) return;
    const diamond = label.querySelector("span");
    if (!diamond) return;
    if (isHighlighted) diamond.style.background = "linear-gradient(135deg, #8CCEE6, #6FC3DF)";
    else diamond.style.background = "#ffffff";
};
/**
 * Update an existing IPR line and label to new positions (same tooth pair, new aligner).
 * Uses translate for label position so the transition animates smoothly.
 */ const $34b3600950cd5660$var$updateIPRLineInPlace = (entry, scene, tooth1, tooth2, jaw, canvasId, isHighlighted = false)=>{
    const { line: line , label: label  } = entry;
    const positionsResult = $34b3600950cd5660$var$computeIPRLinePositions(scene, tooth1, tooth2, jaw, false);
    if (!positionsResult || !line?.geometry || !label) return;
    const { lineStartPoint: lineStartPoint , endPoint: endPoint , labelWorldEnd: labelWorldEnd , midpoint: midpoint  } = positionsResult;
    const positions = [
        lineStartPoint.x,
        lineStartPoint.y,
        lineStartPoint.z,
        endPoint.x,
        endPoint.y,
        endPoint.z
    ];
    line.geometry.setPositions(positions);
    if (line.geometry.attributes.instanceStart) line.geometry.attributes.instanceStart.needsUpdate = true;
    if (line.geometry.attributes.instanceEnd) line.geometry.attributes.instanceEnd.needsUpdate = true;
    entry.midpoint = midpoint;
    entry.endPoint = labelWorldEnd;
    const { camera: camera , renderer: renderer  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId) || {};
    if (camera && renderer) {
        // Aligner change: animate label to new position
        if ($34b3600950cd5660$export$10242fad97d15005()) $34b3600950cd5660$export$cd624845698d9c61(label, line, camera, renderer, labelWorldEnd, true);
        else $34b3600950cd5660$export$e4ed0ff6cb6e65c2(label, labelWorldEnd, camera, renderer, true);
    }
    // Update label diamond background to reflect current highlight state
    $34b3600950cd5660$var$updateIPRLabelHighlight(label, isHighlighted);
};
const $34b3600950cd5660$export$433e7512bd0dcc85 = (canvasId, upperAlignerNum = null, lowerAlignerNum = null)=>{
    if (canvasId === "diff-canvas") return;
    // Avoid duplicate IPR: updateIPRPositions runs first (aligner 00); this runs ~500ms later.
    // If we already have entries for this canvas, skip so we don't push duplicate lines/labels.
    if (($34b3600950cd5660$var$iprLines.get(canvasId) || []).length > 0) return;
    const { scene: scene , models: models , modelGeometries: modelGeometries  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId) || {};
    if (!scene || !models || !modelGeometries) return;
    const currentAlignerNum = $34b3600950cd5660$var$getCurrentAlignerNumber(upperAlignerNum, lowerAlignerNum);
    // Aligner 0 is the passive tray — do not draw IPR lines yet
    if (currentAlignerNum === 0) return;
    // Show ALL IPR entries from every layer so they are visible from aligner 1.
    const allEntries = $34b3600950cd5660$var$getAllIprEntriesWithMetadata();
    if (!allEntries.length) return;
    // Process each IPR entry (format: "tooth:value")
    allEntries.forEach(({ entry: entry , startAligner: startAligner  })=>{
        const { tooth1: tooth1Num , tooth2: tooth2Num , value: value  } = $34b3600950cd5660$var$parseIPREntry(entry);
        if (!tooth1Num || !tooth2Num) return;
        // Determine jaw based on FDI numbering
        let jaw = null;
        const tooth1 = parseInt(tooth1Num);
        // Determine jaw from tooth numbers (FDI system)
        if (tooth1 >= 11 && tooth1 <= 28) jaw = "UPPER";
        else if (tooth1 >= 31 && tooth1 <= 48) jaw = "LOWER";
        if (!jaw) return;
        // Get the appropriate aligner number for this jaw
        const alignerNum = jaw === "UPPER" ? upperAlignerNum : lowerAlignerNum;
        const pair = $34b3600950cd5660$var$findIPRMeshPairForCanvas(canvasId, tooth1Num, tooth2Num, jaw, alignerNum);
        if (!pair) return;
        const { t1: t1 , t2: t2 , resolved: resolved  } = pair;
        // Highlight (blue gradient) only at the exact aligner when the IPR is performed
        const isHighlighted = currentAlignerNum === startAligner;
        $34b3600950cd5660$var$drawIPRLine(scene, t1, t2, jaw || "UPPER", value, canvasId, startAligner, isHighlighted, resolved);
    });
    // Respect global IPR toggle: if IPR is disabled, hide the lines we just created
    if (!$34b3600950cd5660$var$iprEnabled) {
        const lines = $34b3600950cd5660$var$iprLines.get(canvasId) || [];
        lines.forEach(({ line: line , label: label  })=>{
            line.visible = false;
            if (label) {
                label.dataset.visible = "false";
                label.style.opacity = "0";
            }
        });
    }
};
const $34b3600950cd5660$export$674503d9eebf00ad = (canvasId, upperAlignerNum, lowerAlignerNum)=>{
    if (canvasId === "diff-canvas") return;
    if (!upperAlignerNum && !lowerAlignerNum) return;
    const { scene: scene  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId) || {};
    if (!scene) return;
    const currentAlignerNum = $34b3600950cd5660$var$getCurrentAlignerNumber(upperAlignerNum, lowerAlignerNum);
    // Aligner 0 is the passive tray — hide everything and bail out without drawing
    if (currentAlignerNum === 0) {
        $34b3600950cd5660$var$lastAlignerByCanvas.set(canvasId, 0);
        const lines = $34b3600950cd5660$var$iprLines.get(canvasId) || [];
        lines.forEach(({ line: line , label: label  })=>{
            line.visible = false;
            if (label) {
                label.dataset.visible = "false";
                label.style.opacity = "0";
            }
        });
        return;
    }
    $34b3600950cd5660$var$lastAlignerByCanvas.set(canvasId, currentAlignerNum);
    // Always work with ALL entries across every layer so every IPR is always visible.
    const allEntries = $34b3600950cd5660$var$getAllIprEntriesWithMetadata();
    const newPairsSet = new Set();
    for (const { entry: entry  } of allEntries){
        const { tooth1: t1s , tooth2: t2s  } = $34b3600950cd5660$var$parseIPREntry(entry);
        if (!t1s || !t2s) continue;
        const t1n = parseInt(t1s, 10);
        let jawForSet = null;
        if (t1n >= 11 && t1n <= 28) jawForSet = "UPPER";
        else if (t1n >= 31 && t1n <= 48) jawForSet = "LOWER";
        if (!jawForSet) continue;
        const alignerForSet = jawForSet === "UPPER" ? upperAlignerNum : lowerAlignerNum;
        const pairForSet = $34b3600950cd5660$var$findIPRMeshPairForCanvas(canvasId, t1s, t2s, jawForSet, alignerForSet);
        if (!pairForSet) continue;
        const a = parseInt(pairForSet.resolved.tooth1, 10);
        const b = parseInt(pairForSet.resolved.tooth2, 10);
        if (Number.isNaN(a) || Number.isNaN(b)) continue;
        newPairsSet.add([
            a,
            b
        ].sort((x, y)=>x - y).join("-"));
    }
    const existing = $34b3600950cd5660$var$iprLines.get(canvasId) || [];
    const existingByPair = new Map();
    existing.forEach((e)=>{
        if (e.toothPair) existingByPair.set(e.toothPair, e);
    });
    for (const { entry: entryStr , startAligner: startAligner  } of allEntries){
        const { tooth1: tooth1Num , tooth2: tooth2Num , value: value  } = $34b3600950cd5660$var$parseIPREntry(entryStr);
        if (!tooth1Num || !tooth2Num) continue;
        let jaw = null;
        const tooth1 = parseInt(tooth1Num, 10);
        if (tooth1 >= 11 && tooth1 <= 28) jaw = "UPPER";
        else if (tooth1 >= 31 && tooth1 <= 48) jaw = "LOWER";
        if (!jaw) continue;
        // Blue highlight only at the exact aligner when the IPR is performed
        const isHighlighted = currentAlignerNum === startAligner;
        const alignerNum = jaw === "UPPER" ? upperAlignerNum : lowerAlignerNum;
        const pair = $34b3600950cd5660$var$findIPRMeshPairForCanvas(canvasId, tooth1Num, tooth2Num, jaw, alignerNum);
        if (!pair) continue;
        const { t1: t1 , t2: t2 , resolved: resolved  } = pair;
        const toothPair = [
            parseInt(resolved.tooth1, 10),
            parseInt(resolved.tooth2, 10)
        ].sort((a, b)=>a - b).join("-");
        const existingEntry = existingByPair.get(toothPair);
        if (!t1 || !t2) {
            // Cannot update position — just refresh the label highlight if entry exists
            if (existingEntry) $34b3600950cd5660$var$updateIPRLabelHighlight(existingEntry.label, isHighlighted);
            continue;
        }
        if (existingEntry) $34b3600950cd5660$var$updateIPRLineInPlace(existingEntry, scene, t1, t2, jaw || "UPPER", canvasId, isHighlighted);
        else $34b3600950cd5660$var$drawIPRLine(scene, t1, t2, jaw || "UPPER", value, canvasId, startAligner, isHighlighted, resolved);
    }
    // Remove only duplicate entries (same toothPair with more than one entry in the list).
    // Lines that have no entry in allEntries (e.g. orphan from a prior session) are also cleaned up.
    const canvasData = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const sceneForCleanup = canvasData?.scene;
    const afterFilter = ($34b3600950cd5660$var$iprLines.get(canvasId) || []).filter((e)=>newPairsSet.has(e.toothPair) && (existingByPair.get(e.toothPair) === e || !existingByPair.has(e.toothPair)));
    const keptSet = new Set(afterFilter);
    ($34b3600950cd5660$var$iprLines.get(canvasId) || []).forEach((e)=>{
        if (keptSet.has(e)) return;
        if (sceneForCleanup && e.line) {
            sceneForCleanup.remove(e.line);
            if (e.line.geometry) e.line.geometry.dispose();
            if (e.line.material) e.line.material.dispose();
            if (e.line.userData?.cleanup) e.line.userData.cleanup();
        }
        if (e.label?.parentNode) e.label.parentNode.removeChild(e.label);
    });
    $34b3600950cd5660$var$iprLines.set(canvasId, afterFilter);
    if (!$34b3600950cd5660$var$iprEnabled) {
        const lines = $34b3600950cd5660$var$iprLines.get(canvasId) || [];
        lines.forEach(({ line: line , label: label  })=>{
            line.visible = false;
            if (label) {
                label.dataset.visible = "false";
                label.style.opacity = "0";
            }
        });
    } else $34b3600950cd5660$export$127367bf4516af82(canvasId);
};
const $34b3600950cd5660$export$3ca5463dd74f6337 = (canvasId)=>{
    const { scene: scene  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const iprLines = [];
    scene.traverse((obj)=>{
        if (obj.userData && obj.userData.type === "ipr-line") iprLines.push(obj);
    });
    return iprLines;
};
const $34b3600950cd5660$export$ca76157782273601 = (canvasId, toothNum, tooth2Num = null, jaw = null)=>{
    const { scene: scene , models: models , modelGeometries: modelGeometries  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    if (!scene || !models || !modelGeometries) return null;
    // Get the first aligner (usually "00" or "0") - use the active aligner
    const upperModels = models.UPPER;
    const lowerModels = models.LOWER;
    // Try to find in both jaws or specified jaw
    const jawsToSearch = jaw ? [
        {
            name: jaw.toUpperCase(),
            models: jaw === "UPPER" ? upperModels : lowerModels
        }
    ] : [
        {
            name: "UPPER",
            models: upperModels
        },
        {
            name: "LOWER",
            models: lowerModels
        }
    ];
    for (const { name: jawName , models: jawModels  } of jawsToSearch){
        if (!jawModels) continue;
        // Get first aligner (usually "00")
        const alignerKeys = Object.keys(jawModels).sort((a, b)=>{
            const numA = parseInt(a) || 0;
            const numB = parseInt(b) || 0;
            return numA - numB;
        });
        if (alignerKeys.length === 0) continue;
        const firstAligner = alignerKeys[0];
        const aligner = jawModels[firstAligner];
        if (!aligner || !aligner.teeth || !aligner.teeth.length) continue;
        const teeth = aligner.teeth;
        const geometries = modelGeometries[jawName]?.[firstAligner]?.teeth;
        if (!geometries || geometries.length === 0) continue;
        // For now, as a fallback, we'll use indices based on tooth number
        // This is a simplified heuristic - in production you'd need proper mapping
        // Try to map FDI number to index (this is a rough approximation)
        const toothIndex = parseInt(toothNum) % 10; // Use last digit as rough index
        if (toothIndex >= 0 && toothIndex < teeth.length) return {
            material: teeth[toothIndex],
            geometry: geometries[toothIndex]
        };
        // If index doesn't work, return first tooth as fallback
        if (teeth.length > 0) return {
            material: teeth[0],
            geometry: geometries[0]
        };
    }
    return null;
};



let $3824e294ef8e8757$var$movementTableData = null;
let $3824e294ef8e8757$var$activeJaw = "upper";
const $3824e294ef8e8757$export$959c849be6a3e178 = (data)=>{
    $3824e294ef8e8757$var$movementTableData = data || null;
    // Default to whichever jaw has data
    if ($3824e294ef8e8757$var$movementTableData) {
        if (Array.isArray($3824e294ef8e8757$var$movementTableData.upper) && $3824e294ef8e8757$var$movementTableData.upper.length) $3824e294ef8e8757$var$activeJaw = "upper";
        else if (Array.isArray($3824e294ef8e8757$var$movementTableData.lower) && $3824e294ef8e8757$var$movementTableData.lower.length) $3824e294ef8e8757$var$activeJaw = "lower";
    }
    $3824e294ef8e8757$var$renderMovementTable();
    $3824e294ef8e8757$var$syncJawToggleButtons();
};
const $3824e294ef8e8757$export$8b841b601c1682f1 = ()=>{
    if (!$3824e294ef8e8757$var$movementTableData) return false;
    const u = Array.isArray($3824e294ef8e8757$var$movementTableData.upper) ? $3824e294ef8e8757$var$movementTableData.upper.length : 0;
    const l = Array.isArray($3824e294ef8e8757$var$movementTableData.lower) ? $3824e294ef8e8757$var$movementTableData.lower.length : 0;
    return u + l > 0;
};
const $3824e294ef8e8757$var$ROWS = [
    {
        label: "Extrusion(E)/Intrusion(I)",
        key: "E | I"
    },
    {
        label: "Translation \xa0Buccal(B)/Lingual(L)",
        key: "B | L"
    },
    {
        label: "Translation \xa0Mesial(M)/Distal(D)",
        key: "M | D"
    },
    {
        label: "Rotation \xa0Mesial(M)/Distal(D)",
        key: "R"
    },
    {
        label: "Angulation \xa0Mesial(M)/Distal(D)",
        key: "Ti"
    },
    {
        label: "Torque \xa0Buccal(B)/Lingual(L)",
        key: "To"
    }
];
// Sort teeth in dental-chart order:
// - upper: 1x descending (18..11) then 2x ascending (21..28)
// - lower: 4x descending (48..41) then 3x ascending (31..38)
function $3824e294ef8e8757$var$sortTeeth(rows, jaw) {
    const rightQuad = jaw === "upper" ? 1 : 4;
    const leftQuad = jaw === "upper" ? 2 : 3;
    return rows.slice().sort((a, b)=>{
        const aQ = Math.floor(a.tooth / 10);
        const bQ = Math.floor(b.tooth / 10);
        if (aQ === rightQuad && bQ === leftQuad) return -1;
        if (aQ === leftQuad && bQ === rightQuad) return 1;
        if (aQ === rightQuad) return b.tooth - a.tooth;
        return a.tooth - b.tooth;
    });
}
function $3824e294ef8e8757$var$formatValue(v) {
    if (v == null || v === "") return "0";
    return String(v);
}
function $3824e294ef8e8757$var$renderMovementTable() {
    const container = document.getElementById("movement-table-container");
    if (!container) return;
    if (!$3824e294ef8e8757$var$movementTableData) {
        container.innerHTML = '<p class="movement-empty">No movement data available.</p>';
        return;
    }
    const rawRows = Array.isArray($3824e294ef8e8757$var$movementTableData[$3824e294ef8e8757$var$activeJaw]) ? $3824e294ef8e8757$var$movementTableData[$3824e294ef8e8757$var$activeJaw] : [];
    if (!rawRows.length) {
        container.innerHTML = `<p class="movement-empty">No ${$3824e294ef8e8757$var$activeJaw} movement data available.</p>`;
        return;
    }
    const teeth = $3824e294ef8e8757$var$sortTeeth(rawRows, $3824e294ef8e8757$var$activeJaw);
    const headerCells = teeth.map((r)=>`<th class="tooth-col">${r.tooth}</th>`).join("");
    const headerRow = `<tr><th class="row-label"></th>${headerCells}</tr>`;
    const bodyRows = $3824e294ef8e8757$var$ROWS.map((row)=>{
        const cells = teeth.map((toothRow)=>`<td class="value-cell">${$3824e294ef8e8757$var$formatValue(toothRow[row.key])}</td>`).join("");
        return `<tr><th class="row-label">${row.label}</th>${cells}</tr>`;
    }).join("");
    container.innerHTML = `
    <table class="movement-table">
      <thead>${headerRow}</thead>
      <tbody>${bodyRows}</tbody>
    </table>
  `;
}
function $3824e294ef8e8757$var$syncJawToggleButtons() {
    document.querySelectorAll(".movement-jaw-toggle").forEach((btn)=>{
        btn.classList.toggle("active", btn.dataset.jaw === $3824e294ef8e8757$var$activeJaw);
    });
}
function $3824e294ef8e8757$var$setActiveJaw(jaw) {
    if (jaw !== "upper" && jaw !== "lower") return;
    $3824e294ef8e8757$var$activeJaw = jaw;
    $3824e294ef8e8757$var$renderMovementTable();
    $3824e294ef8e8757$var$syncJawToggleButtons();
}
// Drive a window-resize on every animation frame for `durationMs` so the
// three.js canvas keeps in step with the renderer-container's CSS max-height
// transition. After each resize we synchronously re-render every canvas:
// renderer.setSize() clears the WebGL buffer, and the main render rAF
// (registered at startup) fires before this tick each frame, so without an
// immediate re-paint the browser would composite an empty buffer and the
// models would flicker out for the duration of the animation.
function $3824e294ef8e8757$var$driveResizeDuringTransition(durationMs) {
    const start = performance.now();
    const tick = (now)=>{
        window.dispatchEvent(new Event("resize"));
        (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().forEach(({ renderer: renderer , scene: scene , camera: camera , overlayScene: overlayScene , overlayCamera: overlayCamera  })=>{
            if (!renderer || !scene || !camera) return;
            renderer.render(scene, camera);
            if (overlayScene && overlayCamera) {
                renderer.autoClear = false;
                renderer.render(overlayScene, overlayCamera);
                renderer.autoClear = true;
            }
        });
        if (now - start < durationMs) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
}
function $3824e294ef8e8757$export$8e10d974bd166d8b() {
    const panel = document.getElementById("movement-panel");
    if (!panel) return;
    document.body.classList.add("movement-panel-open");
    panel.classList.add("open");
    panel.setAttribute("aria-hidden", "false");
    $3824e294ef8e8757$var$driveResizeDuringTransition(320);
}
function $3824e294ef8e8757$export$41ff6675e1d1082c() {
    const panel = document.getElementById("movement-panel");
    if (!panel) return;
    document.body.classList.remove("movement-panel-open");
    panel.classList.remove("open");
    panel.setAttribute("aria-hidden", "true");
    $3824e294ef8e8757$var$driveResizeDuringTransition(320);
}
function $3824e294ef8e8757$export$4b4dc9e6c29d1e0() {
    const panel = document.getElementById("movement-panel");
    return !!panel && panel.classList.contains("open");
}
function $3824e294ef8e8757$export$21b11519d69ebe5f() {
    if ($3824e294ef8e8757$export$4b4dc9e6c29d1e0()) $3824e294ef8e8757$export$41ff6675e1d1082c();
    else $3824e294ef8e8757$export$8e10d974bd166d8b();
}
function $3824e294ef8e8757$export$a08888547b7e2f4e() {
    const panel = document.getElementById("movement-panel");
    if (!panel) return;
    panel.querySelectorAll(".movement-jaw-toggle").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            $3824e294ef8e8757$var$setActiveJaw(btn.dataset.jaw);
        });
    });
    const closeBtn = panel.querySelector(".movement-panel-close");
    if (closeBtn) closeBtn.addEventListener("click", ()=>$3824e294ef8e8757$export$41ff6675e1d1082c());
    $3824e294ef8e8757$var$syncJawToggleButtons();
    $3824e294ef8e8757$var$renderMovementTable();
}


const $6e53177b5afd7211$var$progressBar = new $fTNTF.Circle("#loader", {
    strokeWidth: 4,
    color: "#088cfe",
    text: {
        value: "1%",
        className: "progressbar-label"
    }
});
const $6e53177b5afd7211$var$loadingManager = new $ilwiq.LoadingManager();
const { gums: $6e53177b5afd7211$var$gums , teeth: $6e53177b5afd7211$var$teeth , attachments: $6e53177b5afd7211$var$attachments  } = (0, $14c6e27f5c489006$export$d5abd5dd7869e8af).plyFiles;
let $6e53177b5afd7211$var$upperActiveNum = "";
let $6e53177b5afd7211$var$lowerActiveNum = "";
const $6e53177b5afd7211$export$8562905f6f910168 = ()=>{
    return {
        upperActiveNum: $6e53177b5afd7211$var$upperActiveNum,
        lowerActiveNum: $6e53177b5afd7211$var$lowerActiveNum
    };
};
const $6e53177b5afd7211$var$TOOTH_DEFAULT_COLOR = "#FFFFF8";
const $6e53177b5afd7211$var$TOOTH_HIGHLIGHT_COLOR = "#6ECFD4";
let $6e53177b5afd7211$var$selectedTooth = null; // { jaw, toothIdx }
const $6e53177b5afd7211$var$applyToothHighlightToCanvas = (canvasId, jaw, toothIdx, highlighted)=>{
    const data = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    if (!data?.models?.[jaw]) return;
    Object.values(data.models[jaw]).forEach((aligner)=>{
        const mat = aligner.teeth?.[toothIdx];
        if (!mat) return;
        mat.color.set(highlighted ? $6e53177b5afd7211$var$TOOTH_HIGHLIGHT_COLOR : $6e53177b5afd7211$var$TOOTH_DEFAULT_COLOR);
        mat.userData.isHighlighted = highlighted;
    });
};
const $6e53177b5afd7211$export$45748d719456834d = (jaw, toothIdx, highlighted)=>{
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().forEach(({ id: id  })=>{
        $6e53177b5afd7211$var$applyToothHighlightToCanvas(id, jaw, toothIdx, highlighted);
    });
};
const $6e53177b5afd7211$export$2aa08e9886547e7a = (jaw, toothIdx)=>{
    const isSame = $6e53177b5afd7211$var$selectedTooth?.jaw === jaw && $6e53177b5afd7211$var$selectedTooth?.toothIdx === toothIdx;
    if ($6e53177b5afd7211$var$selectedTooth) {
        $6e53177b5afd7211$export$45748d719456834d($6e53177b5afd7211$var$selectedTooth.jaw, $6e53177b5afd7211$var$selectedTooth.toothIdx, false);
        $6e53177b5afd7211$var$selectedTooth = null;
    }
    if (!isSame) {
        $6e53177b5afd7211$var$selectedTooth = {
            jaw: jaw,
            toothIdx: toothIdx
        };
        $6e53177b5afd7211$export$45748d719456834d(jaw, toothIdx, true);
    }
};
const $6e53177b5afd7211$export$3990fc6c32c26aba = ()=>{
    if (!$6e53177b5afd7211$var$selectedTooth) return;
    $6e53177b5afd7211$export$45748d719456834d($6e53177b5afd7211$var$selectedTooth.jaw, $6e53177b5afd7211$var$selectedTooth.toothIdx, false);
    $6e53177b5afd7211$var$selectedTooth = null;
};
let $6e53177b5afd7211$var$_isCompressed = false;
const $6e53177b5afd7211$var$generatedModelUrls = [];
const $6e53177b5afd7211$var$modelUrlMeta = new Map();
let $6e53177b5afd7211$var$_preModelProgress = 0;
const $6e53177b5afd7211$var$normalizeAlignerNum = (rawNum)=>{
    if (rawNum == null) return null;
    const normalized = String(rawNum).trim();
    const numericPrefix = normalized.match(/^\d+/)?.[0];
    if (!numericPrefix) return normalized;
    return String(parseInt(numericPrefix, 10)).padStart(2, "0");
};
const $6e53177b5afd7211$var$parseModelMetaFromPath = (filePath)=>{
    const normalized = decodeURIComponent(filePath).replaceAll("\\", "/");
    const parts = normalized.split("/").filter(Boolean);
    const typeIdx = parts.findIndex((part)=>{
        const value = part.toLowerCase();
        return value === "upper" || value === "lower";
    });
    if (typeIdx === -1 || !parts[typeIdx + 1]) return null;
    return {
        type: parts[typeIdx].toUpperCase(),
        num: $6e53177b5afd7211$var$normalizeAlignerNum(parts[typeIdx + 1])
    };
};
const $6e53177b5afd7211$var$getModelMeta = (modelUrl)=>{
    const fromZip = $6e53177b5afd7211$var$modelUrlMeta.get(modelUrl);
    if (fromZip) return fromZip;
    return $6e53177b5afd7211$var$parseModelMetaFromPath(modelUrl);
};
const $6e53177b5afd7211$var$addFileToBuckets = (fileUrl, fileName)=>{
    const lowerCaseName = fileName.toLowerCase();
    if (lowerCaseName.includes("template")) return;
    if (lowerCaseName.includes("attachment")) $6e53177b5afd7211$var$attachments.push(fileUrl);
    if (lowerCaseName.includes("tooth")) $6e53177b5afd7211$var$teeth.push(fileUrl);
    if (lowerCaseName.includes("gum")) $6e53177b5afd7211$var$gums.push(fileUrl);
};
const $6e53177b5afd7211$var$extractModelsFromZip = async (zipFileUrl, onDownloadProgress, onExtractProgress)=>{
    let bestKnownDownloadRatio = 0;
    let hasExactProgress = false;
    let lastProgressEventAt = Date.now();
    const reportDownloadProgress = (ratio)=>{
        const clamped = Math.max(0, Math.min(1, ratio));
        if (clamped < bestKnownDownloadRatio) return;
        bestKnownDownloadRatio = clamped;
        onDownloadProgress?.(bestKnownDownloadRatio);
    };
    // Fallback only when total size is unknown and events are sparse.
    const fallbackTimer = setInterval(()=>{
        if (hasExactProgress) return;
        if (bestKnownDownloadRatio >= 0.95) return;
        const elapsedSinceEvent = Date.now() - lastProgressEventAt;
        if (elapsedSinceEvent < 1200) return;
        reportDownloadProgress(bestKnownDownloadRatio + 0.005);
    }, 450);
    const { data: zipBuffer  } = await (0, $fmRoT.default).get(zipFileUrl, {
        responseType: "arraybuffer",
        onDownloadProgress: (e)=>{
            lastProgressEventAt = Date.now();
            if (e.total) {
                hasExactProgress = true;
                reportDownloadProgress(e.loaded / e.total);
            } else if (e.loaded) // No total available (chunked encoding): conservative estimate to avoid
            // getting far ahead and stalling at a high percentage.
            reportDownloadProgress(Math.min(0.95, 0.02 + e.loaded / 52428800 * 0.93));
        }
    });
    clearInterval(fallbackTimer);
    reportDownloadProgress(1);
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($ff323866fb43afa6$exports))).loadAsync(zipBuffer);
    const extractedFiles = [];
    let hasCompressedFiles = false;
    const zipEntries = Object.keys(zip.files);
    let processedEntries = 0;
    for (const entryName of zipEntries){
        const entry = zip.files[entryName];
        processedEntries++;
        if (entry.dir) continue;
        const lowerCaseName = entry.name.toLowerCase();
        if (!lowerCaseName.endsWith(".crt") && !lowerCaseName.endsWith(".ply")) continue;
        const modelMeta = $6e53177b5afd7211$var$parseModelMetaFromPath(entry.name);
        if (!modelMeta) continue;
        const fileBuffer = await entry.async("arraybuffer");
        const objectUrl = URL.createObjectURL(new Blob([
            fileBuffer
        ], {
            type: "application/octet-stream"
        }));
        $6e53177b5afd7211$var$generatedModelUrls.push(objectUrl);
        $6e53177b5afd7211$var$modelUrlMeta.set(objectUrl, {
            ...modelMeta,
            sourceName: entry.name
        });
        extractedFiles.push({
            url: objectUrl,
            name: lowerCaseName
        });
        if (lowerCaseName.endsWith(".crt")) hasCompressedFiles = true;
        if (zipEntries.length) onExtractProgress?.(processedEntries / zipEntries.length);
    }
    onExtractProgress?.(1);
    return {
        extractedFiles: extractedFiles,
        hasCompressedFiles: hasCompressedFiles
    };
};
const $6e53177b5afd7211$var$cleanupGeneratedModelUrls = ()=>{
    $6e53177b5afd7211$var$generatedModelUrls.forEach((url)=>URL.revokeObjectURL(url));
    $6e53177b5afd7211$var$generatedModelUrls.length = 0;
    $6e53177b5afd7211$var$modelUrlMeta.clear();
};
const $6e53177b5afd7211$var$ZIP_DOWNLOAD_START = 0.01; // 1%
const $6e53177b5afd7211$var$ZIP_DOWNLOAD_END = 0.75; // 75%
const $6e53177b5afd7211$var$ZIP_EXTRACT_WEIGHT = 0.15; // 75–90% for zip extraction
/**
 * Union of missing FDI numbers from API root and from each treatment layer.
 * N-layers / PDF extraction uses per-layer `missingTooth`; older payloads use top-level `missingTeeth`.
 */ const $6e53177b5afd7211$var$collectMissingTeethFromLayersPayload = (missingTeethRoot, layers)=>{
    const missingSet = new Set();
    if (Array.isArray(missingTeethRoot)) for (const n of missingTeethRoot){
        const v = parseInt(n, 10);
        if (!Number.isNaN(v)) missingSet.add(v);
    }
    if (layers && typeof layers === "object") for (const layer of Object.values(layers)){
        const arr = layer?.missingTooth ?? layer?.missingTeeth;
        if (Array.isArray(arr)) for (const n of arr){
            const v = parseInt(n, 10);
            if (!Number.isNaN(v)) missingSet.add(v);
        }
    }
    return [
        ...missingSet
    ];
};
const $6e53177b5afd7211$var$fetchFiles = async (onZipDownloadProgress, onZipExtractProgress)=>{
    // progressBar.destroy();
    // document.getElementById("loader-container").style.display = "none";
    // return;
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    const { data: data  } = await (0, $fmRoT.default).get(`${"/api/v3/zenyum/dental-viewer"}/ply-files?id=${id}`);
    const { plyFiles: files = [] , zipFile: zipFile , isCompressed: isCompressed , pdfLinks: pdfLinks , layers: layers , patientName: patientName , movementTable: movementTable  } = data.data;
    if (isCompressed) $6e53177b5afd7211$var$_isCompressed = isCompressed;
    const mergedMissing = $6e53177b5afd7211$var$collectMissingTeethFromLayersPayload(data.data.missingTeeth, layers);
    (0, $34b3600950cd5660$export$97f48d371494f63c)(layers);
    (0, $34b3600950cd5660$export$80c2ac620393e8b7)(mergedMissing);
    (0, $3824e294ef8e8757$export$959c849be6a3e178)(movementTable);
    document.body.dataset.customerId = data.data.mobileOrUid;
    document.getElementById("customerId").textContent = data.data.mobileOrUid;
    if (data.data.mobileOrUid) document.title = data.data.mobileOrUid;
    if (data.data.planName) document.getElementById("planName").textContent = data.data.planName;
    if (data.data.planNo) document.getElementById("planNo").textContent = `Design No: ${data.data.planNo}`;
    const patientNameEl = document.getElementById("patientName");
    if (patientNameEl && patientName) patientNameEl.textContent = patientName;
    let hasFilesFromZip = false;
    if (zipFile && data?.data?.isCompressed) try {
        const { extractedFiles: extractedFiles , hasCompressedFiles: hasCompressedFiles  } = await $6e53177b5afd7211$var$extractModelsFromZip(zipFile, onZipDownloadProgress, onZipExtractProgress);
        extractedFiles.forEach((file)=>$6e53177b5afd7211$var$addFileToBuckets(file.url, file.name));
        hasFilesFromZip = extractedFiles.length > 0;
        if (hasCompressedFiles) $6e53177b5afd7211$var$_isCompressed = true;
    } catch (err) {
        console.log("Failed to extract zip file", err);
    }
    if (!hasFilesFromZip) files.forEach((file)=>$6e53177b5afd7211$var$addFileToBuckets(file, file));
    $6e53177b5afd7211$var$updatePdfLinkModalContent(pdfLinks ?? {});
};
const $6e53177b5afd7211$var$addLoadedModelsToScene = (canvasId, scene)=>{
    if (!(0, $14c6e27f5c489006$export$d5abd5dd7869e8af).areFilesLoaded || !(0, $14c6e27f5c489006$export$d5abd5dd7869e8af).modelsObjectCache.length) return;
    const defaultCanvasId = "canvas";
    const { models: defaultModels , modelGeometries: defaultModelGeometries  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(defaultCanvasId);
    // Build a fresh structure so each aligner index has its own object. Using
    // cloneDeep(defaultModels) would make filled indices (e.g. UPPER["03"], ["04"])
    // share the same object as the last real index (["02"]), so assigning .gumMesh
    // per key would overwrite the shared object and leave orphan meshes in the scene.
    const newModels = {
        UPPER: {},
        LOWER: {}
    };
    const newSuperImpositions = {};
    Object.entries(defaultModels).forEach(([jaw, aligners])=>{
        Object.entries(aligners).forEach(([alignerNum, parts])=>{
            const slot = {};
            newModels[jaw][alignerNum] = slot;
            if (parts.gum) {
                const clonedMaterial = parts.gum.clone();
                clonedMaterial.visible = false;
                const gumMesh = new $ilwiq.Mesh(defaultModelGeometries[jaw][alignerNum].gum.clone(), clonedMaterial);
                gumMesh.visible = false;
                scene.add(gumMesh);
                slot.gum = clonedMaterial;
                slot.gumMesh = gumMesh;
            }
            if (parts.teeth) {
                slot.teeth = [];
                parts.teeth.forEach((tooth, idx)=>{
                    const clonedMaterial = tooth.clone();
                    clonedMaterial.visible = false;
                    const toothMesh = new $ilwiq.Mesh(defaultModelGeometries[jaw][alignerNum]["teeth"][idx].clone(), clonedMaterial);
                    toothMesh.userData.type = "tooth";
                    toothMesh.userData.toothId = {
                        jaw: jaw,
                        toothIdx: idx
                    };
                    scene.add(toothMesh);
                    slot.teeth[idx] = clonedMaterial;
                    if (alignerNum === "00") {
                        if (!newSuperImpositions[jaw]) newSuperImpositions[jaw] = [];
                        newSuperImpositions[jaw].push(clonedMaterial);
                    }
                });
            }
            if (parts.attachments) {
                slot.attachments = [];
                parts.attachments.forEach((attachment, idx)=>{
                    const clonedMaterial = attachment.clone();
                    clonedMaterial.visible = false;
                    scene.add(new $ilwiq.Mesh(defaultModelGeometries[jaw][alignerNum]["attachments"][idx].clone(), clonedMaterial));
                    slot.attachments[idx] = clonedMaterial;
                });
            }
        });
    });
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        models: newModels,
        superImpositions: newSuperImpositions
    });
    // Re-apply tooth highlight to this new canvas if one is already selected
    if ($6e53177b5afd7211$var$selectedTooth) $6e53177b5afd7211$var$applyToothHighlightToCanvas(canvasId, $6e53177b5afd7211$var$selectedTooth.jaw, $6e53177b5afd7211$var$selectedTooth.toothIdx, true);
};
const $6e53177b5afd7211$export$bab4cdd81fcf11a4 = async (canvasId, scene)=>{
    if ((0, $14c6e27f5c489006$export$d5abd5dd7869e8af).areFilesLoaded) {
        $6e53177b5afd7211$var$addLoadedModelsToScene(canvasId, scene);
        return;
    }
    $6e53177b5afd7211$var$_preModelProgress = 0;
    await $6e53177b5afd7211$var$_loadModels(canvasId, scene, (itemsLoaded, itemsTotal)=>{
        if ((0, $14c6e27f5c489006$export$d5abd5dd7869e8af).areFilesLoaded) return;
        const loadRatio = itemsLoaded / itemsTotal;
        const overallProgress = $6e53177b5afd7211$var$_preModelProgress + loadRatio * (1 - $6e53177b5afd7211$var$_preModelProgress);
        $6e53177b5afd7211$var$progressBar.animate(overallProgress, {
            duration: 300
        });
        $6e53177b5afd7211$var$progressBar.setText(`${Math.ceil(overallProgress * 100)}%`);
    });
};
const $6e53177b5afd7211$var$_loadModels = async (canvasId, scene, onProgress)=>{
    if (!(0, $14c6e27f5c489006$export$d5abd5dd7869e8af).areFilesLoaded) {
        const onZipDownloadProgress = (ratio)=>{
            if ((0, $14c6e27f5c489006$export$d5abd5dd7869e8af).areFilesLoaded) return;
            $6e53177b5afd7211$var$_preModelProgress = $6e53177b5afd7211$var$ZIP_DOWNLOAD_START + ratio * ($6e53177b5afd7211$var$ZIP_DOWNLOAD_END - $6e53177b5afd7211$var$ZIP_DOWNLOAD_START);
            $6e53177b5afd7211$var$progressBar.animate($6e53177b5afd7211$var$_preModelProgress, {
                duration: 150
            });
            $6e53177b5afd7211$var$progressBar.setText(`${Math.ceil($6e53177b5afd7211$var$_preModelProgress * 100)}%`);
        };
        const onZipExtractProgress = (ratio)=>{
            if ((0, $14c6e27f5c489006$export$d5abd5dd7869e8af).areFilesLoaded) return;
            $6e53177b5afd7211$var$_preModelProgress = $6e53177b5afd7211$var$ZIP_DOWNLOAD_END + ratio * $6e53177b5afd7211$var$ZIP_EXTRACT_WEIGHT;
            $6e53177b5afd7211$var$progressBar.animate($6e53177b5afd7211$var$_preModelProgress, {
                duration: 120
            });
            $6e53177b5afd7211$var$progressBar.setText(`${Math.ceil($6e53177b5afd7211$var$_preModelProgress * 100)}%`);
        };
        await $6e53177b5afd7211$var$fetchFiles(onZipDownloadProgress, onZipExtractProgress);
    }
    const addToothModelToScene = (geometry)=>{
        geometry.computeVertexNormals();
        const material = new $ilwiq.MeshPhysicalMaterial({
            color: "#FFFFF8",
            roughness: 0.15,
            metalness: 0,
            clearcoat: 0.8,
            clearcoatRoughness: 0.1,
            reflectivity: 0.9,
            envMapIntensity: 1.2,
            side: $ilwiq.DoubleSide,
            // transmission: 0.1, // Slight translucency
            thickness: 1.0,
            ior: 1.5
        });
        // material.flatShading = false;
        // material.side = THREE.DoubleSide;
        material.visible = false;
        const mesh = new $ilwiq.Mesh(geometry, material);
        mesh.userData.type = "tooth";
        // mesh.doubleSided = true;
        // mesh.castShadow = true;
        // mesh.receiveShadow = true;
        scene.add(mesh);
        (0, $14c6e27f5c489006$export$d5abd5dd7869e8af).modelsObjectCache.push(mesh.clone(true));
        return {
            geometry: geometry,
            material: material,
            mesh: mesh
        };
    };
    const addAttachmentModelToScene = (geometry)=>{
        geometry.computeVertexNormals();
        const material = new $ilwiq.MeshPhysicalMaterial({
            color: "#e57f82"
        });
        material.flatShading = false;
        material.side = $ilwiq.DoubleSide;
        material.visible = false;
        const mesh = new $ilwiq.Mesh(geometry, material);
        scene.add(mesh);
        (0, $14c6e27f5c489006$export$d5abd5dd7869e8af).modelsObjectCache.push(mesh.clone(true));
        return {
            geometry: geometry,
            material: material
        };
    };
    const addGumModelToScene = (geometry)=>{
        geometry.computeVertexNormals();
        const material = new $ilwiq.MeshPhysicalMaterial({
            color: "#e57f82",
            roughness: 0.35,
            metalness: 0,
            clearcoat: 0.3,
            clearcoatRoughness: 0.2,
            reflectivity: 0.5,
            envMapIntensity: 0.8,
            side: $ilwiq.DoubleSide
        });
        material.flatShading = false;
        material.side = $ilwiq.DoubleSide;
        material.visible = false;
        const mesh = new $ilwiq.Mesh(geometry, material);
        mesh.doubleSided = true;
        mesh.castShadow = true;
        mesh.receiveShadow = true;
        scene.add(mesh);
        (0, $14c6e27f5c489006$export$d5abd5dd7869e8af).modelsObjectCache.push(mesh.clone(true));
        return {
            geometry: geometry,
            material: material
        };
    };
    const loader = $6e53177b5afd7211$var$_isCompressed ? new (0, $835522ae6eafc86c$export$e6c0a4d92bb85d0b)($6e53177b5afd7211$var$loadingManager) : new (0, $hKOBv.PLYLoader)($6e53177b5afd7211$var$loadingManager);
    const addMaterial = (canvasId, modelUrl, material, modelType, geometry)=>{
        let { models: models , modelGeometries: modelGeometries  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
        if (!models) models = {};
        if (!modelGeometries) modelGeometries = {};
        if (modelUrl.includes("segmented")) modelUrl = modelUrl.replace("%20segmented", "");
        const modelMeta = $6e53177b5afd7211$var$getModelMeta(modelUrl);
        const type = modelMeta?.type;
        const num = modelMeta?.num;
        if (!type || !num) return;
        if (!models[type]) models[type] = {};
        if (!modelGeometries[type]) modelGeometries[type] = {};
        if (!models[type][num]) models[type][num] = {};
        if (!modelGeometries[type][num]) modelGeometries[type][num] = {};
        if (modelType === "gum") {
            models[type][num][modelType] = material;
            modelGeometries[type][num][modelType] = geometry;
            (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
                models: models,
                modelGeometries: modelGeometries
            });
            return;
        }
        if (!models[type][num]?.[modelType]) models[type][num][modelType] = [];
        if (!modelGeometries[type][num]?.[modelType]) modelGeometries[type][num][modelType] = [];
        models[type][num][modelType].push(material);
        modelGeometries[type][num][modelType].push(geometry);
        (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
            models: models,
            modelGeometries: modelGeometries
        });
    };
    let itemsLoaded = 0;
    const itemsTotal = $6e53177b5afd7211$var$teeth.length + $6e53177b5afd7211$var$gums.length + $6e53177b5afd7211$var$attachments.length;
    const chunkSize = 12;
    for(let i = 0; i < $6e53177b5afd7211$var$teeth.length; i = i + chunkSize){
        const teethModelChunk = [];
        const teethModelPromise = [];
        for(let j = i; j < $6e53177b5afd7211$var$teeth.length && j < i + chunkSize; j++){
            teethModelChunk.push($6e53177b5afd7211$var$teeth[j]);
            teethModelPromise.push(loader.loadAsync($6e53177b5afd7211$var$teeth[j]));
            itemsLoaded++;
        }
        const teethGeometry = await Promise.all(teethModelPromise);
        teethGeometry.forEach((geometry, idx)=>{
            const { geometry: _geometry , material: material , mesh: mesh  } = addToothModelToScene(geometry);
            const modelUrl = teethModelChunk[idx];
            addMaterial(canvasId, modelUrl, material, "teeth", _geometry);
            // Extract jaw and aligner number from URL for tooth registration
            const modelMeta = $6e53177b5afd7211$var$getModelMeta(modelUrl);
            const jaw = modelMeta?.type;
            const alignerNum = modelMeta?.num;
            const sourceNameForToothMapping = modelMeta?.sourceName || modelUrl;
            // Tag mesh with identity so raycasting can identify the tooth.
            // Read the index from the materials array that addMaterial just pushed
            // into — without a fallback, so a missing array surfaces as a visible
            // bug rather than silently colliding with tooth index 0.
            if (jaw && alignerNum) {
                const { models: models  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
                const teethArr = models?.[jaw]?.[alignerNum]?.teeth;
                if (Array.isArray(teethArr) && teethArr.length > 0) mesh.userData.toothId = {
                    jaw: jaw,
                    toothIdx: teethArr.length - 1
                };
            }
            // Register tooth for IPR visualization - now including the mesh
            if (jaw && alignerNum) (0, $34b3600950cd5660$export$5973fc5f62f16522)(sourceNameForToothMapping, mesh, _geometry, jaw, alignerNum, idx);
        });
        onProgress(itemsLoaded, itemsTotal);
    // await sleep();
    }
    // return;
    // teeth.forEach((model) => {
    //   loader.load(model, (geometry) => {
    //     const material = addToothModelToScene(geometry);
    //     addMaterial(model, material, "teeth");
    //   });
    // });
    for(let i = 0; i < $6e53177b5afd7211$var$gums.length; i = i + chunkSize){
        const gumModelsPromise = [];
        const gumsModelChunk = [];
        for(let j = i; j < $6e53177b5afd7211$var$gums.length && j < i + chunkSize; j++){
            gumsModelChunk.push($6e53177b5afd7211$var$gums[j]);
            gumModelsPromise.push(loader.loadAsync($6e53177b5afd7211$var$gums[j]));
            itemsLoaded++;
        }
        const gumsGeometry = await Promise.all(gumModelsPromise);
        gumsGeometry.forEach((geometry, i)=>{
            const { geometry: _geometry , material: material  } = addGumModelToScene(geometry);
            addMaterial(canvasId, gumsModelChunk[i], material, "gum", _geometry);
        });
        onProgress(itemsLoaded, itemsTotal);
    }
    // gums.forEach((gumModel, idx) => {
    //   loader.load(gumModel, (geometry) => {
    //     const material = addGumModelToScene(geometry);
    //     addMaterial(gumModel, material, "gum");
    //   });
    // });
    // for (const attachmentModel of attachments) {
    //   const geometry = await loader.loadAsync(attachmentModel);
    //   itemsLoaded++;
    //   onProgress(itemsLoaded, itemsTotal);
    //   const material = addAttachmentModelToScene(geometry);
    //   addMaterial(attachmentModel, material, "attachments");
    // }
    // attachments.forEach((attachmentModel) => {
    //   loader.load(attachmentModel, (geometry) => {
    //     const material = addAttachmentModelToScene(geometry);
    //     addMaterial(attachmentModel, material, "attachments");
    //   });
    // });
    for(let i = 0; i < $6e53177b5afd7211$var$attachments.length; i = i + 6){
        const attachmentModelsPromise = [];
        const attachmentModelChunk = [];
        for(let j = i; j < $6e53177b5afd7211$var$attachments.length && j < i + 6; j++){
            attachmentModelChunk.push($6e53177b5afd7211$var$attachments[j]);
            attachmentModelsPromise.push(loader.loadAsync($6e53177b5afd7211$var$attachments[j]));
            itemsLoaded++;
        }
        const attachmentsGeomtry = await Promise.all(attachmentModelsPromise);
        attachmentsGeomtry.forEach((geometry, i)=>{
            const { geometry: _geometry , material: material  } = addAttachmentModelToScene(geometry);
            addMaterial(canvasId, attachmentModelChunk[i], material, "attachments", _geometry);
        });
        onProgress(itemsLoaded, itemsTotal);
    }
    $6e53177b5afd7211$var$onModelLoad(canvasId);
    $6e53177b5afd7211$var$cleanupGeneratedModelUrls();
};
const $6e53177b5afd7211$var$initModels = (canvasId)=>{
    const { models: models  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const hasUpper = Object.keys(models.UPPER || {}).length;
    const hasLower = Object.keys(models.LOWER || {}).length;
    // if (!hasUpper)
    //   document.getElementById("upper-control").style.display = "none";
    // if (!hasLower)
    //   document.getElementById("lower-control").style.display = "none";
    // if (!hasLower || !hasUpper)
    //   document.getElementById("left-controls").style.display = "none";
    const { hiddenModels: hiddenModels , visibilityMode: visibilityMode , superImpositions: superImpositions  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    Object.entries(models).forEach(([type, materials])=>{
        const keys = [
            ...Object.keys(materials)
        ];
        keys?.sort((a, b)=>parseInt(a) - parseInt(b));
        if (type === "UPPER") {
            $6e53177b5afd7211$var$upperActiveNum = keys?.[0];
            if (document.getElementById("upper-active-index")) document.getElementById("upper-active-index").textContent = $6e53177b5afd7211$var$upperActiveNum || "";
        }
        if (type === "LOWER") {
            $6e53177b5afd7211$var$lowerActiveNum = keys?.[0];
            if (document.getElementById("lower-active-index")) document.getElementById("lower-active-index").textContent = $6e53177b5afd7211$var$lowerActiveNum || "";
        }
        if (type === "UPPER" && visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER) return;
        if (type === "LOWER" && visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER) return;
        const first = materials[keys[0]];
        if (!first?.gum) return;
        if (!hiddenModels.teeth) first.teeth?.forEach((material)=>{
            material.visible = true;
        });
        if (!hiddenModels.attachments) first.attachments?.forEach((material)=>{
            material.visible = true;
        });
        if (!hiddenModels.gums) first.gum.visible = true;
        superImpositions[type] = first.teeth;
    });
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        superImpositions: superImpositions
    });
};
const $6e53177b5afd7211$export$125fb13b79d6b59b = (canvasId, color)=>{
    const { models: models  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    Object.values(models.UPPER).forEach((model)=>{
        model.gum.color = new $ilwiq.Color(color);
    });
    Object.values(models.LOWER).forEach((model)=>{
        model.gum.color = new $ilwiq.Color(color);
    });
};
const $6e53177b5afd7211$export$7396a2167c7f755e = (canvasId, type)=>{
    let { models: models , visibilityMode: visibilityMode , superImpositions: superImpositions  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    // Diff canvas always displays aligner "00"; main canvas uses global upperActiveNum/lowerActiveNum
    const upperIdx = canvasId === "diff-canvas" ? "00" : $6e53177b5afd7211$var$upperActiveNum;
    const lowerIdx = canvasId === "diff-canvas" ? "00" : $6e53177b5afd7211$var$lowerActiveNum;
    // if (
    //   (visibilityMode === VISIBILITY_MODES.UPPER &&
    //     type === VISIBILITY_MODES.UPPER) ||
    //   (visibilityMode === VISIBILITY_MODES.LOWER &&
    //     type === VISIBILITY_MODES.LOWER)
    // ) {
    //   // toggleVisibility(canvasId, VISIBILITY_MODES.UPPER_LOWER);
    //   // return;
    //   type = VISIBILITY_MODES.UPPER_LOWER;
    // }
    [
        models.UPPER?.[upperIdx],
        models.LOWER?.[lowerIdx]
    ].forEach((m)=>{
        m?.attachments?.forEach((a)=>{
            a.visible = false;
        });
        m?.teeth?.forEach((t)=>{
            t.visible = false;
        });
        if (m?.gum) m.gum.visible = false;
        if (m?.gumMesh) m.gumMesh.visible = false;
    });
    [
        ...superImpositions.UPPER || [],
        ...superImpositions.LOWER || []
    ]?.forEach((a)=>{
        a.color = new $ilwiq.Color("#fff");
        a.visible = false;
    });
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        superImpositions: superImpositions
    });
    const toggleUpper = (canvasId)=>{
        const { hiddenModels: hiddenModels , models: models , superImpositions: superImpositions  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
        if (!models.UPPER || !models.UPPER[upperIdx]) return;
        models.UPPER[upperIdx].attachments?.forEach((a)=>{
            if (!hiddenModels.attachments) a.visible = true;
        });
        models.UPPER[upperIdx].teeth?.forEach((a)=>{
            if (!hiddenModels.teeth) a.visible = true;
        });
        if (models.UPPER[upperIdx].gum) {
            if (!hiddenModels.gums) models.UPPER[upperIdx].gum.visible = true;
        }
        if (models.UPPER[upperIdx].gumMesh) models.UPPER[upperIdx].gumMesh.visible = !hiddenModels.gums;
        if (!hiddenModels.superImposition) superImpositions.UPPER?.forEach((a)=>{
            a.color = new $ilwiq.Color("#fc3");
            a.visible = true;
        });
        (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
            visibilityMode: visibilityMode,
            models: models,
            superImpositions: superImpositions
        });
    };
    const toggleLower = (canvasId)=>{
        const { hiddenModels: hiddenModels , models: models , superImpositions: superImpositions  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
        if (!models.LOWER || !models.LOWER[lowerIdx]) return;
        models.LOWER[lowerIdx].attachments?.forEach((a)=>{
            if (!hiddenModels.attachments) a.visible = true;
        });
        models.LOWER[lowerIdx].teeth?.forEach((a)=>{
            if (!hiddenModels.teeth) a.visible = true;
        });
        if (models.LOWER[lowerIdx].gum) {
            if (!hiddenModels.gums) models.LOWER[lowerIdx].gum.visible = true;
        }
        if (models.LOWER[lowerIdx].gumMesh) models.LOWER[lowerIdx].gumMesh.visible = !hiddenModels.gums;
        if (!hiddenModels.superImposition) superImpositions.LOWER?.forEach((a)=>{
            a.color = new $ilwiq.Color("#fc3");
            a.visible = true;
        });
        (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
            visibilityMode: visibilityMode,
            models: models,
            superImpositions: superImpositions
        });
    };
    if (type === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER) {
        visibilityMode = (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER;
        toggleUpper(canvasId);
        toggleLower(canvasId);
    } else if (type === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER) {
        visibilityMode = (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER;
        toggleUpper(canvasId);
    } else if (type === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER) {
        visibilityMode = (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER;
        toggleLower(canvasId);
    }
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        visibilityMode: visibilityMode,
        models: models
    });
};
// loadingManager.onProgress = function (url, itemsLoaded, itemsTotal) {
//   progressBar.animate(itemsLoaded / itemsTotal, { duration: 300 });
//   progressBar.setText(`${Math.ceil((itemsLoaded / itemsTotal) * 100)}%`);
// };
const $6e53177b5afd7211$var$getMaxUpperAlignerNumber = (canvasId)=>{
    const { models: models  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const upperKeys = Object.keys(models.UPPER || {}).map((key)=>parseInt(key, 10));
    return Math.max(...upperKeys);
};
const $6e53177b5afd7211$var$getMaxLowerAlignerNumber = (canvasId)=>{
    const { models: models  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const lowerKeys = Object.keys(models.LOWER || {}).map((key)=>parseInt(key, 10));
    return Math.max(...lowerKeys);
};
const $6e53177b5afd7211$export$bf13a6ff02b268c3 = (canvasId)=>{
    const { models: models  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const upperKeys = Object.keys(models.UPPER || {}).map((key)=>parseInt(key, 10));
    const lowerKeys = Object.keys(models.LOWER || {}).map((key)=>parseInt(key, 10));
    const allKeys = [
        ...upperKeys,
        ...lowerKeys
    ];
    if (allKeys.length === 0) return null;
    return Math.max(...allKeys);
};
/**
 * For each arch (UPPER/LOWER), if it has fewer aligner indices than the max
 * aligner count, fill missing indices by referencing the last available model
 * for that arch (so e.g. upper with 3 aligners and max 5 will show upper[2]
 * for indices 3 and 4).
 */ const $6e53177b5afd7211$var$fillMissingAlignerIndices = (canvasId)=>{
    const maxIdx = $6e53177b5afd7211$export$bf13a6ff02b268c3(canvasId);
    if (maxIdx == null) return;
    const { models: models , modelGeometries: modelGeometries  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    if (!models) return;
    const pad = (n)=>String(n).padStart(2, "0");
    let realMaxUpperIndex = null;
    let realMaxLowerIndex = null;
    [
        "UPPER",
        "LOWER"
    ].forEach((arch)=>{
        const archModels = models[arch];
        if (!archModels) return;
        const keys = Object.keys(archModels).map((k)=>parseInt(k, 10)).filter((k)=>!Number.isNaN(k)).sort((a, b)=>a - b);
        if (keys.length === 0) return;
        const lastKey = keys[keys.length - 1];
        if (arch === "UPPER") realMaxUpperIndex = lastKey;
        else realMaxLowerIndex = lastKey;
        for(let i = lastKey + 1; i <= maxIdx; i++){
            archModels[pad(i)] = archModels[pad(lastKey)];
            if (modelGeometries?.[arch]) modelGeometries[arch][pad(i)] = modelGeometries[arch][pad(lastKey)];
        }
    });
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        models: models,
        ...modelGeometries && {
            modelGeometries: modelGeometries
        },
        realMaxUpperIndex: realMaxUpperIndex,
        realMaxLowerIndex: realMaxLowerIndex
    });
};
const $6e53177b5afd7211$var$onModelLoad = function(canvasId) {
    if (!(0, $14c6e27f5c489006$export$d5abd5dd7869e8af).areFilesLoaded) $6e53177b5afd7211$var$progressBar.destroy();
    (0, $14c6e27f5c489006$export$d5abd5dd7869e8af).areFilesLoaded = true;
    document.getElementById("loader-container").style.opacity = 0;
    setTimeout(()=>{
        document.getElementById("loader-container").style.display = "none";
    }, 450);
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        visibilityMode: (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER
    });
    $6e53177b5afd7211$var$fillMissingAlignerIndices(canvasId);
    $6e53177b5afd7211$var$initModels(canvasId);
    const playerSlider = document.getElementById("player-slider");
    const maxAligner = $6e53177b5afd7211$export$bf13a6ff02b268c3(canvasId);
    playerSlider.setAttribute("max", maxAligner.toString());
    playerSlider.setAttribute("slider-width", `calc((${maxAligner} - 1) / ${maxAligner} * 100%)`);
    playerSlider.addCSS(`
    .range-slider {
      margin-left: auto;
      margin-right: auto;
      ${(0, $53de29777cdbd7c8$export$a550975ce732ef83) ? "transform: translateY(-25px);" : ""}
    }
    #range-slider,
    #range-slider > .container,
    #range-slider > .container .panel,
    #range-slider > .container .panel-fill {
      height: 35px !important;
      min-height: 35px !important;
    }
    .pointer-shape{
        margin-bottom: 40px;
    }
    .panel-fill{
      background: transparent;
    }
    .panel {
      background: transparent;
    }
    .panel:hover {
      background: transparent;
    }
    
  `);
    if (0, $53de29777cdbd7c8$export$a550975ce732ef83) {
        playerSlider.addCSS(`
      .tooltips {
        transform: rotate(-90deg) translateX(-30px);
        transform-origin: 0 0;
      }
        .tooltips > .tooltip {
          transform: rotate(90deg) translateX(-20px) translateY(-30px) !important;
        }
        #range-slider > .container {
          transform: rotate(-90deg);
          transform-origin: 0 0;
        }
      `);
        setTimeout(()=>{
            const sliderElement = document.getElementsByTagName("tc-range-slider")[0];
            if (sliderElement && sliderElement.shadowRoot) {
                // Get the vertical slider box dimensions
                const verticalBox = sliderElement.shadowRoot.querySelector("#range-slider");
                if (verticalBox) {
                    const boxWidth = verticalBox.clientWidth;
                    const boxHeight = verticalBox.clientHeight;
                    // Get container and tooltips elements
                    const elements = sliderElement.shadowRoot.querySelectorAll("#range-slider > .container, .tooltips");
                    // Update dimensions
                    if (elements.length > 0) {
                        elements[0].style.height = `${boxWidth}px`;
                        elements[0].style.width = `40px`;
                    }
                    if (elements.length > 1) {
                        elements[1].style.width = `${boxHeight}px`;
                        elements[1].style.height = `40px`;
                    }
                }
            }
        }, 1000);
    }
    function createStripedBackground(elementId, alignerCount, maxAlignerCount) {
        const element = document.getElementById(elementId);
        if (!element) return;
        element.querySelectorAll(".stripe-segment").forEach((el)=>el.remove());
        element.style.background = "none";
        const stripeWidthExpr = `(100% - 5px * ${maxAlignerCount - 1}) / ${maxAlignerCount}`;
        for(let i = 0; i < maxAlignerCount; i++){
            const opacity = i < alignerCount ? 1 : 0.3;
            // 0th strip: #434b5a; others: blue (#6fc3df)
            const color = i === 0 ? `rgba(67, 75, 90, ${opacity})` : `rgba(111, 195, 223, ${opacity})`;
            const left = i === 0 ? "0px" : `calc(${i} * (${stripeWidthExpr} + 5px))`;
            const stripe = document.createElement("div");
            stripe.className = "stripe-segment";
            stripe.style.cssText = `
        position: absolute;
        top: 0;
        left: ${left};
        width: calc(${stripeWidthExpr});
        height: 100%;
        background: ${color};
        pointer-events: none;
      `;
            element.appendChild(stripe);
        }
    }
    // Center of stripe to align with createStripedBackground gradient. Slider/stripes use aligner number as index (aligner 0 = stripe 0, aligner 1 = stripe 1).
    function getStripeCenterLeft(aligner, maxAlignerCount) {
        const stripeIdx = Math.max(0, Math.min(aligner, maxAlignerCount - 1));
        const stripeWidth = `(100% - 5px * (${maxAlignerCount} - 1)) / ${maxAlignerCount}`;
        return `calc(${stripeIdx} * (${stripeWidth} + 5px) + ${stripeWidth} / 2)`;
    }
    function createIPRStartDiamonds(elementId, maxAlignerCount, archActiveCount) {
        const element = document.getElementById(elementId);
        if (!element) return;
        // Remove existing diamonds
        element.querySelectorAll(".ipr-start-diamond").forEach((el)=>el.remove());
        const arch = elementId === "upper-track" ? "upper" : "lower";
        const cap = archActiveCount != null ? archActiveCount : maxAlignerCount;
        const startAligners = (0, $34b3600950cd5660$export$8639bd0cc6662416)(arch).filter((a)=>a < cap);
        if (startAligners.length === 0) return;
        const diamondSize = (0, $53de29777cdbd7c8$export$a550975ce732ef83) ? 6 : 8;
        startAligners.forEach((startAligner)=>{
            const diamond = document.createElement("span");
            diamond.className = "ipr-start-diamond";
            const left = getStripeCenterLeft(startAligner, maxAlignerCount);
            diamond.style.cssText = `
        position: absolute;
        left: ${left};
        top: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        width: ${diamondSize}px;
        height: ${diamondSize}px;
        background: #FFD700;
        pointer-events: none;
        z-index: 3;
      `;
            element.appendChild(diamond);
        });
    }
    function createAttachmentMarkers(elementId, maxAlignerCount, archActiveCount) {
        const element = document.getElementById(elementId);
        if (!element) return;
        element.querySelectorAll(".attachment-start-marker").forEach((el)=>el.remove());
        element.querySelectorAll(".attachment-end-marker").forEach((el)=>el.remove());
        const arch = elementId === "upper-track" ? "upper" : "lower";
        const cap = archActiveCount != null ? archActiveCount : maxAlignerCount;
        // Use maxAlignerCount so the end-of-treatment removal marker is placed at the
        // global last step for both arches, even when one arch has fewer aligners.
        const { starts: starts , ends: ends  } = (0, $34b3600950cd5660$export$7b0d3c7f83127bd)(maxAlignerCount, arch);
        const activeStarts = starts.filter((a)=>a < cap);
        // Mid-treatment removals are capped to the arch's active range (< cap).
        // End-of-treatment removal (=== maxAlignerCount) is always shown for both arches.
        const activeEnds = ends.filter((a)=>a < cap || a === maxAlignerCount);
        const markerSize = (0, $53de29777cdbd7c8$export$a550975ce732ef83) ? 10 : 14;
        const halfSize = markerSize / 2;
        // Up arrow at layer start — same stripe center as IPR
        activeStarts.forEach((aligner)=>{
            const arrow = document.createElement("span");
            arrow.className = "attachment-start-marker";
            const left = getStripeCenterLeft(aligner, maxAlignerCount);
            arrow.style.cssText = `
        position: absolute;
        left: ${left};
        top: 42%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 0;
        border-left: ${halfSize}px solid transparent;
        border-right: ${halfSize}px solid transparent;
        border-bottom: ${markerSize}px solid #ff7078;
        pointer-events: none;
        z-index: 1;
      `;
            element.appendChild(arrow);
        });
        // Down arrow at layer end — same stripe center as IPR/start
        activeEnds.forEach((aligner)=>{
            const arrow = document.createElement("span");
            arrow.className = "attachment-end-marker";
            const left = getStripeCenterLeft(aligner, maxAlignerCount);
            arrow.style.cssText = `
        position: absolute;
        left: ${left};
        top: 50%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 0;
        border-left: ${halfSize}px solid transparent;
        border-right: ${halfSize}px solid transparent;
        border-top: ${markerSize}px solid #ff7078;
        pointer-events: none;
        z-index: 1;
      `;
            element.appendChild(arrow);
        });
    }
    const { realMaxUpperIndex: realMaxUpperIndex , realMaxLowerIndex: realMaxLowerIndex  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId) || {};
    const upperActiveCount = Math.max(0, (realMaxUpperIndex != null ? realMaxUpperIndex : $6e53177b5afd7211$var$getMaxUpperAlignerNumber(canvasId)) + 1);
    const lowerActiveCount = Math.max(0, (realMaxLowerIndex != null ? realMaxLowerIndex : $6e53177b5afd7211$var$getMaxLowerAlignerNumber(canvasId)) + 1);
    createStripedBackground("upper-track", upperActiveCount, maxAligner + 1);
    createStripedBackground("lower-track", lowerActiveCount, maxAligner + 1);
    const maxAlignerCount = maxAligner + 1;
    createIPRStartDiamonds("upper-track", maxAlignerCount, upperActiveCount);
    createIPRStartDiamonds("lower-track", maxAlignerCount, lowerActiveCount);
    createAttachmentMarkers("upper-track", maxAlignerCount, upperActiveCount);
    createAttachmentMarkers("lower-track", maxAlignerCount, lowerActiveCount);
    if (canvasId === "canvas") {
        const upperEl = document.querySelector("#aligner-labels > #upper-aligner-label");
        const lowerEl = document.querySelector("#aligner-labels > #lower-aligner-label");
        if (upperEl && realMaxUpperIndex != null) upperEl.textContent = String(realMaxUpperIndex).padStart(2, "0");
        if (lowerEl && realMaxLowerIndex != null) lowerEl.textContent = String(realMaxLowerIndex).padStart(2, "0");
    }
    $6e53177b5afd7211$export$9fb1869c8ff8ec6f(canvasId, 0);
    // Initialize IPR visualization after models are loaded (skip diff canvas)
    if (canvasId !== "diff-canvas") setTimeout(()=>{
        (0, $34b3600950cd5660$export$433e7512bd0dcc85)(canvasId, $6e53177b5afd7211$var$upperActiveNum, $6e53177b5afd7211$var$lowerActiveNum);
    }, 500);
};
const $6e53177b5afd7211$var$hideModel = (canvasId, alignerType, index)=>{
    const { models: models , hiddenModels: hiddenModels , visibilityMode: visibilityMode , superImpositions: superImpositions  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const _models = models[alignerType.toUpperCase()];
    const model = _models[index];
    if (!model) return;
    if (model.gum) model.gum.visible = false;
    if (model.gumMesh) model.gumMesh.visible = false;
    model.teeth?.forEach((material)=>{
        material.visible = false;
    });
    model.attachments?.forEach((material)=>{
        material.visible = false;
    });
    // Only show superImposition for the active arch (respect upper-only / lower-only mode)
    const archActive = visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER || visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER && alignerType === "upper" || visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER && alignerType === "lower";
    if (!hiddenModels.superImposition && archActive) superImpositions[alignerType.toUpperCase()]?.forEach((a)=>{
        a.color = new $ilwiq.Color("#fc3");
        a.visible = true;
    });
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        models: models,
        superImpositions: superImpositions
    });
};
const $6e53177b5afd7211$var$showModel = (canvasId, alignerType, index)=>{
    const { models: models , hiddenModels: hiddenModels , visibilityMode: visibilityMode  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    if (visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER && alignerType === "upper") return;
    if (visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER && alignerType === "lower") return;
    const _models = models[alignerType.toUpperCase()];
    const model = _models[index];
    if (!hiddenModels.gums && model.gum) model.gum.visible = true;
    if (model.gumMesh) model.gumMesh.visible = !hiddenModels.gums;
    if (!hiddenModels.teeth) model.teeth?.forEach((material)=>{
        material.visible = true;
    });
    if (!hiddenModels.attachments) model.attachments?.forEach((material)=>{
        material.visible = true;
    });
};
const $6e53177b5afd7211$var$getNewIndex = (canvasId, currIndex, alignerType, controlType)=>{
    const { models: models  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const keys = Object.keys(models[alignerType.toUpperCase()]);
    keys?.sort((a, b)=>Number(a) - Number(b));
    const allIndices = [
        ...keys
    ];
    const i = allIndices.indexOf(currIndex);
    return controlType === "prev" ? allIndices[i - 1] : allIndices[i + 1];
};
const $6e53177b5afd7211$export$3181a24a4fbc7cd7 = (canvasId, alignerType, controlType)=>{
    const { models: models  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const index = alignerType === "upper" ? $6e53177b5afd7211$var$upperActiveNum : $6e53177b5afd7211$var$lowerActiveNum;
    const _models = models[alignerType.toUpperCase()];
    if (!_models) return;
    const newIdx = $6e53177b5afd7211$var$getNewIndex(canvasId, index, alignerType, controlType);
    if (!newIdx) return;
    const model = _models?.[newIdx];
    if (!model) return;
    $6e53177b5afd7211$var$hideModel(canvasId, alignerType, index);
    $6e53177b5afd7211$var$showModel(canvasId, alignerType, newIdx);
    if (alignerType === "upper") $6e53177b5afd7211$var$upperActiveNum = newIdx;
    else $6e53177b5afd7211$var$lowerActiveNum = newIdx;
    // Update IPR visualization positions when aligner index changes
    if (canvasId === "canvas") (0, $34b3600950cd5660$export$674503d9eebf00ad)(canvasId, $6e53177b5afd7211$var$upperActiveNum, $6e53177b5afd7211$var$lowerActiveNum);
    return newIdx;
};
const $6e53177b5afd7211$var$delay = async (time)=>{
    return new Promise((resolve)=>setTimeout(resolve, time));
};
let $6e53177b5afd7211$var$isPlaying = false;
const $6e53177b5afd7211$export$899fbdb5fa08b653 = async (canvasId)=>{
    const playControl = document.getElementById("play");
    const playerSlider = document.getElementById("player-slider");
    if ($6e53177b5afd7211$var$isPlaying) {
        $6e53177b5afd7211$var$isPlaying = false;
        playerSlider.disabled = false;
        playControl.classList.remove("icon-pause");
        playControl.classList.add("icon-play_back");
        return;
    }
    $6e53177b5afd7211$var$isPlaying = true;
    playControl.classList.remove("icon-play_back");
    playControl.classList.add("icon-pause");
    const maxAligner = $6e53177b5afd7211$export$bf13a6ff02b268c3(canvasId);
    let currentValue = Math.max(Number($6e53177b5afd7211$var$lowerActiveNum), Number($6e53177b5afd7211$var$upperActiveNum));
    // When at last aligner, wrap to 0 so play continues from the start
    if (currentValue >= maxAligner) currentValue = 0;
    playerSlider.disabled = true;
    for(let i = currentValue; i <= maxAligner; i++){
        if (!$6e53177b5afd7211$var$isPlaying) break;
        playerSlider.value = i;
        (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().forEach((canvas)=>{
            $6e53177b5afd7211$export$9fb1869c8ff8ec6f(canvas.id, i);
        });
        await $6e53177b5afd7211$var$delay(340);
    }
    $6e53177b5afd7211$var$isPlaying = false;
    playerSlider.disabled = false;
    playControl.classList.remove("icon-pause");
    playControl.classList.add("icon-play_back");
};
const $6e53177b5afd7211$export$b3c0ccfcf0d86f5a = (canvasId, type)=>{
    const { hiddenModels: hiddenModels , visibilityMode: visibilityMode  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    hiddenModels[type] = !hiddenModels[type];
    $6e53177b5afd7211$export$7396a2167c7f755e(canvasId, visibilityMode);
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        hiddenModels: hiddenModels
    });
};
const $6e53177b5afd7211$export$e1085302050524e2 = (canvasId, type, hidden)=>{
    const { hiddenModels: hiddenModels , visibilityMode: visibilityMode  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    hiddenModels[type] = hidden;
    $6e53177b5afd7211$export$7396a2167c7f755e(canvasId, visibilityMode);
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        hiddenModels: hiddenModels
    });
};
const $6e53177b5afd7211$export$9fb1869c8ff8ec6f = (canvasId, value)=>{
    if (canvasId === "diff-canvas") value = 0;
    const { models: models  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const indexString = value.toString().padStart(2, "0");
    const showAlignerModel = (alignerType, index)=>{
        const _models = models[alignerType.toUpperCase()];
        if (!_models) return;
        const model = _models[index];
        if (!model) return;
        Object.keys(_models).forEach((key)=>{
            $6e53177b5afd7211$var$hideModel(canvasId, alignerType, key);
        });
        $6e53177b5afd7211$var$showModel(canvasId, alignerType, index);
    };
    showAlignerModel("upper", indexString);
    showAlignerModel("lower", indexString);
    // When only one arch is active, hide the inactive arch's superImposition
    const { visibilityMode: visibilityMode , hiddenModels: hiddenModels , superImpositions: superImpositions  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    if (!hiddenModels.superImposition) {
        if (visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER) superImpositions.LOWER?.forEach((a)=>{
            a.color = new $ilwiq.Color("#fff");
            a.visible = false;
        });
        else if (visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER) superImpositions.UPPER?.forEach((a)=>{
            a.color = new $ilwiq.Color("#fff");
            a.visible = false;
        });
        (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
            superImpositions: superImpositions
        });
    }
    // Update global upperActiveNum/lowerActiveNum only for the main canvas so that
    // toggleVisibility and other code that uses these globals affect the correct
    // aligner on the main canvas. Do not update for diff-canvas, otherwise the
    // global state would become "00" and cause overlapping teeth on the main canvas
    // when gums/visibility are toggled (they would touch index "00" on main while
    // main is displaying a different aligner).
    if (canvasId === "canvas") {
        if (indexString) {
            $6e53177b5afd7211$var$upperActiveNum = indexString;
            $6e53177b5afd7211$var$lowerActiveNum = indexString;
        }
    }
    // Update IPR visualization positions when aligner index changes (skip diff canvas)
    if (canvasId !== "diff-canvas") (0, $34b3600950cd5660$export$674503d9eebf00ad)(canvasId, $6e53177b5afd7211$var$upperActiveNum, $6e53177b5afd7211$var$lowerActiveNum);
};
const $6e53177b5afd7211$export$bf1bd66833b3550a = ()=>{
// sharedData.currentView = VIEWS.DIFF;
// const mainCanvas = canvasManager.get("canvas");
// const diffCanvas = canvasManager.get("diff-canvas");
// const slider = document.getElementById("player-slider");
// slider.value = 0;
};
const $6e53177b5afd7211$var$updatePdfLinkModalContent = (pdfLinks)=>{
    const pdfFilesContainer = document.getElementById("pdf-files-container");
    if (!pdfFilesContainer) return;
    const links = pdfLinks && typeof pdfLinks === "object" ? pdfLinks : {};
    pdfFilesContainer.innerHTML = "";
    const pdfTypeConfig = {
        TREATMENT_PLAN: {
            label: "Treatment Plan PDF",
            icon: "data"
        }
    };
    Object.entries(links).forEach(([type, url])=>{
        if (url && pdfTypeConfig[type]) {
            const config = pdfTypeConfig[type];
            const linkElement = document.createElement("a");
            linkElement.href = url;
            linkElement.target = "_blank";
            linkElement.className = "pdf-icon-link";
            const iconElement = document.createElement("i");
            iconElement.className = `iconfont icon-${config.icon}`;
            const labelElement = document.createElement("span");
            labelElement.textContent = config.label;
            linkElement.appendChild(iconElement);
            linkElement.appendChild(labelElement);
            pdfFilesContainer.appendChild(linkElement);
        }
    });
    if (pdfFilesContainer.children.length === 0) {
        const emptyEl = document.createElement("p");
        emptyEl.className = "pdf-files-empty";
        emptyEl.textContent = "No PDF files available.";
        pdfFilesContainer.appendChild(emptyEl);
    }
};




var $8PNKb = parcelRequire("8PNKb");

var $fmRoT = parcelRequire("fmRoT");




var $b0Er6 = parcelRequire("b0Er6");
var $d67bbc77caa5bd25$exports = {};

$d67bbc77caa5bd25$exports = new URL("../" + (parcelRequire("27Lyk")).resolve("1vkZS"), import.meta.url).toString();



function $adcf363a09f534a1$var$e(e, t) {
    for(var o = 0; o < t.length; o++){
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
}
function $adcf363a09f534a1$var$t(e) {
    return function(e) {
        if (Array.isArray(e)) return $adcf363a09f534a1$var$o(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function(e, t) {
        if (!e) return;
        if ("string" == typeof e) return $adcf363a09f534a1$var$o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $adcf363a09f534a1$var$o(e, t);
    }(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $adcf363a09f534a1$var$o(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
    return n;
}
var $adcf363a09f534a1$var$n, $adcf363a09f534a1$var$i, $adcf363a09f534a1$var$a, $adcf363a09f534a1$var$r, $adcf363a09f534a1$var$s, $adcf363a09f534a1$var$l = ($adcf363a09f534a1$var$n = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])'
], $adcf363a09f534a1$var$i = function() {
    function o(e) {
        var n = e.targetModal, i = e.triggers, a = void 0 === i ? [] : i, r = e.onShow, s = void 0 === r ? function() {} : r, l = e.onClose, c = void 0 === l ? function() {} : l, d = e.openTrigger, u = void 0 === d ? "data-micromodal-trigger" : d, f = e.closeTrigger, h = void 0 === f ? "data-micromodal-close" : f, v = e.openClass, g = void 0 === v ? "is-open" : v, m = e.disableScroll, b = void 0 !== m && m, y = e.disableFocus, p = void 0 !== y && y, w = e.awaitCloseAnimation, E = void 0 !== w && w, k = e.awaitOpenAnimation, M = void 0 !== k && k, A = e.debugMode, C = void 0 !== A && A;
        !function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, o), this.modal = "string" == typeof n ? document.getElementById(n) : n, this.config = {
            debugMode: C,
            disableScroll: b,
            openTrigger: u,
            closeTrigger: h,
            openClass: g,
            onShow: s,
            onClose: c,
            awaitCloseAnimation: E,
            awaitOpenAnimation: M,
            disableFocus: p
        }, a.length > 0 && this.registerTriggers.apply(this, $adcf363a09f534a1$var$t(a)), this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this);
    }
    var i, a, r;
    return i = o, a = [
        {
            key: "registerTriggers",
            value: function() {
                for(var e = this, t = arguments.length, o = new Array(t), n = 0; n < t; n++)o[n] = arguments[n];
                o.filter(Boolean).forEach(function(t) {
                    t.addEventListener("click", function(t) {
                        return e.showModal(t);
                    });
                });
            }
        },
        {
            key: "showModal",
            value: function() {
                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (this.activeElement = document.activeElement, this.modal.setAttribute("aria-hidden", "false"), this.modal.classList.add(this.config.openClass), this.scrollBehaviour("disable"), this.addEventListeners(), this.config.awaitOpenAnimation) {
                    var o = function t() {
                        e.modal.removeEventListener("animationend", t, !1), e.setFocusToFirstNode();
                    };
                    this.modal.addEventListener("animationend", o, !1);
                } else this.setFocusToFirstNode();
                this.config.onShow(this.modal, this.activeElement, t);
            }
        },
        {
            key: "closeModal",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = this.modal;
                if (this.modal.setAttribute("aria-hidden", "true"), this.removeEventListeners(), this.scrollBehaviour("enable"), this.activeElement && this.activeElement.focus && this.activeElement.focus(), this.config.onClose(this.modal, this.activeElement, e), this.config.awaitCloseAnimation) {
                    var o = this.config.openClass;
                    this.modal.addEventListener("animationend", function e() {
                        t.classList.remove(o), t.removeEventListener("animationend", e, !1);
                    }, !1);
                } else t.classList.remove(this.config.openClass);
            }
        },
        {
            key: "closeModalByIdOrElement",
            value: function(e) {
                this.modal = "string" == typeof e ? document.getElementById(e) : e, this.modal && this.closeModal();
            }
        },
        {
            key: "scrollBehaviour",
            value: function(e) {
                if (this.config.disableScroll) {
                    var t = document.querySelector("body");
                    switch(e){
                        case "enable":
                            Object.assign(t.style, {
                                overflow: ""
                            });
                            break;
                        case "disable":
                            Object.assign(t.style, {
                                overflow: "hidden"
                            });
                    }
                }
            }
        },
        {
            key: "addEventListeners",
            value: function() {
                this.modal.addEventListener("touchstart", this.onClick), this.modal.addEventListener("click", this.onClick), document.addEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "removeEventListeners",
            value: function() {
                this.modal.removeEventListener("touchstart", this.onClick), this.modal.removeEventListener("click", this.onClick), document.removeEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "onClick",
            value: function(e) {
                (e.target.hasAttribute(this.config.closeTrigger) || e.target.parentNode.hasAttribute(this.config.closeTrigger)) && (e.preventDefault(), e.stopPropagation(), this.closeModal(e));
            }
        },
        {
            key: "onKeydown",
            value: function(e) {
                27 === e.keyCode && this.closeModal(e), 9 === e.keyCode && this.retainFocus(e);
            }
        },
        {
            key: "getFocusableNodes",
            value: function() {
                var e = this.modal.querySelectorAll($adcf363a09f534a1$var$n);
                return Array.apply(void 0, $adcf363a09f534a1$var$t(e));
            }
        },
        {
            key: "setFocusToFirstNode",
            value: function() {
                var e = this;
                if (!this.config.disableFocus) {
                    var t = this.getFocusableNodes();
                    if (0 !== t.length) {
                        var o = t.filter(function(t) {
                            return !t.hasAttribute(e.config.closeTrigger);
                        });
                        o.length > 0 && o[0].focus(), 0 === o.length && t[0].focus();
                    }
                }
            }
        },
        {
            key: "retainFocus",
            value: function(e) {
                var t = this.getFocusableNodes();
                if (0 !== t.length) {
                    if (t = t.filter(function(e) {
                        return null !== e.offsetParent;
                    }), this.modal.contains(document.activeElement)) {
                        var o = t.indexOf(document.activeElement);
                        e.shiftKey && 0 === o && (t[t.length - 1].focus(), e.preventDefault()), !e.shiftKey && t.length > 0 && o === t.length - 1 && (t[0].focus(), e.preventDefault());
                    } else t[0].focus();
                }
            }
        }
    ], $adcf363a09f534a1$var$e(i.prototype, a), r && $adcf363a09f534a1$var$e(i, r), o;
}(), $adcf363a09f534a1$var$a = null, $adcf363a09f534a1$var$r = function(e) {
    if ("string" == typeof id ? !document.getElementById(e) : !e) return console.warn("MicroModal: ❗Seems like you have missed %c'".concat(e, "'"), "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="'.concat(e, '"></div>')), !1;
}, $adcf363a09f534a1$var$s = function(e, t) {
    if (function(e) {
        e.length <= 0 && (console.warn("MicroModal: ❗Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>'));
    }(e), !t) return !0;
    for(var o in t)$adcf363a09f534a1$var$r(o);
    return !0;
}, {
    init: function(e) {
        var o = Object.assign({}, {
            openTrigger: "data-micromodal-trigger"
        }, e), n = $adcf363a09f534a1$var$t(document.querySelectorAll("[".concat(o.openTrigger, "]"))), r = function(e, t) {
            var o = [];
            return e.forEach(function(e) {
                var n = e.attributes[t].value;
                void 0 === o[n] && (o[n] = []), o[n].push(e);
            }), o;
        }(n, o.openTrigger);
        if (!0 !== o.debugMode || !1 !== $adcf363a09f534a1$var$s(n, r)) for(var l in r){
            var c = r[l];
            o.targetModal = l, o.triggers = $adcf363a09f534a1$var$t(c), $adcf363a09f534a1$var$a = new $adcf363a09f534a1$var$i(o);
        }
    },
    show: function(e, t) {
        var o = t || {};
        o.targetModal = e, !0 === o.debugMode && !1 === $adcf363a09f534a1$var$r(e) || ($adcf363a09f534a1$var$a && $adcf363a09f534a1$var$a.removeEventListeners(), ($adcf363a09f534a1$var$a = new $adcf363a09f534a1$var$i(o)).showModal());
    },
    close: function(e) {
        e ? $adcf363a09f534a1$var$a.closeModalByIdOrElement(e) : $adcf363a09f534a1$var$a.closeModal();
    }
});
"undefined" != typeof window && (window.MicroModal = $adcf363a09f534a1$var$l);
var $adcf363a09f534a1$export$2e2bcd8739ae039 = $adcf363a09f534a1$var$l;



// ffmpeg assets are copied verbatim into dist/ffmpeg/ by
// parcel-reporter-static-files-copy. We resolve them relative to the document
// base URI rather than hardcoding /ffmpeg/... so the app works when deployed
// under a sub-path. The UMD core in particular MUST NOT go through Parcel —
// it loads via importScripts() and assigns self.createFFmpegCore as a side
// effect, which Parcel's tree-shaker would eliminate.
const $abb8e350d4fb0f9e$var$ffmpegWorkerUrl = new URL("ffmpeg/ffmpeg-worker.js", document.baseURI).toString();
const $abb8e350d4fb0f9e$var$ffmpegCoreUrl = new URL("ffmpeg/ffmpeg-core.js", document.baseURI).toString();
const $abb8e350d4fb0f9e$var$ffmpegWasmUrl = new URL("ffmpeg/ffmpeg-core.wasm", document.baseURI).toString();
(0, $adcf363a09f534a1$export$2e2bcd8739ae039).init();
const $abb8e350d4fb0f9e$var$DESKTOP_CAMERA_ZOOM = 1.21;
(0, $b0Er6.default).init();
(0, $b0Er6.default)({
    defaultColor: "#c58c8c",
    alpha: false,
    onChange: (color)=>{
        (0, $6e53177b5afd7211$export$125fb13b79d6b59b)(null, color);
    },
    theme: "polaroid"
});
document.body.classList.add("zenyum");
const $abb8e350d4fb0f9e$var$initializeCanvas = async (canvasId, config = {})=>{
    const canvas = document.getElementById(canvasId);
    const screenDimensions = {
        width: canvas.width,
        height: canvas.height
    };
    const scene = (0, $53de29777cdbd7c8$export$e4d886da0d914a1b)();
    const renderer = (0, $53de29777cdbd7c8$export$40e69c7cd6d54d9c)({
        width: screenDimensions.width,
        height: screenDimensions.height
    }, canvas);
    const camera = (0, $53de29777cdbd7c8$export$254b82f749afde61)({
        width: screenDimensions.width,
        height: screenDimensions.height
    });
    const controls = (0, $53de29777cdbd7c8$export$e24de3f6e24de13a)(camera, renderer);
    // Listen to camera changes to update IPR visibility and label positions
    controls.addEventListener("change", ()=>{
        (0, $34b3600950cd5660$export$127367bf4516af82)(canvasId);
    });
    // Also update on window resize to reposition labels
    window.addEventListener("resize", ()=>{
        (0, $34b3600950cd5660$export$127367bf4516af82)(canvasId);
    });
    const { overlayCamera: overlayCamera , overlayScene: overlayScene , gridMaterial: gridMaterial , centerMaterial: centerMaterial  } = (0, $53de29777cdbd7c8$export$1b2a38402d047d8e)({
        width: screenDimensions.width,
        height: screenDimensions.height
    });
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).add(canvas.id, canvas, scene, camera, renderer, controls, overlayScene, overlayCamera);
    await (0, $6e53177b5afd7211$export$bab4cdd81fcf11a4)(canvasId, scene);
    const light = (0, $53de29777cdbd7c8$export$d70675aa2822a2ba)(scene, renderer);
    window.addEventListener("resize", ()=>$abb8e350d4fb0f9e$var$resizeCanvas(canvas, camera, renderer, overlayCamera, gridMaterial, centerMaterial));
    $abb8e350d4fb0f9e$var$resizeCanvas(canvas, camera, renderer, overlayCamera, gridMaterial, centerMaterial);
    $abb8e350d4fb0f9e$var$render(renderer, camera, controls, scene, light, overlayCamera, overlayScene, canvasId);
    window.dispatchEvent(new Event("resize"));
};
// Cleanup handle for the bidirectional camera sync between main and diff
// canvases. Set when diff view is enabled (zenyum only); called and cleared
// when diff view is closed so listeners don't accumulate across toggles.
let $abb8e350d4fb0f9e$var$cleanupDiffCameraSync = null;
// Mirror camera position/rotation/zoom + controls target between the main and
// diff canvases. The re-entry guard prevents the listener we trigger on the
// other canvas from bouncing back and re-syncing the source mid-update.
const $abb8e350d4fb0f9e$var$setupDiffCameraSync = ()=>{
    const main = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get("canvas");
    const diff = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get("diff-canvas");
    if (!main || !diff) return null;
    let isSyncing = false;
    const makeHandler = (sourceId, targetId)=>()=>{
            if (isSyncing) return;
            const source = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(sourceId);
            const target = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(targetId);
            if (!source || !target) return;
            isSyncing = true;
            target.camera.position.copy(source.camera.position);
            target.camera.quaternion.copy(source.camera.quaternion);
            target.camera.zoom = source.camera.zoom;
            target.camera.updateProjectionMatrix();
            target.controls.target.copy(source.controls.target);
            target.controls.update();
            isSyncing = false;
        };
    const mainHandler = makeHandler("canvas", "diff-canvas");
    const diffHandler = makeHandler("diff-canvas", "canvas");
    main.controls.addEventListener("change", mainHandler);
    diff.controls.addEventListener("change", diffHandler);
    return ()=>{
        main.controls.removeEventListener("change", mainHandler);
        diff.controls.removeEventListener("change", diffHandler);
    };
};
const $abb8e350d4fb0f9e$var$toggleDiffView = async ()=>{
    const existing = document.getElementById("diff-canvas");
    if (existing) {
        if ($abb8e350d4fb0f9e$var$cleanupDiffCameraSync) {
            $abb8e350d4fb0f9e$var$cleanupDiffCameraSync();
            $abb8e350d4fb0f9e$var$cleanupDiffCameraSync = null;
        }
        // Clean up IPR visualization before removing canvas
        (0, $34b3600950cd5660$export$8d5444b70ae94d36)(existing.id);
        (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).remove(existing.id);
        existing.remove();
        window.dispatchEvent(new Event("resize"));
        return;
    }
    const newCanvas = document.createElement("canvas");
    newCanvas.id = "diff-canvas";
    document.querySelector(".renderer-container").prepend(newCanvas);
    await $abb8e350d4fb0f9e$var$initializeCanvas(newCanvas.id);
    const mainCanvas = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get("canvas");
    // Sync maxil/mand state so "disable maxil/mand" turns off for both canvases (otherwise diff has "" and toggles to maxil)
    const syncedMaxilMand = mainCanvas.activeMaxilOrMandView || "";
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update("diff-canvas", {
        hiddenModels: {
            ...mainCanvas.hiddenModels
        },
        visibilityMode: mainCanvas.visibilityMode,
        activeMaxilOrMandView: syncedMaxilMand
    });
    (0, $6e53177b5afd7211$export$7396a2167c7f755e)("diff-canvas", mainCanvas.visibilityMode);
    // Force diff canvas to show only aligner 00 (onModelLoad already did this, but
    // ensure it after syncing visibility so no other aligners stay visible).
    (0, $6e53177b5afd7211$export$9fb1869c8ff8ec6f)("diff-canvas", 0);
    // Restore global upperActiveNum/lowerActiveNum from slider (onModelLoad for diff set them to "00").
    const playerSlider = document.getElementById("player-slider");
    if (playerSlider != null && playerSlider.value != null) (0, $6e53177b5afd7211$export$9fb1869c8ff8ec6f)("canvas", Number(playerSlider.value));
    $abb8e350d4fb0f9e$var$changeCameraAngle(mainCanvas.camera, "front");
    if (!(0, $53de29777cdbd7c8$export$a550975ce732ef83)) mainCanvas.camera.zoom = $abb8e350d4fb0f9e$var$DESKTOP_CAMERA_ZOOM;
    mainCanvas.camera.updateProjectionMatrix();
    (0, $6e53177b5afd7211$export$bf1bd66833b3550a)();
    $abb8e350d4fb0f9e$var$cleanupDiffCameraSync = $abb8e350d4fb0f9e$var$setupDiffCameraSync();
};
/**
 * Set maxil view state (force on or off, no toggle)
 * @param {string} canvasId - Canvas ID
 * @param {boolean} enable - Whether to enable maxil view
 * @param {boolean} forceCameraUpdate - Force camera update even if state is already correct
 */ const $abb8e350d4fb0f9e$var$setMaxilView = (canvasId, enable, forceCameraUpdate = false)=>{
    let { camera: camera , activeMaxilOrMandView: activeMaxilOrMandView , visibilityMode: visibilityMode  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const shouldBeMaxil = enable;
    const isCurrentlyMaxil = activeMaxilOrMandView === "maxil";
    // Update state if needed, or if forcing camera update
    if (shouldBeMaxil !== isCurrentlyMaxil || forceCameraUpdate) {
        if (shouldBeMaxil !== isCurrentlyMaxil) {
            activeMaxilOrMandView = shouldBeMaxil ? "maxil" : "";
            (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
                activeMaxilOrMandView: activeMaxilOrMandView
            });
        }
        if (shouldBeMaxil) {
            new (0, $8PNKb.default).Tween(camera.position).to(!(0, $53de29777cdbd7c8$export$a550975ce732ef83) ? {
                x: 0,
                y: -90,
                z: 35
            } : {
                x: 90,
                y: 0,
                z: 35
            }, 500).easing((0, $8PNKb.default).Easing.Cubic.InOut).start();
            if (visibilityMode != (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER) (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER);
        } else {
            new (0, $8PNKb.default).Tween(camera.position).to({
                x: 0,
                y: 0,
                z: 112
            }, 500).easing((0, $8PNKb.default).Easing.Cubic.InOut).start();
            if (visibilityMode != (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER) (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER);
        }
    }
};
/**
 * Set mand view state (force on or off, no toggle)
 * @param {string} canvasId - Canvas ID
 * @param {boolean} enable - Whether to enable mand view
 * @param {boolean} forceCameraUpdate - Force camera update even if state is already correct
 */ const $abb8e350d4fb0f9e$var$setMandView = (canvasId, enable, forceCameraUpdate = false)=>{
    let { camera: camera , activeMaxilOrMandView: activeMaxilOrMandView , visibilityMode: visibilityMode  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    const shouldBeMand = enable;
    const isCurrentlyMand = activeMaxilOrMandView === "mand";
    // Update state if needed, or if forcing camera update
    if (shouldBeMand !== isCurrentlyMand || forceCameraUpdate) {
        if (shouldBeMand !== isCurrentlyMand) {
            activeMaxilOrMandView = shouldBeMand ? "mand" : "";
            (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
                activeMaxilOrMandView: activeMaxilOrMandView
            });
        }
        if (shouldBeMand) {
            new (0, $8PNKb.default).Tween(camera.position).to(!(0, $53de29777cdbd7c8$export$a550975ce732ef83) ? {
                x: 0,
                y: 90,
                z: 35
            } : {
                x: -90,
                y: 0,
                z: 35
            }, 1000).easing((0, $8PNKb.default).Easing.Cubic.Out).start();
            if (visibilityMode != (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER) (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER);
        } else {
            new (0, $8PNKb.default).Tween(camera.position).to({
                x: 0,
                y: 0,
                z: 112
            }, 1000).easing((0, $8PNKb.default).Easing.Cubic.Out).start();
            if (visibilityMode != (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER) (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER);
        }
    }
};
const $abb8e350d4fb0f9e$var$toggleMaxilView = (canvasId)=>{
    let { camera: camera , activeMaxilOrMandView: activeMaxilOrMandView , visibilityMode: visibilityMode  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    if (activeMaxilOrMandView != "maxil") activeMaxilOrMandView = "maxil";
    else activeMaxilOrMandView = "";
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        activeMaxilOrMandView: activeMaxilOrMandView
    });
    if (activeMaxilOrMandView === "maxil") new (0, $8PNKb.default).Tween(camera.position).to(!(0, $53de29777cdbd7c8$export$a550975ce732ef83) ? {
        x: 0,
        y: -90,
        z: 35
    } : {
        x: 90,
        y: 0,
        z: 35
    }, 500).easing((0, $8PNKb.default).Easing.Cubic.InOut).start();
    else new (0, $8PNKb.default).Tween(camera.position).to({
        x: 0,
        y: 0,
        z: 112
    }, 500).easing((0, $8PNKb.default).Easing.Cubic.InOut).start();
    // When turning OFF maxil, always set UPPER_LOWER and sync toolbar (don't use visibilityMode:
    // deactivateUpperLowerIfActive may have already set it to UPPER_LOWER before we run).
    if (activeMaxilOrMandView === "") {
        (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER);
        document.querySelectorAll(".toolbar-item.upper_lower").forEach((btn)=>btn.classList.remove("active"));
        $abb8e350d4fb0f9e$var$updateUpperLowerButtons();
    } else if (visibilityMode != (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER) (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER);
    else (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER);
};
const $abb8e350d4fb0f9e$var$toggleMandView = (canvasId)=>{
    let { camera: camera , activeMaxilOrMandView: activeMaxilOrMandView , visibilityMode: visibilityMode  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    if (activeMaxilOrMandView != "mand") activeMaxilOrMandView = "mand";
    else activeMaxilOrMandView = "";
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(canvasId, {
        activeMaxilOrMandView: activeMaxilOrMandView
    });
    if (activeMaxilOrMandView === "mand") new (0, $8PNKb.default).Tween(camera.position).to(!(0, $53de29777cdbd7c8$export$a550975ce732ef83) ? {
        x: 0,
        y: 90,
        z: 35
    } : {
        x: -90,
        y: 0,
        z: 35
    }, 1000).easing((0, $8PNKb.default).Easing.Cubic.Out).start();
    else new (0, $8PNKb.default).Tween(camera.position).to({
        x: 0,
        y: 0,
        z: 112
    }, 1000).easing((0, $8PNKb.default).Easing.Cubic.Out).start();
    // When turning OFF mand, always set UPPER_LOWER and sync toolbar (don't use visibilityMode:
    // deactivateUpperLowerIfActive may have already set it to UPPER_LOWER before we run).
    if (activeMaxilOrMandView === "") {
        (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER);
        document.querySelectorAll(".toolbar-item.upper_lower").forEach((btn)=>btn.classList.remove("active"));
        $abb8e350d4fb0f9e$var$updateUpperLowerButtons();
    } else if (visibilityMode != (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER) (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER);
    else (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER);
};
const $abb8e350d4fb0f9e$var$toggleMaxilAndMandView = async ()=>{
    const existing = document.getElementById("maxilandmand-canvas");
    if (existing) {
        // Turn off maxil view on main canvas and reset to normal view
        $abb8e350d4fb0f9e$var$setMaxilView("canvas", false);
        // Clean up IPR visualization before removing canvas
        (0, $34b3600950cd5660$export$8d5444b70ae94d36)(existing.id);
        (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).remove(existing.id);
        existing.remove();
        window.dispatchEvent(new Event("resize"));
        return;
    }
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().forEach((canvas)=>{
        $abb8e350d4fb0f9e$var$deactivateUpperLowerIfActive(canvas.id);
    });
    const newCanvas = document.createElement("canvas");
    newCanvas.id = "maxilandmand-canvas";
    document.querySelector(".renderer-container").appendChild(newCanvas);
    const mainCanvas = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get("canvas");
    // Preserve main canvas hidden state (gums, attachments, etc.) so it is re-applied after setting maxil view
    const mainHiddenBefore = {
        ...mainCanvas.hiddenModels
    };
    console.log({
        isPortrait: $53de29777cdbd7c8$export$a550975ce732ef83
    });
    if (!(0, $53de29777cdbd7c8$export$a550975ce732ef83)) mainCanvas.camera.zoom = $abb8e350d4fb0f9e$var$DESKTOP_CAMERA_ZOOM;
    else mainCanvas.camera.zoom = 0.3;
    mainCanvas.camera.updateProjectionMatrix();
    await $abb8e350d4fb0f9e$var$initializeCanvas(newCanvas.id);
    // Apply main canvas hidden state to new canvas so both respect gums/attachments etc.
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update(newCanvas.id, {
        hiddenModels: mainHiddenBefore
    });
    // Use setMaxilView and setMandView to force the correct state
    // Force camera update to ensure correct position regardless of previous state
    // This ensures maxil is ON for main canvas and mand is ON for new canvas
    $abb8e350d4fb0f9e$var$setMaxilView(mainCanvas.id, true, true);
    $abb8e350d4fb0f9e$var$setMandView(newCanvas.id, true, true);
    // Re-apply main canvas hidden state so gums etc. stay as user had them (avoids gums becoming visible when they were off)
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update("canvas", {
        hiddenModels: mainHiddenBefore
    });
    (0, $6e53177b5afd7211$export$7396a2167c7f755e)("canvas", (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER);
    // Explicitly hide gum on main canvas when user had gums off (defensive: ensure mesh.visible matches hiddenModels)
    const applyGumsHidden = ()=>{
        if (!mainHiddenBefore.gums) return;
        const { models: models  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get("canvas");
        if (!models?.UPPER) return;
        const { upperActiveNum: uIdx  } = (0, $6e53177b5afd7211$export$8562905f6f910168)();
        const idx = uIdx || Object.keys(models.UPPER)[0] || "00";
        const upperGum = models.UPPER[idx]?.gum;
        if (upperGum) upperGum.visible = false;
    };
    applyGumsHidden();
    // Re-apply after next frame so we override any code that shows gums during/after resize or render
    requestAnimationFrame(()=>{
        applyGumsHidden();
    });
    // Initialize IPR visualization for the new canvas with current active aligner numbers
    // Wait for models to load and then initialize IPR
    setTimeout(()=>{
        const { upperActiveNum: upperActiveNum , lowerActiveNum: lowerActiveNum  } = (0, $6e53177b5afd7211$export$8562905f6f910168)();
        (0, $34b3600950cd5660$export$433e7512bd0dcc85)(newCanvas.id, upperActiveNum, lowerActiveNum);
    }, 1000); // Increased delay to ensure models are loaded
};
const $abb8e350d4fb0f9e$var$deactivateUpperLowerIfActive = (canvasId)=>{
    const { visibilityMode: visibilityMode  } = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasId);
    if (visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER || visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER) {
        (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvasId, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER);
        // Sync toolbar: clear active state on upper/lower buttons
        const btns = document.querySelectorAll(".toolbar-item.upper_lower");
        btns.forEach((btn)=>btn.classList.remove("active"));
        $abb8e350d4fb0f9e$var$updateUpperLowerButtons();
    }
};
const $abb8e350d4fb0f9e$var$toggleGrid = ()=>{
    (0, $14c6e27f5c489006$export$d5abd5dd7869e8af).isGridVisible = !(0, $14c6e27f5c489006$export$d5abd5dd7869e8af).isGridVisible;
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().forEach((canvas)=>{
        canvas.overlayScene.visible = (0, $14c6e27f5c489006$export$d5abd5dd7869e8af).isGridVisible;
    });
};
/**
 * Check if maxil or mand view is active across all canvases
 * @returns {boolean} True if either maxil or mand is active
 */ const $abb8e350d4fb0f9e$var$isMaxilOrMandActive = ()=>{
    let hasMaxil = false;
    let hasMand = false;
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().forEach((canvas)=>{
        if (canvas.activeMaxilOrMandView === "maxil") hasMaxil = true;
        if (canvas.activeMaxilOrMandView === "mand") hasMand = true;
    });
    return hasMaxil || hasMand;
};
/**
 * Update upper and lower button states based on maxil/mand active status
 * Disables upper/lower when either maxil or mand is active
 */ const $abb8e350d4fb0f9e$var$updateUpperLowerButtons = ()=>{
    const maxilOrMandActive = $abb8e350d4fb0f9e$var$isMaxilOrMandActive();
    const upperBtn = document.getElementById("toolbar-item-upper");
    const lowerBtn = document.getElementById("toolbar-item-lower");
    if (upperBtn) upperBtn.disabled = maxilOrMandActive;
    if (lowerBtn) lowerBtn.disabled = maxilOrMandActive;
};
function $abb8e350d4fb0f9e$var$resizeCanvas(canvas, camera, renderer, overlayCamera, gridMaterial, centerMaterial) {
    const canvasCount = document.querySelectorAll(".renderer-container > canvas").length;
    canvas.style.width = `calc(100% / ${canvasCount})`;
    canvas.style.height = "100%";
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    if (0, $53de29777cdbd7c8$export$a550975ce732ef83) {
        canvas.style.width = `calc(100% / ${canvasCount})`;
        canvas.style.height = `100%`;
        // canvas.style.flex = 1;
        canvas.width = canvas.offsetHeight;
        canvas.height = canvas.offsetWidth;
    } else {
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
    }
    const [canvas1, canvas2] = document.querySelectorAll(".renderer-container > canvas");
    if (0, $53de29777cdbd7c8$export$a550975ce732ef83) {
        if (canvasCount == 2) {
            canvas1.style.transform = "translate(-100%, -50%) rotate(90deg)";
            canvas2.style.transform = "translate(0%, -50%) rotate(90deg)";
        } else canvas1.style.transform = "translate(-50%, -50%) rotate(90deg)";
    }
    $abb8e350d4fb0f9e$var$onWindowResize(canvas, camera, renderer, overlayCamera, gridMaterial, centerMaterial);
}
function $abb8e350d4fb0f9e$var$onWindowResize(canvas, camera, renderer, overlayCamera, gridMaterial, centerMaterial) {
    const { width: width , height: height  } = canvas;
    const screenDimensions = {
        width: canvas.width,
        height: canvas.height
    };
    // const aspectRatio = Math.round((width / height) * 10);
    screenDimensions.width = width;
    screenDimensions.height = height;
    camera.aspect = width / height;
    if (0, $53de29777cdbd7c8$export$a550975ce732ef83) {
        camera.left = -width / 7.6;
        camera.right = width / 7.6;
        camera.top = height / 7.6;
        camera.bottom = -height / 7.6;
    } else {
        camera.left = -width / 12.5;
        camera.right = width / 12.5;
        camera.top = height / 12.5;
        camera.bottom = -height / 12.5;
    }
    camera.updateProjectionMatrix();
    renderer.setSize(width, height);
    const aspect = width / height;
    overlayCamera.left = -1 * aspect;
    overlayCamera.right = 1 * aspect;
    overlayCamera.top = 1;
    overlayCamera.bottom = -1;
    overlayCamera.updateProjectionMatrix();
    gridMaterial.resolution.set(width, height);
    centerMaterial.resolution.set(width, height);
}
const $abb8e350d4fb0f9e$var$changeCameraAngle = (camera, type)=>{
    switch(type){
        case "front":
            new (0, $8PNKb.default).Tween(camera.position).to({
                x: 0,
                y: 0,
                z: 112
            }, 500).easing((0, $8PNKb.default).Easing.Cubic.Out).start();
            break;
        case "rear":
            new (0, $8PNKb.default).Tween(camera.position).to({
                x: 0,
                y: 0,
                z: -112
            }, 1500).easing((0, $8PNKb.default).Easing.Cubic.Out).start();
            break;
        case "left":
            new (0, $8PNKb.default).Tween(camera.position).to(!(0, $53de29777cdbd7c8$export$a550975ce732ef83) ? {
                x: 112,
                y: 0,
                z: 20
            } : {
                x: 0,
                y: 112,
                z: 20
            }, 500).easing((0, $8PNKb.default).Easing.Cubic.Out).start();
            break;
        case "right":
            new (0, $8PNKb.default).Tween(camera.position).to(!(0, $53de29777cdbd7c8$export$a550975ce732ef83) ? {
                x: -112,
                y: 0,
                z: 20
            } : {
                x: 0,
                y: -112,
                z: 20
            }, 500).easing((0, $8PNKb.default).Easing.Cubic.Out).start();
            break;
        case "top":
            new (0, $8PNKb.default).Tween(camera.position).to(!(0, $53de29777cdbd7c8$export$a550975ce732ef83) ? {
                x: 0,
                y: 112,
                z: 20
            } : {
                x: 112,
                y: 0,
                z: 20
            }, 500).easing((0, $8PNKb.default).Easing.Cubic.Out).start();
            break;
        case "bottom":
            new (0, $8PNKb.default).Tween(camera.position).to(!(0, $53de29777cdbd7c8$export$a550975ce732ef83) ? {
                x: 0,
                y: -112,
                z: 20
            } : {
                x: -112,
                y: 0,
                z: 20
            }, 500).easing((0, $8PNKb.default).Easing.Cubic.Out).start();
            break;
        default:
            break;
    }
};
async function $abb8e350d4fb0f9e$var$downloadFile(id) {
    const { data: data  } = await (0, $fmRoT.default).get(`${"/api/v3/zenyum/dental-viewer"}/report?id=${id}`);
    if (data.pdfUrl) {
        const link = document.createElement("a");
        link.download = data.fileName;
        link.href = data.pdfUrl;
        link.click();
    }
}
function $abb8e350d4fb0f9e$var$bindEventListeners() {
    // const visibilityTypes = ["upper_lower", "upper", "lower"];
    // visibilityTypes.forEach((type) => {
    //   const control = document.getElementById(`show-${type}`);
    //   control.addEventListener("click", (e) => {
    //     toggleVisibility(type);
    //   });
    // });
    // const cameraTypes = ["front", "rear", "left", "right", "top", "bottom"];
    // cameraTypes.forEach((type) => {
    //   const control = document.getElementById(`camera-${type}`);
    //   control.addEventListener("click", (e) => {
    //     changeCameraAngle(type);
    //   });
    // });
    // ["lower", "upper"].forEach((type) => {
    //   ["prev", "next"].forEach((controlType) => {
    //     const centerControl = document.querySelector(
    //       `#${type}-control > .control-${controlType}`
    //     );
    //     centerControl.addEventListener("click", (e) => {
    //       const newIdx = changeActiveIndex(type, controlType);
    //       if (!newIdx) return;
    //       document.querySelector(
    //         `#${type}-control > #${type}-active-index`
    //       ).textContent = newIdx;
    //     });
    //   });
    // });
    document.getElementById("play").addEventListener("click", ()=>{
        (0, $6e53177b5afd7211$export$899fbdb5fa08b653)("canvas");
    });
    document.getElementById("play-next").addEventListener("click", ()=>{
        const slider = document.getElementById("player-slider");
        const newValue = Number(slider.value) + 1;
        // canvasManager.getAll().forEach((canvas) => {
        //   changeActiveIndexByValue(canvas.id, newValue);
        // });
        slider.value = newValue;
    });
    document.getElementById("play-prev").addEventListener("click", ()=>{
        const slider = document.getElementById("player-slider");
        const newValue = Number(slider.value) - 1;
        // canvasManager.getAll().forEach((canvas) => {
        //   changeActiveIndexByValue(canvas.id, newValue);
        // });
        slider.value = newValue;
    });
    // --- Toolbar action queue ---
    // Serialises toolbar actions so only one runs at a time. All toolbar buttons
    // are disabled while an action is in progress, preventing rapid clicks from
    // causing model visibility to desync with toolbar state.
    const TOOLBAR_ACTION_TYPES = [
        "superImposition",
        "attachments",
        "gums",
        "upper",
        "lower",
        "front",
        "left",
        "rear",
        "right",
        "diff-view",
        "maxil",
        "mand",
        "maxil_mand",
        "grid",
        "pdf-files",
        "movement-table",
        "ipr"
    ];
    let toolbarActionQueue = Promise.resolve();
    const disableAllToolbarButtons = ()=>{
        TOOLBAR_ACTION_TYPES.forEach((t)=>{
            const btn = document.getElementById(`toolbar-item-${t}`);
            if (btn) btn.disabled = true;
        });
    };
    const TOOLBAR_DISABLE_RULES = {
        maxil_mand: [
            "front",
            "left",
            "rear",
            "right",
            "upper",
            "lower",
            "maxil",
            "mand",
            "diff-view"
        ],
        "diff-view": [
            "maxil_mand"
        ]
    };
    const restoreToolbarButtonStates = ()=>{
        TOOLBAR_ACTION_TYPES.forEach((t)=>{
            const btn = document.getElementById(`toolbar-item-${t}`);
            if (btn) btn.disabled = false;
        });
        // Re-apply disable rules based on currently active toggle buttons
        Object.entries(TOOLBAR_DISABLE_RULES).forEach(([key, targets])=>{
            const activeBtn = document.getElementById(`toolbar-item-${key}`);
            if (activeBtn && activeBtn.classList.contains("active")) targets.forEach((target)=>{
                const targetBtn = document.getElementById(`toolbar-item-${target}`);
                if (targetBtn) targetBtn.disabled = true;
            });
        });
        // Re-apply maxil/mand → upper/lower disable rule
        $abb8e350d4fb0f9e$var$updateUpperLowerButtons();
    };
    const enqueueToolbarAction = (actionFn)=>{
        toolbarActionQueue = toolbarActionQueue.then(async ()=>{
            disableAllToolbarButtons();
            try {
                await actionFn();
            } catch (err) {
                console.error("Toolbar action failed:", err);
            } finally{
                restoreToolbarButtonStates();
            }
        });
    };
    TOOLBAR_ACTION_TYPES.forEach((type)=>{
        const handleAction = async ()=>{
            if (type === "report") {
                const urlParams = new URLSearchParams(window.location.search);
                const id = urlParams.get("id");
                await $abb8e350d4fb0f9e$var$downloadFile(id);
                return;
            } else if ([
                "upper",
                "lower"
            ].includes(type)) {
                (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().forEach((canvas)=>{
                    const { visibilityMode: visibilityMode  } = canvas;
                    if (visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER && type === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER || visibilityMode === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER && type === (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).LOWER) (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvas.id, (0, $14c6e27f5c489006$export$cadc9083b0ea9c43).UPPER_LOWER);
                    else (0, $6e53177b5afd7211$export$7396a2167c7f755e)(canvas.id, type);
                // canvasManager.update(canvas.id, {
                //   visibilityMode: type,
                // });
                });
                return;
            } else if ([
                "front",
                "left",
                "rear",
                "right"
            ].includes(type)) {
                (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().forEach((canvas)=>{
                    $abb8e350d4fb0f9e$var$changeCameraAngle(canvas.camera, type);
                    // Update IPR visibility after camera angle changes
                    setTimeout(()=>{
                        (0, $34b3600950cd5660$export$127367bf4516af82)(canvas.id);
                    }, 550); // Wait for camera animation to complete
                });
                return;
            } else if (type === "diff-view") {
                await $abb8e350d4fb0f9e$var$toggleDiffView();
                return;
            } else if (type === "maxil") {
                const allCanvases = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll();
                const wasMaxilOrMandOnBefore = allCanvases.some((c)=>c.activeMaxilOrMandView === "maxil" || c.activeMaxilOrMandView === "mand");
                allCanvases.forEach((canvas)=>{
                    $abb8e350d4fb0f9e$var$deactivateUpperLowerIfActive(canvas.id);
                    $abb8e350d4fb0f9e$var$toggleMaxilView(canvas.id);
                });
                // Keep diff-canvas visibility in sync with main canvas after toggling maxil
                const diffData = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get("diff-canvas");
                if (diffData) {
                    const mainCanvas = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get("canvas");
                    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update("diff-canvas", {
                        visibilityMode: mainCanvas.visibilityMode,
                        hiddenModels: {
                            ...mainCanvas.hiddenModels
                        }
                    });
                    (0, $6e53177b5afd7211$export$7396a2167c7f755e)("diff-canvas", mainCanvas.visibilityMode);
                    // When we just turned off maxil/mand with diff view active, ensure both cameras go to default front position
                    if (wasMaxilOrMandOnBefore) {
                        $abb8e350d4fb0f9e$var$changeCameraAngle(mainCanvas.camera, "front");
                        $abb8e350d4fb0f9e$var$changeCameraAngle(diffData.camera, "front");
                    }
                }
                return;
            } else if (type === "mand") {
                const allCanvases = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll();
                const wasMaxilOrMandOnBefore = allCanvases.some((c)=>c.activeMaxilOrMandView === "maxil" || c.activeMaxilOrMandView === "mand");
                allCanvases.forEach((canvas)=>{
                    $abb8e350d4fb0f9e$var$deactivateUpperLowerIfActive(canvas.id);
                    $abb8e350d4fb0f9e$var$toggleMandView(canvas.id);
                });
                // Keep diff-canvas visibility in sync with main canvas after toggling mand
                const diffData = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get("diff-canvas");
                if (diffData) {
                    const mainCanvas = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get("canvas");
                    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).update("diff-canvas", {
                        visibilityMode: mainCanvas.visibilityMode,
                        hiddenModels: {
                            ...mainCanvas.hiddenModels
                        }
                    });
                    (0, $6e53177b5afd7211$export$7396a2167c7f755e)("diff-canvas", mainCanvas.visibilityMode);
                    // When we just turned off maxil/mand with diff view active, ensure both cameras go to default front position
                    if (wasMaxilOrMandOnBefore) {
                        $abb8e350d4fb0f9e$var$changeCameraAngle(mainCanvas.camera, "front");
                        $abb8e350d4fb0f9e$var$changeCameraAngle(diffData.camera, "front");
                    }
                }
                return;
            } else if (type === "maxil_mand") {
                await $abb8e350d4fb0f9e$var$toggleMaxilAndMandView();
                return;
            } else if (type === "grid") {
                $abb8e350d4fb0f9e$var$toggleGrid();
                return;
            } else if (type === "pdf-files") {
                (0, $adcf363a09f534a1$export$2e2bcd8739ae039).show("pdf-files-modal");
                return;
            } else if (type === "movement-table") {
                (0, $3824e294ef8e8757$export$21b11519d69ebe5f)();
                return;
            } else if (type === "ipr") {
                // Toggle IPR once globally; toggleIPR updates all canvases
                const canvases = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll();
                if (canvases.length) (0, $34b3600950cd5660$export$94a482d3376e4ed9)(canvases[0].id);
                return;
            }
            const canvases = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll();
            const syncTypes = [
                "gums",
                "attachments",
                "superImposition"
            ];
            if (syncTypes.includes(type) && canvases.length > 0) {
                const newHidden = !(0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvases[0].id).hiddenModels[type];
                canvases.forEach((canvas)=>(0, $6e53177b5afd7211$export$e1085302050524e2)(canvas.id, type, newHidden));
            } else canvases.forEach((canvas)=>{
                (0, $6e53177b5afd7211$export$b3c0ccfcf0d86f5a)(canvas.id, type);
            });
        };
        document.getElementById(`toolbar-item-${type}`).addEventListener("click", ()=>enqueueToolbarAction(handleAction));
    });
}
// Store last update time for throttling IPR visibility updates
let $abb8e350d4fb0f9e$var$lastIPRUpdate = 0;
const $abb8e350d4fb0f9e$var$render = (renderer, camera, controls, scene, mainLight, overlayCamera, overlayScene, canvasId)=>{
    requestAnimationFrame(()=>$abb8e350d4fb0f9e$var$render(renderer, camera, controls, scene, mainLight, overlayCamera, overlayScene, canvasId));
    renderer.render(scene, camera);
    renderer.autoClear = false;
    (0, $8PNKb.default).update();
    controls.update();
    // Update IPR visibility when camera moves (throttled to every 100ms)
    if (canvasId && Date.now() - $abb8e350d4fb0f9e$var$lastIPRUpdate > 100) {
        (0, $34b3600950cd5660$export$127367bf4516af82)(canvasId);
        $abb8e350d4fb0f9e$var$lastIPRUpdate = Date.now();
    }
    // Update label positions every frame for visible labels
    if (canvasId && window.iprLines) {
        const lines = window.iprLines.get(canvasId) || [];
        lines.forEach(({ label: label , endPoint: endPoint , line: line  })=>{
            if (!label || !line || !line.visible) return;
            if ((0, $34b3600950cd5660$export$10242fad97d15005)()) (0, $34b3600950cd5660$export$cd624845698d9c61)(label, line, camera, renderer, endPoint);
            else if (endPoint) (0, $34b3600950cd5660$export$e4ed0ff6cb6e65c2)(label, endPoint, camera, renderer);
        });
    }
    mainLight.position.set(camera.position.x + camera.position.x * 1.1, camera.position.y + camera.position.y * 0.6, camera.position.z - camera.position.z * 0.1);
    renderer.render(overlayScene, overlayCamera);
    renderer.autoClear = true;
};
function $abb8e350d4fb0f9e$var$setupToothClickHighlight() {
    const raycaster = new $ilwiq.Raycaster();
    const mouse = new $ilwiq.Vector2();
    let mouseDownX = 0;
    let mouseDownY = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    const rendererContainer = document.querySelector(".renderer-container");
    const handleToothPick = (clientX, clientY, canvasEl)=>{
        const canvasData = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get(canvasEl.id);
        if (!canvasData) return;
        const { camera: camera , scene: scene  } = canvasData;
        const rect = canvasEl.getBoundingClientRect();
        mouse.x = (clientX - rect.left) / rect.width * 2 - 1;
        mouse.y = -((clientY - rect.top) / rect.height) * 2 + 1;
        raycaster.setFromCamera(mouse, camera);
        const toothMeshes = scene.children.filter((obj)=>obj.userData.type === "tooth" && obj.material?.visible);
        const intersects = raycaster.intersectObjects(toothMeshes, false);
        if (intersects.length === 0) {
            (0, $6e53177b5afd7211$export$3990fc6c32c26aba)();
            return;
        }
        const { toothId: toothId  } = intersects[0].object.userData;
        if (!toothId) return;
        (0, $6e53177b5afd7211$export$2aa08e9886547e7a)(toothId.jaw, toothId.toothIdx);
    };
    rendererContainer.addEventListener("mousedown", (e)=>{
        mouseDownX = e.clientX;
        mouseDownY = e.clientY;
    });
    rendererContainer.addEventListener("click", (e)=>{
        if (Math.abs(e.clientX - mouseDownX) > 5 || Math.abs(e.clientY - mouseDownY) > 5) return;
        const target = e.target;
        if (!(target instanceof HTMLCanvasElement)) return;
        handleToothPick(e.clientX, e.clientY, target);
    });
    rendererContainer.addEventListener("touchstart", (e)=>{
        if (e.touches.length === 1) {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
        }
    }, {
        passive: true
    });
    rendererContainer.addEventListener("touchend", (e)=>{
        if (e.changedTouches.length !== 1) return;
        const touch = e.changedTouches[0];
        if (Math.abs(touch.clientX - touchStartX) > 10 || Math.abs(touch.clientY - touchStartY) > 10) return;
        const target = document.elementFromPoint(touch.clientX, touch.clientY);
        if (!(target instanceof HTMLCanvasElement)) return;
        handleToothPick(touch.clientX, touch.clientY, target);
    });
}
function $abb8e350d4fb0f9e$var$createToolbar(items) {
    const toolbar = document.getElementById("toolbar");
    const toolbarItems = document.createElement("div");
    toolbarItems.className = "toolbar-items";
    const disableRules = {
        maxil_mand: [
            "front",
            "left",
            "rear",
            "right",
            "upper",
            "lower",
            "maxil",
            "mand",
            "diff-view"
        ],
        "diff-view": [
            "maxil_mand"
        ]
    };
    items.forEach((item)=>{
        const button = document.createElement("button");
        button.className = "toolbar-item";
        if (item.defaultActive) button.className += " active";
        button.id = "toolbar-item-" + (item.type || item.text.toLowerCase());
        const icon = document.createElement("div");
        icon.className = `iconfont icon-${item.icon}`;
        const label = document.createElement("span");
        label.className = "label";
        label.textContent = item.text;
        button.appendChild(icon);
        button.appendChild(label);
        toolbarItems.appendChild(button);
        if (item.canToggle) {
            button.addEventListener("click", ()=>{
                if (item.toggleGroup) document.querySelectorAll(`.toolbar-item.${item.toggleGroup}`).forEach((btn)=>{
                    if (btn !== button) btn.classList.remove("active");
                });
                button.classList.toggle("active");
                Object.entries(disableRules).forEach(([key, targets])=>{
                    if (item.type === key) targets.forEach((target)=>{
                        const targetBtn = document.getElementById(`toolbar-item-${target}`);
                        if (targetBtn) targetBtn.disabled = button.classList.contains("active");
                    });
                });
                Object.entries(disableRules).forEach(([key, targets])=>{
                    const activeBtn = document.getElementById(`toolbar-item-${key}`);
                    if (!activeBtn || !activeBtn.classList.contains("active")) targets.forEach((target)=>{
                        const targetBtn = document.getElementById(`toolbar-item-${target}`);
                        if (targetBtn) targetBtn.disabled = false;
                    });
                });
                // Update upper/lower buttons based on maxil/mand state
                // This needs to happen after a delay to allow canvas state to update
                if (item.type === "maxil" || item.type === "mand") setTimeout(()=>{
                    $abb8e350d4fb0f9e$var$updateUpperLowerButtons();
                }, 100);
            });
            if (item.toggleGroup) button.classList.add(item.toggleGroup);
        }
    });
    toolbar.appendChild(toolbarItems);
}
const $abb8e350d4fb0f9e$var$toolbarData = [
    {
        icon: "attachments",
        text: "Attach",
        type: "attachments",
        canToggle: true,
        defaultActive: true
    },
    {
        icon: "overlap",
        text: "Super",
        type: "superImposition",
        canToggle: true
    },
    {
        icon: "occlusal",
        text: "Gums",
        type: "gums",
        canToggle: true,
        defaultActive: true
    },
    {
        icon: "deglazing",
        text: "IPR",
        type: "ipr",
        canToggle: true,
        defaultActive: true
    },
    {
        icon: "reveal_upper",
        text: "Upper",
        type: "upper",
        canToggle: true,
        toggleGroup: "upper_lower"
    },
    {
        icon: "reveal_lower",
        text: "Lower",
        type: "lower",
        canToggle: true,
        toggleGroup: "upper_lower"
    },
    {
        icon: "zhengmian",
        text: "Front",
        type: "front"
    },
    {
        icon: "left_side",
        text: "Left",
        type: "left"
    },
    {
        icon: "back_vision",
        text: "Back",
        type: "rear"
    },
    {
        icon: "right_side",
        text: "Right",
        type: "right"
    },
    {
        icon: "upper_teeth",
        text: "Maxil",
        type: "maxil",
        canToggle: true,
        toggleGroup: "maxil_mand"
    },
    {
        icon: "lower_teeth",
        text: "Mand",
        type: "mand",
        canToggle: true,
        toggleGroup: "maxil_mand"
    },
    {
        icon: "hemian",
        text: "View",
        canToggle: true,
        type: "maxil_mand",
        toggleGroup: "maxil_mand"
    },
    {
        icon: "contrast",
        text: "Differ",
        type: "diff-view",
        canToggle: true
    },
    {
        icon: "grid",
        text: "Grid",
        type: "grid",
        canToggle: true
    },
    {
        icon: "data",
        text: "Files",
        type: "pdf-files"
    },
    {
        icon: "movement",
        text: "Movement Table",
        type: "movement-table"
    }
];
$abb8e350d4fb0f9e$var$createToolbar($abb8e350d4fb0f9e$var$toolbarData);
$abb8e350d4fb0f9e$var$initializeCanvas("canvas");
$abb8e350d4fb0f9e$var$bindEventListeners();
$abb8e350d4fb0f9e$var$setupToothClickHighlight();
try {
    (0, $3824e294ef8e8757$export$a08888547b7e2f4e)();
} catch (err) {
    console.error("initMovementPanel failed", err);
}
// Expose tooth mapping and IPR functions for debugging
window.getToothMapping = (0, $34b3600950cd5660$export$72128fa364af8f33);
window.findIPRLines = (0, $34b3600950cd5660$export$3ca5463dd74f6337);
window.testFDIMapping = (0, $34b3600950cd5660$export$4860e836ee91184f);
window.canvasManager = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039);
const $abb8e350d4fb0f9e$var$playerWrapper = document.getElementById("player-wrapper");
const $abb8e350d4fb0f9e$var$$slider = document.createElement("tc-range-slider");
$abb8e350d4fb0f9e$var$$slider.setAttribute("id", "player-slider");
$abb8e350d4fb0f9e$var$$slider.setAttribute("min", "0");
$abb8e350d4fb0f9e$var$$slider.setAttribute("style", "--opacity: 0.95; margin-left: auto; margin-right: auto");
if (0, $53de29777cdbd7c8$export$a550975ce732ef83) $abb8e350d4fb0f9e$var$$slider.setAttribute("type", "vertical");
$abb8e350d4fb0f9e$var$$slider.setAttribute("value1", "0");
$abb8e350d4fb0f9e$var$$slider.setAttribute("generate-labels", "false");
$abb8e350d4fb0f9e$var$$slider.setAttribute("moving-tooltip", "true");
$abb8e350d4fb0f9e$var$$slider.setAttribute("moving-tooltip-width", "30");
$abb8e350d4fb0f9e$var$$slider.setAttribute("moving-tooltip-height", "36");
$abb8e350d4fb0f9e$var$$slider.setAttribute("moving-tooltip-bg", `transparent url(${(0, (/*@__PURE__*/$parcel$interopDefault($d67bbc77caa5bd25$exports)))}) no-repeat center/contain`);
$abb8e350d4fb0f9e$var$$slider.setAttribute("step", "1");
$abb8e350d4fb0f9e$var$$slider.setAttribute("round", "0");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-width", "50px");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-height", "50px");
$abb8e350d4fb0f9e$var$$slider.setAttribute("moving-tooltip-distance-to-pointer", "20");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-bg", "transparent");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-bg-focus", "transparent");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-bg-hover", "transparent");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-border", "none");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-border-hover", "none");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-border-focus", "none");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-shadow", "none");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-shadow-hover", "none");
$abb8e350d4fb0f9e$var$$slider.setAttribute("pointer-shadow-focus", "none");
$abb8e350d4fb0f9e$var$playerWrapper.append($abb8e350d4fb0f9e$var$$slider);
$abb8e350d4fb0f9e$var$$slider.addEventListener("change", (evt)=>{
    (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().forEach((canvas)=>{
        (0, $6e53177b5afd7211$export$9fb1869c8ff8ec6f)(canvas.id, evt.detail.value);
    });
});
// ── Export Modal Logic ────────────────────────────────────────────────────────
(function initExportModal() {
    // Speed definitions: ms per aligner frame
    const SPEED_MAP = {
        slow: 400,
        middle: 220,
        fast: 100
    };
    let selectedFormat = "gif";
    let selectedSpeed = "slow";
    let isExporting = false;
    // Open modal via export button in app bar
    const exportBtn = document.getElementById("export-btn");
    if (exportBtn) exportBtn.addEventListener("click", ()=>{
        (0, $adcf363a09f534a1$export$2e2bcd8739ae039).show("export-modal");
    });
    // Option group toggle (format)
    document.getElementById("export-format-group").addEventListener("click", (e)=>{
        const btn = e.target.closest(".export-option");
        if (!btn) return;
        document.querySelectorAll("#export-format-group .export-option").forEach((b)=>b.classList.remove("active"));
        btn.classList.add("active");
        selectedFormat = btn.dataset.value;
    });
    // Option group toggle (speed)
    document.getElementById("export-speed-group").addEventListener("click", (e)=>{
        const btn = e.target.closest(".export-option");
        if (!btn) return;
        document.querySelectorAll("#export-speed-group .export-option").forEach((b)=>b.classList.remove("active"));
        btn.classList.add("active");
        selectedSpeed = btn.dataset.value;
    });
    // Start export
    document.getElementById("export-start-btn").addEventListener("click", async ()=>{
        if (isExporting) return;
        await runExport(selectedFormat, selectedSpeed);
    });
    function setProgress(pct, label) {
        document.getElementById("export-progress-fill").style.width = pct + "%";
        document.getElementById("export-progress-label").textContent = label;
    }
    function setExportingUI(exporting) {
        isExporting = exporting;
        const progressArea = document.getElementById("export-progress-area");
        const startBtn = document.getElementById("export-start-btn");
        const cancelBtn = document.getElementById("export-cancel-btn");
        progressArea.style.display = exporting ? "block" : "none";
        startBtn.disabled = exporting;
        cancelBtn.disabled = exporting;
        if (!exporting) setProgress(0, "Preparing…");
    }
    // Composite IPR labels onto the export canvas.
    // Labels are HTML elements — canvas.toDataURL() can't see them, so we read
    // their actual DOM style and repaint them as canvas primitives, matching the
    // diamond shape, white fill, drop-shadow, and text exactly.
    function drawIPRLabelsOntoCanvasAt(ctx, threeRenderer, threeCamera, canvasId, dx, dy, dw, dh) {
        const lines = window.iprLines ? window.iprLines.get(canvasId) || [] : [];
        const src = threeRenderer.domElement;
        const cssW = src.clientWidth || src.width;
        const cssH = src.clientHeight || src.height;
        // Pixels-per-CSS-pixel in the destination region (so labels match on-screen size)
        const scaleX = dw / cssW;
        const scaleY = dh / cssH;
        const scale = (scaleX + scaleY) / 2;
        lines.forEach(({ label: label , endPoint: endPoint  })=>{
            if (!label || !endPoint || label.dataset.visible !== "true") return;
            // --- position: project 3D end-point into CSS-pixel space, then translate to dest ---
            const vec = endPoint.clone().project(threeCamera);
            const xCss = (vec.x * 0.5 + 0.5) * cssW;
            const yCss = (vec.y * -0.5 + 0.5) * cssH;
            const cx = dx + xCss * scaleX;
            const cy = dy + yCss * scaleY;
            // --- read text from the DOM (innermost span holds the value) ---
            const innerSpans = label.querySelectorAll("span");
            let text = "";
            innerSpans.forEach((s)=>{
                if (!text && s.textContent.trim()) text = s.textContent.trim();
            });
            if (!text) text = label.textContent.trim();
            if (!text) return;
            // --- size: read from computed style of the outer label ---
            const computedSize = parseFloat(getComputedStyle(label).width) || 26;
            const half = computedSize / 2 * scale;
            // --- shadow ---
            ctx.save();
            ctx.shadowColor = "rgba(0,0,0,0.22)";
            ctx.shadowBlur = 4 * scale;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 1 * scale;
            // --- diamond fill: read highlight state from the live DOM span ---
            const diamondEl = label.querySelector("span");
            const isHighlighted = diamondEl && (diamondEl.style.background || "").includes("gradient");
            ctx.translate(cx, cy);
            ctx.rotate(Math.PI / 4);
            if (isHighlighted) {
                // Match linear-gradient(135deg, #8CCEE6, #6FC3DF)
                // 135° in canvas space = top-left → bottom-right within the rotated square
                const grad = ctx.createLinearGradient(-half, -half, half, half);
                grad.addColorStop(0, "#8CCEE6");
                grad.addColorStop(1, "#6FC3DF");
                ctx.fillStyle = grad;
            } else ctx.fillStyle = "#ffffff";
            ctx.beginPath();
            ctx.rect(-half, -half, half * 2, half * 2);
            ctx.fill();
            ctx.restore();
            // --- text (drawn upright, centred on the same point) ---
            ctx.save();
            const fontSize = Math.round(computedSize * 0.38 * scale);
            ctx.font = `normal ${fontSize}px sans-serif`;
            ctx.fillStyle = "#000000";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(text, cx, cy);
            ctx.restore();
        });
    }
    // Composite every active canvas (main + diff-canvas + maxilandmand-canvas)
    // into a single output frame, laid out exactly as they appear on screen.
    function captureCompositeFrame() {
        const canvases = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll();
        const container = document.querySelector(".renderer-container");
        const containerRect = container.getBoundingClientRect();
        // Force a fresh render on every active canvas so preserveDrawingBuffer holds the latest frame
        canvases.forEach(({ renderer: renderer , scene: scene , camera: camera , overlayScene: overlayScene , overlayCamera: overlayCamera  })=>{
            renderer.render(scene, camera);
            renderer.autoClear = false;
            renderer.render(overlayScene, overlayCamera);
            renderer.autoClear = true;
        });
        // Pick output resolution from the main canvas's DPR
        const main = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).get("canvas") || canvases[0];
        const mainSrc = main.renderer.domElement;
        const mainRect = main.canvas.getBoundingClientRect();
        const dpr = mainSrc.width / (mainRect.width || mainSrc.width);
        const flat = document.createElement("canvas");
        flat.width = Math.max(1, Math.round(containerRect.width * dpr));
        flat.height = Math.max(1, Math.round(containerRect.height * dpr));
        const ctx = flat.getContext("2d");
        ctx.fillStyle = "#f0f2f5";
        ctx.fillRect(0, 0, flat.width, flat.height);
        canvases.forEach((c)=>{
            const src = c.renderer.domElement;
            const rect = c.canvas.getBoundingClientRect();
            const dx = Math.round((rect.left - containerRect.left) * dpr);
            const dy = Math.round((rect.top - containerRect.top) * dpr);
            const dw = Math.round(rect.width * dpr);
            const dh = Math.round(rect.height * dpr);
            if (dw <= 0 || dh <= 0) return;
            ctx.drawImage(src, 0, 0, src.width, src.height, dx, dy, dw, dh);
            drawIPRLabelsOntoCanvasAt(ctx, c.renderer, c.camera, c.id, dx, dy, dw, dh);
        });
        return flat.toDataURL("image/png");
    }
    async function captureFrames() {
        const canvases = (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll();
        if (!canvases.length || !canvases.every((c)=>c.camera && c.renderer && c.scene)) throw new Error("Canvas is not initialized yet. Please wait for the model to finish loading and try again.");
        // Use the authoritative model count rather than the slider attribute
        const maxAligner = (0, $6e53177b5afd7211$export$bf13a6ff02b268c3)("canvas");
        const frames = [];
        for(let i = 0; i <= maxAligner; i++){
            canvases.forEach((c)=>(0, $6e53177b5afd7211$export$9fb1869c8ff8ec6f)(c.id, i));
            // Update IPR line/label visibility on every active canvas so labels composite correctly
            canvases.forEach((c)=>(0, $34b3600950cd5660$export$127367bf4516af82)(c.id));
            // Wait two rAFs: one for model visibility to propagate, one for Three.js render loop
            await new Promise((r)=>requestAnimationFrame(r));
            await new Promise((r)=>requestAnimationFrame(r));
            frames.push(captureCompositeFrame());
            setProgress(Math.round(i / maxAligner * 65), `Capturing frame ${i + 1} / ${maxAligner + 1}…`);
        }
        return frames;
    }
    // ── GIF export (uses bundled gif.js) ─────────────────────────────────────
    async function exportGIF(frames, frameDelayMs) {
        const firstImg = await loadImage(frames[0]);
        const gif = new (0, (/*@__PURE__*/$parcel$interopDefault($b9918e92641a49b0$exports)))({
            workers: 2,
            quality: 10,
            width: firstImg.naturalWidth,
            height: firstImg.naturalHeight,
            workerScript: (0, (/*@__PURE__*/$parcel$interopDefault($5d4e089399650db3$exports)))
        });
        setProgress(65, "Building GIF frames…");
        for(let i = 0; i < frames.length; i++){
            const img = await loadImage(frames[i]);
            // Draw onto a canvas so gif.js gets pixel data (not just an img element)
            const fc = document.createElement("canvas");
            fc.width = img.naturalWidth;
            fc.height = img.naturalHeight;
            fc.getContext("2d").drawImage(img, 0, 0);
            gif.addFrame(fc, {
                delay: frameDelayMs,
                copy: true
            });
            setProgress(65 + Math.round(i / frames.length * 20), `Building GIF frame ${i + 1} / ${frames.length}…`);
        }
        return new Promise((resolve, reject)=>{
            gif.on("progress", (p)=>setProgress(85 + Math.round(p * 14), "Encoding GIF…"));
            gif.on("finished", (blob)=>resolve(blob));
            gif.on("error", reject);
            gif.render();
        });
    }
    // Helper: load an image, with onerror so a bad frame rejects rather than hangs forever.
    function loadImage(src) {
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = ()=>reject(new Error("Failed to load frame image"));
            img.src = src;
        });
    }
    // Pick the best MediaRecorder mimeType for this browser.
    // Returns { mimeType, container } where container is "mp4" if we can record
    // MP4 directly (Safari 14.1+) or "webm" if we need to transcode.
    function pickRecorderMime() {
        if (typeof MediaRecorder === "undefined") return null;
        const mp4Candidates = [
            "video/mp4;codecs=avc1.42E01E",
            "video/mp4;codecs=avc1",
            "video/mp4"
        ];
        for (const m of mp4Candidates){
            if (MediaRecorder.isTypeSupported(m)) return {
                mimeType: m,
                container: "mp4"
            };
        }
        const webmCandidates = [
            "video/webm;codecs=vp9",
            "video/webm;codecs=vp8",
            "video/webm"
        ];
        for (const m of webmCandidates){
            if (MediaRecorder.isTypeSupported(m)) return {
                mimeType: m,
                container: "webm"
            };
        }
        return null;
    }
    // ── MP4 export: frames → MediaRecorder. On browsers that record MP4 natively
    // (Safari 14.1+) we download the recording directly. Elsewhere we record WebM
    // and transcode to MP4 via ffmpeg.wasm. ────────────────────────────────────
    async function exportMP4(frames, frameDelayMs) {
        if (typeof MediaRecorder === "undefined") throw new Error("Video export is not supported in this browser. Please try GIF instead.");
        const firstImg = await loadImage(frames[0]);
        const offscreen = document.createElement("canvas");
        offscreen.width = firstImg.naturalWidth;
        offscreen.height = firstImg.naturalHeight;
        const ctx = offscreen.getContext("2d");
        if (typeof offscreen.captureStream !== "function") throw new Error("Video export is not supported in this browser (canvas.captureStream missing). Please try GIF instead.");
        const mime = pickRecorderMime();
        if (!mime) throw new Error("This browser does not support video recording. Please try GIF instead.");
        const stream = offscreen.captureStream();
        const recorder = new MediaRecorder(stream, {
            mimeType: mime.mimeType
        });
        const chunks = [];
        recorder.ondataavailable = (e)=>{
            if (e.data.size > 0) chunks.push(e.data);
        };
        // Attach onstop BEFORE calling stop() so we can't miss the event.
        const stopped = new Promise((resolve)=>{
            recorder.onstop = resolve;
        });
        recorder.start();
        for(let i = 0; i < frames.length; i++){
            const img = await loadImage(frames[i]);
            ctx.fillStyle = "#f0f2f5";
            ctx.fillRect(0, 0, offscreen.width, offscreen.height);
            ctx.drawImage(img, 0, 0);
            setProgress(65 + Math.round(i / frames.length * 15), `Recording frame ${i + 1} / ${frames.length}…`);
            await new Promise((r)=>setTimeout(r, frameDelayMs));
        }
        recorder.stop();
        await stopped;
        const recordedBlob = new Blob(chunks, {
            type: mime.mimeType
        });
        // If the recorder gave us MP4 directly, we're done — skip ffmpeg entirely.
        if (mime.container === "mp4") {
            setProgress(99, "Finalising…");
            return new Blob([
                await recordedBlob.arrayBuffer()
            ], {
                type: "video/mp4"
            });
        }
        // Otherwise transcode WebM → MP4 via our self-contained ffmpeg classic worker.
        setProgress(81, "Loading transcoder…");
        // Fetch the UMD core JS text and WASM binary — turned into blob URLs so
        // importScripts() inside the classic worker sees a same-origin URL.
        const [coreResp, wasmResp] = await Promise.all([
            fetch($abb8e350d4fb0f9e$var$ffmpegCoreUrl),
            fetch($abb8e350d4fb0f9e$var$ffmpegWasmUrl)
        ]);
        if (!coreResp.ok) throw new Error(`Failed to load ffmpeg core (HTTP ${coreResp.status})`);
        if (!wasmResp.ok) throw new Error(`Failed to load ffmpeg wasm (HTTP ${wasmResp.status})`);
        const [coreText, wasmBuf] = await Promise.all([
            coreResp.text(),
            wasmResp.arrayBuffer()
        ]);
        const coreBlobUrl = URL.createObjectURL(new Blob([
            coreText
        ], {
            type: "text/javascript"
        }));
        const worker = new Worker($abb8e350d4fb0f9e$var$ffmpegWorkerUrl);
        // Load core inside the worker
        await new Promise((resolve, reject)=>{
            worker.onmessage = (e)=>{
                if (e.data.type === "ready") resolve();
                else if (e.data.type === "error") reject(new Error(e.data.message));
            };
            worker.onerror = (e)=>reject(new Error(e.message || "ffmpeg worker error"));
            worker.postMessage({
                type: "load",
                payload: {
                    coreUrl: coreBlobUrl,
                    wasmBinary: new Uint8Array(wasmBuf)
                }
            });
        });
        setProgress(85, "Transcoding to MP4…");
        // Feed the WebM blob as a Uint8Array and get back MP4 bytes
        const webmBytes = new Uint8Array(await recordedBlob.arrayBuffer());
        const mp4Bytes = await new Promise((resolve, reject)=>{
            worker.onmessage = (e)=>{
                if (e.data.type === "done") resolve(e.data.output);
                else if (e.data.type === "error") reject(new Error(e.data.message));
            };
            worker.onerror = (e)=>reject(new Error(e.message || "ffmpeg worker error"));
            worker.postMessage({
                type: "exec",
                payload: {
                    args: [
                        "-i",
                        "input.webm",
                        "-c:v",
                        "libx264",
                        "-preset",
                        "fast",
                        "-crf",
                        "23",
                        "-movflags",
                        "+faststart",
                        "-y",
                        "output.mp4"
                    ],
                    inputName: "input.webm",
                    inputData: webmBytes
                }
            }, [
                webmBytes.buffer
            ]);
        });
        worker.terminate();
        URL.revokeObjectURL(coreBlobUrl);
        setProgress(99, "Finalising…");
        return new Blob([
            mp4Bytes.buffer
        ], {
            type: "video/mp4"
        });
    }
    // Build "{patientName}-{designNo}" for the export download. Falls back to UID
    // when patientName is missing. The #planNo element renders as "Design No: X"
    // so we strip the prefix. Sanitises filesystem-unsafe characters.
    function getExportBaseName() {
        const patientName = document.getElementById("patientName")?.textContent?.trim();
        const uid = document.body.dataset.customerId || document.getElementById("customerId")?.textContent?.trim() || "";
        const planNoText = document.getElementById("planNo")?.textContent?.trim() || "";
        const designNo = planNoText.replace(/^design\s*no\s*:?\s*/i, "").trim();
        const namePart = patientName || uid || "dental-animation";
        const base = designNo ? `${namePart}-${designNo}` : namePart;
        return base.replace(/[\\/:*?"<>|]+/g, "_");
    }
    function downloadBlob(blob, filename) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        setTimeout(()=>URL.revokeObjectURL(url), 5000);
    }
    async function runExport(format, speed) {
        const playerSlider = document.getElementById("player-slider");
        const frameDelayMs = SPEED_MAP[speed] || 340;
        const savedSliderValue = parseInt(playerSlider.value || "0", 10);
        setExportingUI(true);
        try {
            setProgress(0, "Capturing frames…");
            const frames = await captureFrames();
            setProgress(65, format === "gif" ? "Building GIF…" : "Encoding video…");
            let blob;
            if (format === "gif") blob = await exportGIF(frames, frameDelayMs);
            else blob = await exportMP4(frames, frameDelayMs);
            setProgress(100, "Done! Downloading…");
            const ext = format === "gif" ? "gif" : "mp4";
            downloadBlob(blob, `${getExportBaseName()}.${ext}`);
            // Restore slider to where user was
            (0, $c67591ac74c9ae8f$export$2e2bcd8739ae039).getAll().forEach((c)=>(0, $6e53177b5afd7211$export$9fb1869c8ff8ec6f)(c.id, savedSliderValue));
            playerSlider.value = savedSliderValue;
            await new Promise((r)=>setTimeout(r, 800));
            (0, $adcf363a09f534a1$export$2e2bcd8739ae039).close("export-modal");
        } catch (err) {
            console.error("Export failed:", err);
            setProgress(0, "Export failed. Please try again.");
            await new Promise((r)=>setTimeout(r, 2000));
        } finally{
            setExportingUI(false);
        }
    }
})();


//# sourceMappingURL=revamped-view.d6e655d6.js.map
